import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  UUID: any;
  Void: any;
};

export type AcademicSession = {
  __typename?: 'AcademicSession';
  active: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateTermEnd: Scalars['DateTime'];
  dateTermStart: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  default: Scalars['Boolean'];
  externalId?: Maybe<ExternalId>;
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  sisId?: Maybe<Scalars['String']>;
  sourceKind?: Maybe<Scalars['String']>;
  sourceKindId?: Maybe<Scalars['Int']>;
  status: AcademicSessionStatus;
};

export type AcademicSessionCreateInput = {
  dateTermEnd: Scalars['DateTime'];
  dateTermStart: Scalars['DateTime'];
  externalId?: InputMaybe<ExternalIdInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  sisId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<SourceKind>;
};

export enum AcademicSessionOrderField {
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID'
}

export enum AcademicSessionStatus {
  CURRENT = 'CURRENT',
  FUTURE = 'FUTURE',
  PREVIOUS = 'PREVIOUS'
}

export type AcademicSessionUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  dateTermEnd?: InputMaybe<Scalars['DateTime']>;
  dateTermStart?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<SourceKind>;
  sourceKindId?: InputMaybe<Scalars['Int']>;
};

export type AcademicSessionWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AcademicSessionsDateRangeInput = {
  dateEnd: Scalars['DateTime'];
  dateStart: Scalars['DateTime'];
};

export type AcademicSessionsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<AcademicSessionOrderField>;
};

export type AcademicSessionsUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  dateTermEnd?: InputMaybe<Scalars['DateTime']>;
  dateTermStart?: InputMaybe<Scalars['DateTime']>;
};

export type AcademicSessionsWhereInput = {
  AND?: InputMaybe<Array<AcademicSessionsWhereInput>>;
  OR?: InputMaybe<Array<AcademicSessionsWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  dateTermRange?: InputMaybe<AcademicSessionsDateRangeInput>;
  default?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<AcademicSessionStatus>;
};

export type App = {
  __typename?: 'App';
  accessDetails?: Maybe<AppAccessDetails>;
  appProducts: Array<AppProduct>;
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  pliManaged: Scalars['Boolean'];
  products: Array<Product>;
  purchaseDetails?: Maybe<AppPurchaseDetails>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ProductType>;
};

export type AppAccessDetails = {
  __typename?: 'AppAccessDetails';
  bannerUrl: Scalars['String'];
  iosUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AppProduct = {
  __typename?: 'AppProduct';
  accessDetails?: Maybe<AppAccessDetails>;
  app?: Maybe<App>;
  appId: Scalars['Int'];
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  pliManaged: Scalars['Boolean'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  purchaseDetails?: Maybe<AppPurchaseDetails>;
  title?: Maybe<Scalars['String']>;
};

export type AppPurchaseDetails = {
  __typename?: 'AppPurchaseDetails';
  description?: Maybe<Scalars['String']>;
  salesQuoteUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  webstoreUrl?: Maybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  captions?: Maybe<Scalars['JSON']>;
  changes?: Maybe<Array<AssetChange>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  description: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  locale: Locale;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  src?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<AssetTag>>;
  title: Scalars['String'];
  translations?: Maybe<Array<AssetTranslation>>;
  type: AssetType;
  user?: Maybe<User>;
  userId: Scalars['Int'];
  vtt?: Maybe<Scalars['String']>;
  vttFilename?: Maybe<Scalars['String']>;
};

export type AssetChange = {
  __typename?: 'AssetChange';
  action?: Maybe<AssetChangeAction>;
  asset?: Maybe<Asset>;
  assetId: Scalars['Int'];
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  fromData?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  toData?: Maybe<Scalars['JSON']>;
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export enum AssetChangeAction {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  REMOVED = 'REMOVED',
  RESTORED = 'RESTORED',
  SAVED = 'SAVED'
}

export type AssetChangeInput = {
  action?: InputMaybe<AssetChangeAction>;
  assetId?: InputMaybe<Scalars['Int']>;
  dateCreated?: InputMaybe<Scalars['String']>;
  dateRemoved?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Scalars['String']>;
  fromData?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  toData?: InputMaybe<Scalars['JSON']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AssetChangesWhereInput = {
  action?: InputMaybe<AssetChangeAction>;
  assetId?: InputMaybe<Array<Scalars['Int']>>;
};

export type AssetCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  locale: Locale;
  size: Scalars['Int'];
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  title: Scalars['String'];
  translations?: InputMaybe<Array<AssetTranslationInput>>;
  type: AssetType;
  vtt?: InputMaybe<Scalars['String']>;
};

export type AssetMetadata = {
  __typename?: 'AssetMetadata';
  cacheControl?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
};

export type AssetMetadataUpdateInput = {
  cacheControl?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
};

export enum AssetOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
  DESCRIPTION = 'DESCRIPTION',
  FILENAME = 'FILENAME',
  ID = 'ID',
  TITLE = 'TITLE',
  TYPE = 'TYPE'
}

export type AssetResponse = {
  __typename?: 'AssetResponse';
  status: CmsResponseType;
};

export type AssetTag = {
  __typename?: 'AssetTag';
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  tag: Scalars['String'];
  value: Scalars['String'];
};

export type AssetTagCreateInput = {
  tag: Scalars['String'];
  value: Scalars['String'];
};

export enum AssetTagOrderField {
  ID = 'ID',
  TAG = 'TAG',
  VALUE = 'VALUE'
}

export type AssetTagUpdateInput = {
  tag?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AssetTagWhereInput = {
  id: Scalars['Int'];
};

export type AssetTagsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<AssetTagOrderField>;
};

export type AssetTagsWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AssetTranslation = {
  __typename?: 'AssetTranslation';
  description?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  locale: Locale;
  narrationSrc?: Maybe<Scalars['String']>;
  narrationVtt?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vttFilename?: Maybe<Scalars['String']>;
};

export type AssetTranslationInput = {
  description?: InputMaybe<Scalars['String']>;
  locale: Locale;
  title?: InputMaybe<Scalars['String']>;
};

export enum AssetType {
  ARCHIVE = 'ARCHIVE',
  AUDIO = 'AUDIO',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  SVG = 'SVG',
  VIDEO = 'VIDEO'
}

export type AssetUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Locale>;
  size?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<AssetTranslationInput>>;
  type?: InputMaybe<AssetType>;
  vtt?: InputMaybe<Scalars['String']>;
};

export type AssetVersion = {
  __typename?: 'AssetVersion';
  key: Scalars['String'];
  lastModified: Scalars['DateTime'];
  versionId: Scalars['String'];
};

export type AssetVersionUpdateInput = {
  currentKey: Scalars['String'];
  revertKey: Scalars['String'];
};

export type AssetVtt = {
  __typename?: 'AssetVtt';
  vtt: Scalars['String'];
  wordCountMatched: Scalars['Boolean'];
  wordsBelowThreshold: Array<Scalars['String']>;
};

export type AssetVttCreateInput = {
  category: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type AssetWhereInput = {
  id: Scalars['Int'];
};

export type AssetsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<AssetOrderField>;
};

export type AssetsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  locale?: InputMaybe<Array<Locale>>;
  onlyDeleted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<Array<AssetType>>;
};

export type AssignAvailableLicenseInput = {
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  replaceExistingProductFamilyLicense?: InputMaybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: InputMaybe<Scalars['Boolean']>;
  skipManualAssignment?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type AssignAvailableLicenseWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
};

export enum AssigneeType {
  STUDENT = 'STUDENT',
  USER = 'USER'
}

export type AsyncReportResult = {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type AzsappClassroomSettings = {
  __typename?: 'AzsappClassroomSettings';
  accessBookAfterAssignment?: Maybe<AzsappExposeLetterBooksSettingData>;
};

export type AzsappExposeLetterBooksSettingData = {
  __typename?: 'AzsappExposeLetterBooksSettingData';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type BaseClassroomSettingResponse = {
  __typename?: 'BaseClassroomSettingResponse';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type BaseSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type BaseSettingData = {
  __typename?: 'BaseSettingData';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type BaseStudentSettingResponse = {
  __typename?: 'BaseStudentSettingResponse';
  app: App;
  appId: Scalars['Int'];
  setting: Scalars['String'];
  student: Student;
  studentId: Scalars['Int'];
  value: Scalars['JSON'];
};

export type BatchMutationResult = {
  __typename?: 'BatchMutationResult';
  count?: Maybe<Scalars['Int']>;
};

export type BulkAssignAvailableLicenseInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
  replaceExistingProductFamilyLicense?: InputMaybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: InputMaybe<Scalars['Boolean']>;
  skipManualAssignment?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type BulkAssignAvailableWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type BulkAssignResult = {
  __typename?: 'BulkAssignResult';
  error?: Maybe<Scalars['String']>;
  license?: Maybe<License>;
  request: LicenseAssignRequest;
};

export type BulkGroupEnrollmentActionGroupCategoryRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupCategoryRequest';
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionGroupRequest = {
  __typename?: 'BulkGroupEnrollmentActionGroupRequest';
  classroomId: Scalars['Int'];
  groupCategory?: Maybe<BulkGroupEnrollmentActionGroupCategoryRequest>;
  name: Scalars['String'];
};

export type BulkGroupEnrollmentActionInput = {
  action: GroupEnrollmentAction;
  group?: InputMaybe<GroupEnrollmentGroupInput>;
  groupId?: InputMaybe<Scalars['Int']>;
  studentId: Scalars['Int'];
};

export type BulkGroupEnrollmentActionRequest = {
  __typename?: 'BulkGroupEnrollmentActionRequest';
  group?: Maybe<BulkGroupEnrollmentActionGroupRequest>;
  groupId?: Maybe<Scalars['Int']>;
  studentId: Scalars['Int'];
};

export type BulkGroupEnrollmentActionResult = {
  __typename?: 'BulkGroupEnrollmentActionResult';
  error?: Maybe<Scalars['String']>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  request: BulkGroupEnrollmentActionRequest;
};

export type BulkImportFileUploadInput = {
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  filename: Scalars['String'];
  organizationName: Scalars['String'];
  size: Scalars['Int'];
  token: Scalars['String'];
};

export type BulkImportFileUploadResult = {
  __typename?: 'BulkImportFileUploadResult';
  fields?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
};

export type BulkLicenseActionInput = {
  action: LicenseAction;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
  replaceExistingProductFamilyLicense?: InputMaybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: InputMaybe<Scalars['Boolean']>;
  skipManualAssignment?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type BulkLicenseActionResult = {
  __typename?: 'BulkLicenseActionResult';
  error?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<License>>;
  request: LicenseActionRequest;
};

export type BulkLicenseActionWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type Classroom = {
  __typename?: 'Classroom';
  academicSession?: Maybe<AcademicSession>;
  academicSessionId?: Maybe<Scalars['Int']>;
  color: Scalars['String'];
  dateArchived?: Maybe<Scalars['DateTime']>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  externalId?: Maybe<ExternalId>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int'];
  licenseUsage?: Maybe<Array<ClassroomLicenseUsage>>;
  loginType: StudentLoginType;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  settings?: Maybe<Array<ClassroomSetting>>;
  sisId?: Maybe<Scalars['String']>;
  stats: ClassroomStats;
  status?: Maybe<ClassroomStatus>;
  studentCount: Scalars['Int'];
  students?: Maybe<Array<Student>>;
  users?: Maybe<Array<UserClassroomEnrollment>>;
};


export type ClassroomGroupsArgs = {
  orderBy?: InputMaybe<GroupsOrderInput>;
  where?: InputMaybe<GroupsWhereInput>;
};


export type ClassroomLicenseUsageArgs = {
  where?: InputMaybe<LicenseUsageWhereInput>;
};


export type ClassroomSettingsArgs = {
  orderBy?: InputMaybe<ClassroomSettingsOrderInput>;
  where?: InputMaybe<ClassroomSettingsWhereInput>;
};


export type ClassroomUsersArgs = {
  where?: InputMaybe<UsersWhereInput>;
};

export type ClassroomCreateInput = {
  academicSessionId?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  dateArchived?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdInput>;
  loginType?: InputMaybe<StudentLoginType>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  settings?: InputMaybe<Array<BaseSettingCreateInput>>;
  sisId?: InputMaybe<Scalars['String']>;
  studentEnrollments?: InputMaybe<Array<Scalars['Int']>>;
  students?: InputMaybe<Array<StudentCreateInput>>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};

export type ClassroomLicenseUsage = {
  __typename?: 'ClassroomLicenseUsage';
  assignedCount: Scalars['Int'];
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
};

export enum ClassroomOrderField {
  DATE_ARCHIVED = 'DATE_ARCHIVED',
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID'
}

export type ClassroomPrivilege = {
  __typename?: 'ClassroomPrivilege';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum ClassroomPrivilegeOrderField {
  DISPLAY_NAME = 'DISPLAY_NAME',
  ID = 'ID',
  NAME = 'NAME'
}

export type ClassroomPrivilegeWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ClassroomPrivilegesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomPrivilegeOrderField>;
};

export type ClassroomPrivilegesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type ClassroomRole = {
  __typename?: 'ClassroomRole';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  classification: ClassroomRoleClassification;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  privileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
};

export enum ClassroomRoleClassification {
  COEDUCATOR = 'COEDUCATOR',
  EDUCATOR = 'EDUCATOR'
}

export enum ClassroomRoleOrderField {
  APP = 'APP',
  DISPLAY_NAME = 'DISPLAY_NAME',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION = 'ORGANIZATION'
}

export type ClassroomRoleWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ClassroomRolesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomRoleOrderField>;
};

export type ClassroomRolesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type ClassroomSetting = {
  __typename?: 'ClassroomSetting';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export type ClassroomSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum ClassroomSettingOrderField {
  APP_ID = 'APP_ID',
  CLASSROOM_ID = 'CLASSROOM_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING'
}

export type ClassroomSettingUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type ClassroomSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  classroomId: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
};

export type ClassroomSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomSettingOrderField>;
};

export type ClassroomSettingsUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type ClassroomSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
};

export type ClassroomStats = {
  __typename?: 'ClassroomStats';
  studentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum ClassroomStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  REMOVED = 'REMOVED'
}

export type ClassroomUpdateInput = {
  academicSessionId?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  dateArchived?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  loginType?: InputMaybe<StudentLoginType>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};

export type ClassroomWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ClassroomsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ClassroomOrderField>;
};

export type ClassroomsUpdateInput = {
  academicSessionId?: InputMaybe<Scalars['Int']>;
  dateArchived?: InputMaybe<Scalars['DateTime']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type ClassroomsWhereInput = {
  AND?: InputMaybe<Array<ClassroomsWhereInput>>;
  OR?: InputMaybe<Array<ClassroomsWhereInput>>;
  academicSessionId?: InputMaybe<Array<Scalars['Int']>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  coEducator?: InputMaybe<UsersWhereInput>;
  educator?: InputMaybe<UsersWhereInput>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationsWhereInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<Array<ClassroomStatus>>;
};

export enum ClientDevice {
  CHROMEBOOK = 'CHROMEBOOK',
  DESKTOP = 'DESKTOP',
  IPAD = 'IPAD'
}

export enum CmsResponseType {
  SUCCESS = 'SUCCESS'
}

export type Contact = {
  __typename?: 'Contact';
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  email: Scalars['String'];
  externalId?: Maybe<ExternalId>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sisId?: Maybe<Scalars['String']>;
  students?: Maybe<Array<Student>>;
};

export type ContactInput = {
  email: Scalars['String'];
  externalId?: InputMaybe<ExternalIdInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum ContactOrderField {
  ID = 'ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID'
}

export type ContactStudentRemoveInput = {
  contactId: Scalars['Int'];
  studentId?: InputMaybe<Array<Scalars['Int']>>;
};

export type ContactUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
};

export type ContactWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ContactsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ContactOrderField>;
};

export type ContactsWhereInput = {
  AND?: InputMaybe<Array<ContactsWhereInput>>;
  OR?: InputMaybe<Array<ContactsWhereInput>>;
  email?: InputMaybe<Array<Scalars['String']>>;
  email_contains?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Array<Scalars['String']>>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  lastName?: InputMaybe<Array<Scalars['String']>>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
};

export type Course = {
  __typename?: 'Course';
  changes?: Maybe<Array<AssetChange>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  description: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['Int'];
  locale: Locale;
  size: Scalars['Int'];
  src?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<AssetTag>>;
  title: Scalars['String'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type CourseCreateInput = {
  description: Scalars['String'];
  locale: Locale;
  signedUrl: Scalars['String'];
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  title: Scalars['String'];
  translations?: InputMaybe<Array<AssetTranslationInput>>;
};

export enum CourseOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
  DESCRIPTION = 'DESCRIPTION',
  FILENAME = 'FILENAME',
  ID = 'ID',
  TITLE = 'TITLE'
}

export type CourseUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Locale>;
  signedUrl?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<AssetTranslationInput>>;
};

export type CourseWhereInput = {
  id: Scalars['Int'];
};

export type CoursesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<CourseOrderField>;
};

export type CoursesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  locale?: InputMaybe<Array<Locale>>;
  search?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateEntityLicenseAssignInput = {
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type DateRangeInput = {
  dateEnd: Scalars['DateTime'];
  dateStart: Scalars['DateTime'];
};

export type DefaultGroupSetting = {
  __typename?: 'DefaultGroupSetting';
  gradeLevels: Array<Scalars['String']>;
  group: GroupCreate;
  productCodes: Array<Scalars['String']>;
};

export type Enrollment = {
  __typename?: 'Enrollment';
  classroom: Classroom;
  classroomRole?: Maybe<ClassroomRole>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  removedDate?: Maybe<Scalars['DateTime']>;
  student?: Maybe<Student>;
  user?: Maybe<User>;
};

export enum EnrollmentOrderField {
  CLASSROOM_ROLE = 'CLASSROOM_ROLE',
  CLASSROOM_ROLE_ID = 'CLASSROOM_ROLE_ID',
  STUDENT_ID = 'STUDENT_ID',
  USER_ID = 'USER_ID'
}

export type EnrollmentWhereInput = {
  id: Scalars['Int'];
};

export type EnrollmentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<EnrollmentOrderField>;
};

export type EnrollmentsWhereInput = {
  classroomId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  classroomRole?: InputMaybe<Array<InputMaybe<UserRole>>>;
  classroomRoleId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  studentId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ExposeLetterBooksDataInput = {
  enabled: Scalars['Boolean'];
};

export type ExternalId = {
  __typename?: 'ExternalId';
  sourceId: Scalars['String'];
  sourceKind: SourceKind;
  sourceKindId: Scalars['Int'];
};

export type ExternalIdInput = {
  sourceId: Scalars['String'];
  sourceKind: SourceKind;
};

export type ExternalIdUpdateInput = {
  sourceId?: InputMaybe<Scalars['String']>;
  sourceKind?: InputMaybe<SourceKind>;
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  app: App;
  appId: Scalars['Int'];
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FeatureToggleInput = {
  appId: Scalars['Int'];
  data?: InputMaybe<Scalars['JSON']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum FeatureToggleOrderField {
  APP_ID = 'APP_ID',
  DATE_CREATED = 'DATE_CREATED',
  ENABLED = 'ENABLED',
  ID = 'ID',
  NAME = 'NAME'
}

export type FeatureToggleUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  data?: InputMaybe<Scalars['JSON']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FeatureToggleWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type FeatureTogglesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<FeatureToggleOrderField>;
};

export type FeatureTogglesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export enum FileType {
  AUDIO = 'AUDIO',
  IMG = 'IMG',
  PDF = 'PDF',
  VIDEO = 'VIDEO'
}

export type FileUploadData = {
  __typename?: 'FileUploadData';
  asset: Asset;
  fileUploadUrl: Scalars['String'];
  id: Scalars['Int'];
};

export type FindAvailableLicenseWhereInput = {
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  ignoreLicenseOverage?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductIdentifierInput>;
  productFamily?: InputMaybe<ProductIdentifierInput>;
};

export enum Grade {
  EIGHTH = 'EIGHTH',
  FIFTH = 'FIFTH',
  FIRST = 'FIRST',
  FOURTH = 'FOURTH',
  K = 'K',
  PK = 'PK',
  SECOND = 'SECOND',
  SEVENTH = 'SEVENTH',
  SIXTH = 'SIXTH',
  THIRD = 'THIRD',
  TK = 'TK'
}

export type Group = {
  __typename?: 'Group';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  groupCategory: GroupCategory;
  groupCategoryId: Scalars['Int'];
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupCategoriesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<GroupCategoryOrderField>;
};

export type GroupCategoriesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type GroupCategory = {
  __typename?: 'GroupCategory';
  app: App;
  appId: Scalars['Int'];
  classroom: Classroom;
  classroomId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  groups: Array<Maybe<Group>>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupCategoryCreate = {
  __typename?: 'GroupCategoryCreate';
  appId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCategoryCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export enum GroupCategoryOrderField {
  CLASSROOM_ID = 'CLASSROOM_ID',
  ID = 'ID',
  NAME = 'NAME'
}

export type GroupCategoryUpsertInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCategoryWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupCreate = {
  __typename?: 'GroupCreate';
  appId: Scalars['Int'];
  groupCategory?: Maybe<GroupCategoryCreate>;
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupCreateInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory: GroupCategoryCreateInput;
  name: Scalars['String'];
};

export type GroupEnrollment = {
  __typename?: 'GroupEnrollment';
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  group?: Maybe<Group>;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export enum GroupEnrollmentAction {
  ENROLL = 'ENROLL',
  UNENROLL = 'UNENROLL'
}

export type GroupEnrollmentGroupCategoryInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupEnrollmentGroupInput = {
  appId: Scalars['Int'];
  classroomId: Scalars['Int'];
  groupCategory?: InputMaybe<GroupEnrollmentGroupCategoryInput>;
  name: Scalars['String'];
};

export enum GroupEnrollmentOrderField {
  GROUP_ID = 'GROUP_ID',
  ID = 'ID',
  STUDENT_ID = 'STUDENT_ID'
}

export type GroupEnrollmentWhereInput = {
  groupId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

export type GroupEnrollmentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<GroupEnrollmentOrderField>;
};

export type GroupEnrollmentsWhereInput = {
  groupId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  studentId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum GroupOrderField {
  CLASSROOM_ID = 'CLASSROOM_ID',
  GROUP_CATEGORY_ID = 'GROUP_CATEGORY_ID',
  ID = 'ID',
  NAME = 'NAME'
}

export type GroupUnenrollmentInput = {
  groupId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type GroupUpdateInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type GroupUpsertInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  groupCategory?: InputMaybe<GroupCategoryUpsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GroupWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  classroomId?: InputMaybe<Scalars['Int']>;
  groupCategoryId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<GroupOrderField>;
};

export type GroupsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  groupCategoryId?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export enum GssCharacterOrder {
  freePlay = 'freePlay',
  gss = 'gss',
  natural = 'natural'
}

export type GssClassroomSettings = {
  __typename?: 'GssClassroomSettings';
  characterOrder?: Maybe<GssSettingCharacterOrderData>;
  handedness?: Maybe<GssSettingLeftHandednessData>;
  locale?: Maybe<Locale>;
};

export enum GssSetting {
  LETTER_AND_NUMBER_ORDER = 'LETTER_AND_NUMBER_ORDER',
  LOCALE = 'LOCALE'
}

export type GssSettingCharacterOrderData = {
  __typename?: 'GssSettingCharacterOrderData';
  letters?: Maybe<GssCharacterOrder>;
  numbers?: Maybe<GssCharacterOrder>;
  wdtCapitals?: Maybe<GssCharacterOrder>;
  wdtLowercase?: Maybe<GssCharacterOrder>;
  wdtNumbers?: Maybe<GssCharacterOrder>;
};

export type GssSettingCharacterOrderDataInput = {
  letters?: InputMaybe<GssCharacterOrder>;
  numbers?: InputMaybe<GssCharacterOrder>;
  wdtCapitals?: InputMaybe<GssCharacterOrder>;
  wdtLowercase?: InputMaybe<GssCharacterOrder>;
  wdtNumbers?: InputMaybe<GssCharacterOrder>;
};

export type GssSettingLeftHandednessData = {
  __typename?: 'GssSettingLeftHandednessData';
  leftHanded: Scalars['Boolean'];
  rtlCrossStroke?: Maybe<Scalars['Boolean']>;
};

export type GssSettingLeftHandednessDataInput = {
  leftHanded: Scalars['Boolean'];
  rtlCrossStroke?: InputMaybe<Scalars['Boolean']>;
};

export type GssStudentSettings = {
  __typename?: 'GssStudentSettings';
  characterOrder?: Maybe<GssSettingCharacterOrderData>;
  handedness?: Maybe<GssSettingLeftHandednessData>;
  locale?: Maybe<Locale>;
};

export type HomeUseClassroomDataInput = {
  contactEmail?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  productCurriculumCode: Scalars['String'];
  studentId: Scalars['Int'];
};

export type HomeUseStudentDataInput = {
  contactEmail?: InputMaybe<Scalars['String']>;
  productCurriculumCode: Scalars['String'];
};

export type HwtClassroomSettings = {
  __typename?: 'HwtClassroomSettings';
  locale?: Maybe<Locale>;
};

export enum HwtSetting {
  LOCALE = 'LOCALE'
}

export type HwtStudentSettings = {
  __typename?: 'HwtStudentSettings';
  locale?: Maybe<Locale>;
};

export type InviteRecipient = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type InviteSender = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type KeyActiveStudentsReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyActiveStudentsReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<KeyActiveStudentsReportResult>;
};

export type KeyActiveStudentsReportResult = {
  __typename?: 'KeyActiveStudentsReportResult';
  activeStudentCount: Scalars['Int'];
  totalStudentCount: Scalars['Int'];
};

export type KeyActivitiesCompletedAndTimeSpentIntervalData = {
  __typename?: 'KeyActivitiesCompletedAndTimeSpentIntervalData';
  activitiesCompletedCount: Scalars['Int'];
  averageMinutesSpent: Scalars['Float'];
  interval: Scalars['DateTime'];
};

export type KeyActivitiesCompletedAndTimeSpentReportResult = {
  __typename?: 'KeyActivitiesCompletedAndTimeSpentReportResult';
  averageWeeklyMinutesSpent: Scalars['Float'];
  intervalUnit: ReportIntervalUnit;
  intervals: Array<KeyActivitiesCompletedAndTimeSpentIntervalData>;
  totalActivitiesCompletedCount: Scalars['Int'];
};

export type KeyActivitiesCompletedAndTimeSpentReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

export type KeyActivitiesCompletedReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyActivitiesCompletedReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<KeyActivitiesCompletedReportResult>;
};

export type KeyActivitiesCompletedReportResult = {
  __typename?: 'KeyActivitiesCompletedReportResult';
  curriculumActivitiesCompleted?: Maybe<Array<ProductCurriculumActivitiesCompleted>>;
  totalActivitiesCompletedCount: Scalars['Int'];
};

export type KeyAssessmentAcceleratorActivityTypeModuleResult = {
  __typename?: 'KeyAssessmentAcceleratorActivityTypeModuleResult';
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  moduleIds: Array<Scalars['Int']>;
  modules?: Maybe<Array<KeyboardingModule>>;
};

export type KeyAssessmentAcceleratorActivityTypeResult = {
  __typename?: 'KeyAssessmentAcceleratorActivityTypeResult';
  activityType?: Maybe<KeyboardingActivityType>;
  activityTypeId: Scalars['Int'];
  modules: Array<KeyAssessmentAcceleratorActivityTypeModuleResult>;
};

export enum KeyAssessmentAcceleratorModuleAssignmentStatus {
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_ASSIGNED = 'NOT_ASSIGNED'
}

export type KeyAssessmentAcceleratorScheduledDate = {
  __typename?: 'KeyAssessmentAcceleratorScheduledDate';
  date: Scalars['DateTime'];
  moduleIds: Array<Scalars['Int']>;
};

export type KeyAssessmentAcceleratorScheduledDateInput = {
  date: Scalars['DateTime'];
  moduleIds: Array<Scalars['Int']>;
};

export type KeyAssessmentAcceleratorSettings = {
  __typename?: 'KeyAssessmentAcceleratorSettings';
  activityTypeId: Scalars['String'];
  scheduledDates?: Maybe<Array<KeyAssessmentAcceleratorScheduledDate>>;
};

export type KeyAssessmentAndEnrichmentActivityAcceleratorModuleStats = {
  __typename?: 'KeyAssessmentAndEnrichmentActivityAcceleratorModuleStats';
  assignmentStatus?: Maybe<KeyAssessmentAcceleratorModuleAssignmentStatus>;
  moduleIds: Array<Scalars['Int']>;
  modules?: Maybe<Array<KeyboardingModule>>;
  totalFirstAttemptCount?: Maybe<Scalars['Int']>;
  totalSecondsSpent?: Maybe<Scalars['Int']>;
};

export type KeyAssessmentAndEnrichmentActivityCompletionStats = {
  __typename?: 'KeyAssessmentAndEnrichmentActivityCompletionStats';
  studentCompletedCount?: Maybe<Scalars['Int']>;
  totalCompletedCount: Scalars['Int'];
};

export type KeyAssessmentAndEnrichmentActivityReportResult = {
  __typename?: 'KeyAssessmentAndEnrichmentActivityReportResult';
  assessmentAccelerator: Array<KeyAssessmentAndEnrichmentActivityAcceleratorModuleStats>;
  enrichmentActivities: KeyAssessmentEnrichmentActivityEnrichmentActivityStats;
  spotChecks: KeyAssessmentAndEnrichmentSpeedAccuracyStats;
  teacherCreatedActivities?: Maybe<KeyAssessmentAndEnrichmentSpeedAccuracyStats>;
};

export type KeyAssessmentAndEnrichmentActivityReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

export type KeyAssessmentAndEnrichmentSpeedAccuracyStats = {
  __typename?: 'KeyAssessmentAndEnrichmentSpeedAccuracyStats';
  averageAccuracy: Scalars['Float'];
  averageWpm: Scalars['Float'];
  studentCompletedCount?: Maybe<Scalars['Int']>;
  totalCompletedCount: Scalars['Int'];
};

export type KeyAssessmentEnrichmentActivityEnrichmentActivityStats = {
  __typename?: 'KeyAssessmentEnrichmentActivityEnrichmentActivityStats';
  hearItTypeIt?: Maybe<KeyAssessmentAndEnrichmentActivityCompletionStats>;
  myChoiceKeyboarding?: Maybe<KeyAssessmentAndEnrichmentActivityCompletionStats>;
};

export type KeyAverageWeeklyTimeSpentReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyAverageWeeklyTimeSpentReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<KeyAverageWeeklyTimeSpentReportResult>;
};

export type KeyAverageWeeklyTimeSpentReportResult = {
  __typename?: 'KeyAverageWeeklyTimeSpentReportResult';
  averageWeeklyMinutesSpent: Scalars['Float'];
  curriculumAverageWeeklyTimeSpent?: Maybe<Array<ProductCurriculumAverageWeeklyTimeSpent>>;
};

export type KeyClassroomEngagementAssessmentAcceleratorModuleActivityTypeStats = {
  __typename?: 'KeyClassroomEngagementAssessmentAcceleratorModuleActivityTypeStats';
  activityType?: Maybe<KeyboardingActivityType>;
  activityTypeId: Scalars['Int'];
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  moduleIds: Array<Scalars['Int']>;
  modules?: Maybe<Array<KeyboardingModule>>;
  totalCompletedCount?: Maybe<Scalars['Int']>;
  totalFirstAttemptCount?: Maybe<Scalars['Int']>;
};

export type KeyClassroomEngagementAssessmentAcceleratorModuleStats = {
  __typename?: 'KeyClassroomEngagementAssessmentAcceleratorModuleStats';
  activityTypes?: Maybe<Array<KeyClassroomEngagementAssessmentAcceleratorModuleActivityTypeStats>>;
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageFirstAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  moduleIds: Array<Scalars['Int']>;
  modules?: Maybe<Array<KeyboardingModule>>;
};

export type KeyClassroomEngagementAssessmentAcceleratorResult = {
  __typename?: 'KeyClassroomEngagementAssessmentAcceleratorResult';
  activityTypes?: Maybe<Array<KeyAssessmentAcceleratorActivityTypeResult>>;
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageFirstAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  modules?: Maybe<Array<KeyClassroomEngagementAssessmentAcceleratorModuleStats>>;
};

export type KeyClassroomEngagementAssessmentAcceleratorStudentModuleStats = {
  __typename?: 'KeyClassroomEngagementAssessmentAcceleratorStudentModuleStats';
  assignmentStatus?: Maybe<KeyAssessmentAcceleratorModuleAssignmentStatus>;
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  moduleIds: Array<Scalars['Int']>;
  modules?: Maybe<Array<KeyboardingModule>>;
  totalCompletedCount?: Maybe<Scalars['Int']>;
  totalFirstAttemptCount?: Maybe<Scalars['Int']>;
  totalSecondsSpent?: Maybe<Scalars['Int']>;
};

export type KeyClassroomEngagementAssessmentAcceleratorStudentStats = {
  __typename?: 'KeyClassroomEngagementAssessmentAcceleratorStudentStats';
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  moduleAverageSecondsSpent?: Maybe<Scalars['Float']>;
  modules: Array<KeyClassroomEngagementAssessmentAcceleratorStudentModuleStats>;
  totalCompletedCount?: Maybe<Scalars['Int']>;
  totalFirstAttemptCount?: Maybe<Scalars['Int']>;
  totalSecondsSpent?: Maybe<Scalars['Int']>;
};

export type KeyClassroomEngagementEnrichmentActivityStats = {
  __typename?: 'KeyClassroomEngagementEnrichmentActivityStats';
  hearItTypeItCompletedCount: Scalars['Int'];
  myChoiceKeyboardingCompletedCount: Scalars['Int'];
};

export type KeyClassroomEngagementReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyClassroomEngagementReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<KeyClassroomEngagementReportResult>;
};

export type KeyClassroomEngagementReportResult = {
  __typename?: 'KeyClassroomEngagementReportResult';
  assessmentAccelerator?: Maybe<KeyClassroomEngagementAssessmentAcceleratorResult>;
  students: Array<KeyClassroomEngagementStudentResult>;
};

export type KeyClassroomEngagementReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type KeyClassroomEngagementScheduledActivities = {
  __typename?: 'KeyClassroomEngagementScheduledActivities';
  accuracy?: Maybe<Scalars['Int']>;
  dateCompleted: Scalars['DateTime'];
  wpm?: Maybe<Scalars['Int']>;
};

export type KeyClassroomEngagementScheduledActivityStats = {
  __typename?: 'KeyClassroomEngagementScheduledActivityStats';
  activities?: Maybe<Array<KeyClassroomEngagementScheduledActivities>>;
  assessmentAverageAccuracy?: Maybe<Scalars['Int']>;
  assessmentAverageWpm?: Maybe<Scalars['Int']>;
  assessmentCompletedCount: Scalars['Int'];
  assessmentSkippedCount?: Maybe<Scalars['Int']>;
};

export type KeyClassroomEngagementSpotCheckActivityResult = {
  __typename?: 'KeyClassroomEngagementSpotCheckActivityResult';
  accuracy: Scalars['Int'];
  dateCompleted: Scalars['DateTime'];
  template: Scalars['String'];
  week: Scalars['Int'];
  wpm: Scalars['Int'];
};

export type KeyClassroomEngagementSpotCheckStats = {
  __typename?: 'KeyClassroomEngagementSpotCheckStats';
  activities?: Maybe<Array<KeyClassroomEngagementSpotCheckActivityResult>>;
  averageAccuracy: Scalars['Float'];
  averageWpm: Scalars['Float'];
  dateLastCompleted?: Maybe<Scalars['DateTime']>;
  totalCompletedCount: Scalars['Int'];
};

export type KeyClassroomEngagementStudentResult = {
  __typename?: 'KeyClassroomEngagementStudentResult';
  assessmentAccelerator?: Maybe<KeyClassroomEngagementAssessmentAcceleratorStudentStats>;
  averageWeeklyMinutesSpent: Scalars['Float'];
  curriculumProgressPercentage: Scalars['Float'];
  curriculumWeek: Scalars['Int'];
  enrichmentActivities?: Maybe<KeyClassroomEngagementEnrichmentActivityStats>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  scheduledActivities?: Maybe<KeyClassroomEngagementScheduledActivityStats>;
  spotChecks?: Maybe<KeyClassroomEngagementSpotCheckStats>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
  teacherCreatedActivities?: Maybe<KeyClassroomEngagementTeacherCreatedActivityStats>;
  totalActivitiesCompletedCount: Scalars['Int'];
};

export type KeyClassroomEngagementTeacherCreatedActivityStats = {
  __typename?: 'KeyClassroomEngagementTeacherCreatedActivityStats';
  averageAccuracy: Scalars['Float'];
  averageWpm: Scalars['Float'];
  totalCompletedCount: Scalars['Int'];
};

export type KeyClassroomSettingHomeUseData = {
  __typename?: 'KeyClassroomSettingHomeUseData';
  enabled: Scalars['Boolean'];
  students?: Maybe<Array<KeyClassroomSettingHomeUseStudentData>>;
};

export type KeyClassroomSettingHomeUseStudentData = {
  __typename?: 'KeyClassroomSettingHomeUseStudentData';
  homeUse?: Maybe<KeySettingHomeUseData>;
  productCurriculumCode: Scalars['String'];
  studentId: Scalars['Int'];
};

export type KeyClassroomSettings = {
  __typename?: 'KeyClassroomSettings';
  assessmentAcceleratorSettings?: Maybe<KeyAssessmentAcceleratorSettings>;
  assessmentSettings?: Maybe<KeyScheduledActivitySettings>;
  classroomId: Scalars['Int'];
  enrichmentActivitySettings?: Maybe<KeyEnrichmentActivitySettings>;
  homeUse?: Maybe<KeyClassroomSettingHomeUseData>;
  skipJumpIn?: Maybe<BaseSettingData>;
  stopAndReview?: Maybe<WeekSettingData>;
};

export type KeyCurriculumProgressReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyCurriculumProgressReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<KeyCurriculumProgressReportResult>;
};

export type KeyCurriculumProgressReportResult = {
  __typename?: 'KeyCurriculumProgressReportResult';
  curriculumProgressPercentage: Scalars['Float'];
};

export type KeyEnrichmentActivitySettings = {
  __typename?: 'KeyEnrichmentActivitySettings';
  hearItTypeIt?: Maybe<BaseSettingData>;
  myChoiceKeyboarding?: Maybe<BaseSettingData>;
  teacherCreated?: Maybe<KeyTeacherCreatedActivitySettings>;
};

export enum KeyOneHandedTypingHand {
  LEFT_HAND = 'LEFT_HAND',
  RIGHT_HAND = 'RIGHT_HAND'
}

export type KeyOrganizationClassroomEngagementReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyOrganizationClassroomEngagementReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<Array<KeyOrganizationClassroomEngagementReportResult>>;
};

export type KeyOrganizationClassroomEngagementReportResult = {
  __typename?: 'KeyOrganizationClassroomEngagementReportResult';
  activeStudentCount: Scalars['Int'];
  averageWeeklyMinutesSpent: Scalars['Float'];
  classroom?: Maybe<Classroom>;
  classroomId: Scalars['Int'];
  curriculumProgressPercentage: Scalars['Float'];
  totalActivitiesCompletedCount: Scalars['Int'];
  totalStudentCount: Scalars['Int'];
};

export type KeyOrganizationClassroomEngagementReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type KeyOrganizationEngagementReportAsyncResult = AsyncReportResult & {
  __typename?: 'KeyOrganizationEngagementReportAsyncResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  result?: Maybe<Array<KeyOrganizationEngagementReportResult>>;
};

export type KeyOrganizationEngagementReportResult = {
  __typename?: 'KeyOrganizationEngagementReportResult';
  activeStudentCount: Scalars['Int'];
  averageWeeklyMinutesSpent: Scalars['Float'];
  curriculumActivitiesCompleted?: Maybe<Array<ProductCurriculumActivitiesCompleted>>;
  curriculumAverageWeeklyTimeSpent?: Maybe<Array<ProductCurriculumAverageWeeklyTimeSpent>>;
  curriculumProgressPercentage: Scalars['Float'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  totalActivitiesCompletedCount: Scalars['Int'];
  totalStudentCount: Scalars['Int'];
};

export type KeyOrganizationEngagementReportWhereInput = {
  organizationId: Scalars['Int'];
};

export type KeyReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type KeyScheduledActivitySettings = {
  __typename?: 'KeyScheduledActivitySettings';
  activityTypeId: Scalars['String'];
  assessOnLoginDate?: Maybe<Scalars['DateTime']>;
  scheduleType?: Maybe<ScheduledActivityScheduleType>;
  scheduledDates?: Maybe<Array<Scalars['DateTime']>>;
};

export enum KeySetting {
  HEAR_IT_TYPE_IT = 'HEAR_IT_TYPE_IT',
  HOME_USE = 'HOME_USE',
  MY_CHOICE = 'MY_CHOICE',
  SKIP_JUMP_IN = 'SKIP_JUMP_IN',
  STOP_AND_REVIEW = 'STOP_AND_REVIEW',
  STOP_REVIEW = 'STOP_REVIEW',
  TEACHER_CREATED = 'TEACHER_CREATED'
}

export type KeySettingDataInput = {
  enabled: Scalars['Boolean'];
};

export type KeySettingHomeUseData = {
  __typename?: 'KeySettingHomeUseData';
  KEY1?: Maybe<Scalars['String']>;
  KEY2?: Maybe<Scalars['String']>;
  KEY3?: Maybe<Scalars['String']>;
  KEY4?: Maybe<Scalars['String']>;
  KEY5?: Maybe<Scalars['String']>;
  KEYK?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
};

export type KeySettingSkipJumpInData = {
  __typename?: 'KeySettingSkipJumpInData';
  KEY1?: Maybe<Scalars['Boolean']>;
  KEY2?: Maybe<Scalars['Boolean']>;
  KEY3?: Maybe<Scalars['Boolean']>;
  KEY4?: Maybe<Scalars['Boolean']>;
  KEY5?: Maybe<Scalars['Boolean']>;
  KEYK?: Maybe<Scalars['Boolean']>;
};

export type KeySettingStopAndReviewData = {
  __typename?: 'KeySettingStopAndReviewData';
  KEY1?: Maybe<WeekSettingData>;
  KEY2?: Maybe<WeekSettingData>;
  KEY3?: Maybe<WeekSettingData>;
  KEY4?: Maybe<WeekSettingData>;
  KEY5?: Maybe<WeekSettingData>;
  KEYK?: Maybe<WeekSettingData>;
};

export type KeyStudentCurriculumProgress = {
  __typename?: 'KeyStudentCurriculumProgress';
  activeDayCount: Scalars['Int'];
  activityCompletedCount: Scalars['Int'];
  activityTotalCount: Scalars['Int'];
  curriculumProgressPercentage: Scalars['Float'];
  curriculumWeek: Scalars['Int'];
  curriculumWeekTotal: Scalars['Int'];
  spotCheckCompletedCount: Scalars['Int'];
  spotCheckTotalCount: Scalars['Int'];
};

export type KeyStudentEngagementAssessmentAcceleratorModuleAttempt = {
  __typename?: 'KeyStudentEngagementAssessmentAcceleratorModuleAttempt';
  activities: Array<KeyStudentEngagementAssessmentAcceleratorModuleAttemptActivity>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
};

export type KeyStudentEngagementAssessmentAcceleratorModuleAttemptActivity = {
  __typename?: 'KeyStudentEngagementAssessmentAcceleratorModuleAttemptActivity';
  activity?: Maybe<KeyboardingActivity>;
  activityId: Scalars['Int'];
  attemptCount?: Maybe<Scalars['Int']>;
  responseData?: Maybe<Scalars['JSON']>;
  secondsSpent?: Maybe<Scalars['Int']>;
};

export type KeyStudentEngagementAssessmentAcceleratorModuleResult = {
  __typename?: 'KeyStudentEngagementAssessmentAcceleratorModuleResult';
  attempts: Array<KeyStudentEngagementAssessmentAcceleratorModuleAttempt>;
  averageAttemptCount?: Maybe<Scalars['Float']>;
  averageSecondsSpent?: Maybe<Scalars['Float']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  moduleIds: Array<Scalars['Int']>;
  modules?: Maybe<Array<KeyboardingModule>>;
  totalFirstAttemptCount?: Maybe<Scalars['Int']>;
  totalSecondsSpent?: Maybe<Scalars['Int']>;
};

export type KeyStudentEngagementAssessmentAcceleratorResult = {
  __typename?: 'KeyStudentEngagementAssessmentAcceleratorResult';
  activityTypes: Array<KeyAssessmentAcceleratorActivityTypeResult>;
  averageAttemptCount?: Maybe<Scalars['Float']>;
  moduleAverageSecondsSpent?: Maybe<Scalars['Float']>;
  modules: Array<KeyStudentEngagementAssessmentAcceleratorModuleResult>;
  totalFirstAttemptCount?: Maybe<Scalars['Int']>;
  totalSecondsSpent?: Maybe<Scalars['Int']>;
};

export type KeyStudentEngagementAssessmentActivityResult = {
  __typename?: 'KeyStudentEngagementAssessmentActivityResult';
  aborted?: Maybe<Scalars['Boolean']>;
  accuracy: Scalars['Int'];
  template: Scalars['String'];
  wpm: Scalars['Int'];
};

export type KeyStudentEngagementAssessmentResult = {
  __typename?: 'KeyStudentEngagementAssessmentResult';
  aborted?: Maybe<Scalars['Boolean']>;
  activities?: Maybe<Array<KeyStudentEngagementAssessmentActivityResult>>;
  averageAccuracy: Scalars['Float'];
  averageWpm: Scalars['Float'];
  dateCompleted: Scalars['DateTime'];
};

export type KeyStudentEngagementEnrichmentActivityResult = {
  __typename?: 'KeyStudentEngagementEnrichmentActivityResult';
  aborted?: Maybe<Scalars['Boolean']>;
  accuracy: Scalars['Int'];
  dateCompleted: Scalars['DateTime'];
  retryCount?: Maybe<Scalars['Int']>;
  template: Scalars['String'];
  wpm: Scalars['Int'];
};

export type KeyStudentEngagementReportResult = {
  __typename?: 'KeyStudentEngagementReportResult';
  assessmentAccelerator?: Maybe<KeyStudentEngagementAssessmentAcceleratorResult>;
  assessments?: Maybe<Array<KeyStudentEngagementAssessmentResult>>;
  enrichmentActivities?: Maybe<Array<KeyStudentEngagementEnrichmentActivityResult>>;
  spotChecks?: Maybe<Array<KeyStudentEngagementSpotCheckResult>>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type KeyStudentEngagementReportWhereInput = {
  studentId: Scalars['Int'];
};

export type KeyStudentEngagementSpotCheckResult = {
  __typename?: 'KeyStudentEngagementSpotCheckResult';
  accuracy: Scalars['Int'];
  dateCompleted: Scalars['DateTime'];
  template: Scalars['String'];
  wpm: Scalars['Int'];
};

export type KeyStudentProgressReportResult = {
  __typename?: 'KeyStudentProgressReportResult';
  curriculumProgress?: Maybe<KeyStudentCurriculumProgress>;
  dateLastLogin?: Maybe<Scalars['DateTime']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  skipJumpInEnabled: Scalars['Boolean'];
  stopAndReviewEnabled: Scalars['Boolean'];
  stopAndReviewWeek?: Maybe<Scalars['Int']>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type KeyStudentProgressReportWhereInput = {
  studentId: Scalars['Int'];
};

export type KeyStudentSettings = {
  __typename?: 'KeyStudentSettings';
  homeUse?: Maybe<KeySettingHomeUseData>;
  oneHandedTypingHand?: Maybe<KeyOneHandedTypingHand>;
  skipJumpIn?: Maybe<KeySettingSkipJumpInData>;
  stopAndReview?: Maybe<KeySettingStopAndReviewData>;
  studentId: Scalars['Int'];
};

export type KeyTeacherCreatedActivity = {
  __typename?: 'KeyTeacherCreatedActivity';
  activityGroupCount?: Maybe<Scalars['Int']>;
  classroomId: Scalars['Int'];
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type KeyTeacherCreatedActivityInput = {
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type KeyTeacherCreatedActivityPreview = {
  __typename?: 'KeyTeacherCreatedActivityPreview';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type KeyTeacherCreatedActivityPreviewInput = {
  text: Scalars['String'];
  title: Scalars['String'];
};

export type KeyTeacherCreatedActivitySettingInput = {
  activities?: InputMaybe<Array<KeyTeacherCreatedActivityInput>>;
  enabled: Scalars['Boolean'];
};

export type KeyTeacherCreatedActivitySettings = {
  __typename?: 'KeyTeacherCreatedActivitySettings';
  activities?: Maybe<Array<KeyTeacherCreatedActivity>>;
  enabled: Scalars['Boolean'];
};

export type KeyboardingActivity = {
  __typename?: 'KeyboardingActivity';
  activityTypeVariant: KeyboardingActivityTypeVariant;
  activityTypeVariantId: Scalars['Int'];
  category: KeyboardingActivityCategory;
  description: Scalars['String'];
  id: Scalars['Int'];
  modules?: Maybe<Array<Maybe<KeyboardingModule>>>;
  name: Scalars['String'];
  productCurriculums: Array<ProductCurriculum>;
  thumbnail?: Maybe<Asset>;
  thumbnailId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export enum KeyboardingActivityCategory {
  ASSESSMENT_ACCELERATOR_ELA = 'ASSESSMENT_ACCELERATOR_ELA',
  ASSESSMENT_ACCELERATOR_MATH = 'ASSESSMENT_ACCELERATOR_MATH',
  ASSESSMENT_ACCELERATOR_STEM = 'ASSESSMENT_ACCELERATOR_STEM',
  KEYBOARDING = 'KEYBOARDING'
}

export type KeyboardingActivityType = {
  __typename?: 'KeyboardingActivityType';
  activityTypeVariants: Array<KeyboardingActivityTypeVariant>;
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type KeyboardingActivityTypeVariant = {
  __typename?: 'KeyboardingActivityTypeVariant';
  activityType: KeyboardingActivityType;
  activityTypeId: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  variant: Scalars['String'];
  videos: Array<Maybe<KeyboardingActivityVideo>>;
};

export type KeyboardingActivityVideo = {
  __typename?: 'KeyboardingActivityVideo';
  activityTypeVariant: KeyboardingActivityTypeVariant;
  activityTypeVariantId: Scalars['Int'];
  description: Scalars['String'];
  device: ClientDevice;
  id: Scalars['Int'];
  name: Scalars['String'];
  productCurriculums: Array<ProductCurriculum>;
  video: Asset;
  videoId: Scalars['Int'];
};

export type KeyboardingCurriculum = {
  __typename?: 'KeyboardingCurriculum';
  curriculumActivities: Array<KeyboardingCurriculumActivity>;
  curriculumWeeks: Array<KeyboardingCurriculumWeek>;
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  productCurriculum: ProductCurriculum;
  productCurriculumId: Scalars['Int'];
};

export type KeyboardingCurriculumActivity = {
  __typename?: 'KeyboardingCurriculumActivity';
  activity: KeyboardingActivity;
  activityId: Scalars['Int'];
  curriculum: KeyboardingCurriculum;
  curriculumId: Scalars['Int'];
  curriculumWeek: KeyboardingCurriculumWeek;
  curriculumWeekId: Scalars['Int'];
  dayOfWeek?: Maybe<Weekday>;
  enrichment: Scalars['Boolean'];
  id: Scalars['Int'];
  sequenceNumber: Scalars['Int'];
  spotCheck: Scalars['Boolean'];
};

export enum KeyboardingCurriculumOrderField {
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID'
}

export type KeyboardingCurriculumTheme = {
  __typename?: 'KeyboardingCurriculumTheme';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  thumbnail: Asset;
  thumbnailId: Scalars['Int'];
};

export type KeyboardingCurriculumWeek = {
  __typename?: 'KeyboardingCurriculumWeek';
  curriculum: KeyboardingCurriculum;
  curriculumActivities: Array<KeyboardingCurriculumActivity>;
  curriculumId: Scalars['Int'];
  curriculumTheme: KeyboardingCurriculumTheme;
  curriculumThemeId: Scalars['Int'];
  id: Scalars['Int'];
  keys?: Maybe<Scalars['String']>;
  week: Scalars['Int'];
};

export type KeyboardingCurriculumWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
};

export type KeyboardingCurriculumsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
};

export type KeyboardingModule = {
  __typename?: 'KeyboardingModule';
  activities?: Maybe<Array<Maybe<KeyboardingActivity>>>;
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  parentModuleId?: Maybe<Scalars['Int']>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId: Scalars['Int'];
  submodules?: Maybe<Array<KeyboardingModule>>;
  thumbnail?: Maybe<Asset>;
  thumbnailId: Scalars['Int'];
};

export enum KeyboardingModuleOrderField {
  ID = 'ID',
  NAME = 'NAME'
}

export type KeyboardingModuleWhereInput = {
  id: Scalars['Int'];
};

export type KeyboardingModulesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['Int']>>;
  parentModuleId?: InputMaybe<Array<Scalars['Int']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
};

export type License = {
  __typename?: 'License';
  dateCreated: Scalars['DateTime'];
  dateExpiration: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  dateUpdatedAssignment?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  expired: Scalars['Boolean'];
  id: Scalars['Int'];
  licenseType: LicenseType;
  licenseTypeId: Scalars['Int'];
  manualAssignment?: Maybe<Scalars['Boolean']>;
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  siteLicense?: Maybe<SiteLicense>;
  siteLicenseId?: Maybe<Scalars['Int']>;
  student?: Maybe<Student>;
  studentId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export enum LicenseAction {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN'
}

export type LicenseActionRequest = {
  __typename?: 'LicenseActionRequest';
  action?: Maybe<LicenseAction>;
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
  userId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignInput = {
  productCurriculum?: InputMaybe<ProductIdentifierInput>;
  studentId?: InputMaybe<Scalars['Int']>;
  updates?: InputMaybe<LicenseAssignmentUpdateInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type LicenseAssignRequest = {
  __typename?: 'LicenseAssignRequest';
  gradeLevel?: Maybe<Scalars['String']>;
  orderItemId?: Maybe<Array<Scalars['Int']>>;
  productCode?: Maybe<Scalars['String']>;
  productCurriculumCode?: Maybe<Scalars['String']>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  replaceExistingProductFamilyLicense?: Maybe<Scalars['Boolean']>;
  skipAlreadyLicensed?: Maybe<Scalars['Boolean']>;
  skipManualAssignment?: Maybe<Scalars['Boolean']>;
  studentId?: Maybe<Scalars['Int']>;
  updates?: Maybe<LicenseAssignUpdates>;
  userId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignUpdates = {
  __typename?: 'LicenseAssignUpdates';
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateUsed?: Maybe<Scalars['DateTime']>;
  organizationId?: Maybe<Scalars['Int']>;
};

export type LicenseAssignmentUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  dateUsed?: InputMaybe<Scalars['DateTime']>;
  manualAssignment?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type LicenseExpirationInput = {
  gracePeriodEndDate: Scalars['DateTime'];
  unlockDate: Scalars['DateTime'];
};

export enum LicenseOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_EXPIRATION = 'DATE_EXPIRATION',
  DATE_UPDATED = 'DATE_UPDATED',
  DATE_UPDATED_ASSIGNMENT = 'DATE_UPDATED_ASSIGNMENT',
  ID = 'ID',
  MANUAL_ASSIGNMENT = 'MANUAL_ASSIGNMENT',
  ORDER_ITEM_ID = 'ORDER_ITEM_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  STUDENT_ID = 'STUDENT_ID',
  USER_ID = 'USER_ID'
}

export enum LicenseStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  REMOVED = 'REMOVED'
}

export enum LicenseType {
  ADD_ON = 'ADD_ON',
  EMPLOYEE = 'EMPLOYEE',
  FULL = 'FULL',
  MULTI_YEAR = 'MULTI_YEAR',
  OVERAGE = 'OVERAGE',
  PRORATED = 'PRORATED',
  RENEWAL = 'RENEWAL',
  TRIAL = 'TRIAL',
  WORKSHOP = 'WORKSHOP'
}

export type LicenseUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  expiration?: InputMaybe<LicenseExpirationInput>;
  orderItemId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type LicenseUsageWhereInput = {
  product?: InputMaybe<Array<ProductIdentifierInput>>;
  productCurriculum?: InputMaybe<Array<ProductIdentifierInput>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
};

export type LicenseWhereInput = {
  id: Scalars['Int'];
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
};

export type LicensesMastercodeWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
};

export type LicensesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<LicenseOrderField>;
};

export type LicensesOrderWhereInput = {
  AND?: InputMaybe<Array<LicensesOrderWhereInput>>;
  OR?: InputMaybe<Array<LicensesOrderWhereInput>>;
  ecmsOrderNumber?: InputMaybe<Array<Scalars['String']>>;
  ecmsOrderNumber_contains?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  orderNumber?: InputMaybe<Array<Scalars['String']>>;
  orderNumber_contains?: InputMaybe<Scalars['String']>;
};

export type LicensesOrganizationWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
};

export type LicensesWhereInput = {
  AND?: InputMaybe<Array<LicensesWhereInput>>;
  OR?: InputMaybe<Array<LicensesWhereInput>>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  assigneeType?: InputMaybe<AssigneeType>;
  expired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  licenseType?: InputMaybe<Array<LicenseType>>;
  manualAssignment?: InputMaybe<Scalars['Boolean']>;
  mastercode?: InputMaybe<LicensesMastercodeWhereInput>;
  order?: InputMaybe<LicensesOrderWhereInput>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organization?: InputMaybe<LicensesOrganizationWhereInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<Array<ProductIdentifierInput>>;
  productCurriculum?: InputMaybe<Array<ProductIdentifierInput>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
  siteLicenseId?: InputMaybe<Array<Scalars['Int']>>;
  status?: InputMaybe<Array<LicenseStatus>>;
  studentId?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum Locale {
  EN_US = 'EN_US',
  ES_US = 'ES_US'
}

export type Mastercode = {
  __typename?: 'Mastercode';
  code: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateExpired?: Maybe<Scalars['DateTime']>;
  dateGracePeriodEnd: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateScheduledUnlock?: Maybe<Scalars['DateTime']>;
  dateUnlocked?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  orderItems?: Maybe<Array<OrderItem>>;
  ownerEmail?: Maybe<Scalars['String']>;
  parentMastercode?: Maybe<Mastercode>;
  parentMastercodeId?: Maybe<Scalars['Int']>;
  status?: Maybe<MastercodeStatus>;
  transferHistory?: Maybe<Array<MastercodeTransferHistory>>;
};

export enum MastercodeOrderField {
  CODE = 'CODE',
  DATE_CREATED = 'DATE_CREATED',
  DATE_REMOVED = 'DATE_REMOVED',
  DATE_SCHEDULED_UNLOCK = 'DATE_SCHEDULED_UNLOCK',
  DATE_UNLOCKED = 'DATE_UNLOCKED',
  ID = 'ID',
  OWNER_EMAIL = 'OWNER_EMAIL'
}

export type MastercodeOrderItemsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  licenseType?: InputMaybe<Array<LicenseType>>;
  licenseTypeId?: InputMaybe<Array<Scalars['Int']>>;
  trial?: InputMaybe<Scalars['Boolean']>;
};

export type MastercodeOrdersWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  orderNumber?: InputMaybe<Array<Scalars['String']>>;
  psrentOrderId?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export type MastercodeOrganizationsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
};

export enum MastercodeStatus {
  EXPIRED = 'EXPIRED',
  LOCKED = 'LOCKED',
  REMOVED = 'REMOVED',
  SCHEDULED = 'SCHEDULED',
  UNLOCKED = 'UNLOCKED'
}

export type MastercodeTransferHistoriesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  mastercodeId?: InputMaybe<Array<Scalars['Int']>>;
  newOwnerEmail?: InputMaybe<Array<Scalars['String']>>;
  previousOwnerEmail?: InputMaybe<Array<Scalars['String']>>;
};

export type MastercodeTransferHistory = {
  __typename?: 'MastercodeTransferHistory';
  dateTransferred: Scalars['DateTime'];
  id: Scalars['Int'];
  mastercode?: Maybe<Mastercode>;
  mastercodeId: Scalars['Int'];
  newOwnerEmail: Scalars['String'];
  previousOwnerEmail: Scalars['String'];
};

export enum MastercodeTransferHistoryOrderField {
  DATE_TRANSERRED = 'DATE_TRANSERRED',
  ID = 'ID',
  MASTERCODE_ID = 'MASTERCODE_ID',
  NEW_OWNER_EMAIL = 'NEW_OWNER_EMAIL',
  PREVIOUS_OWNER_EMAIL = 'PREVIOUS_OWNER_EMAIL'
}

export type MastercodeTransferHistoryOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<MastercodeTransferHistoryOrderField>;
};

export type MastercodeTransferHistoryWhereInput = {
  id: Scalars['Int'];
};

export type MastercodeTransferInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  ownerEmail: Scalars['String'];
};

export type MastercodeUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MastercodeWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
};

export type MastercodesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<MastercodeOrderField>;
};

export type MastercodesWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  expired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Array<Scalars['Int']>>;
  orderItems?: InputMaybe<MastercodeOrderItemsWhereInput>;
  orders?: InputMaybe<MastercodeOrdersWhereInput>;
  organizations?: InputMaybe<MastercodeOrganizationsWhereInput>;
  ownerEmail?: InputMaybe<Array<Scalars['String']>>;
  ownerEmail_contains?: InputMaybe<Scalars['String']>;
  parentMastercodeId?: InputMaybe<Array<Scalars['Int']>>;
  products?: InputMaybe<ProductsWhereInput>;
  status?: InputMaybe<Array<MastercodeStatus>>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
};

export type Media = {
  __typename?: 'Media';
  mediaType: MediaType;
  src: Scalars['String'];
};

export enum MediaType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type Mutation = {
  __typename?: 'Mutation';
  _dummyCore?: Maybe<Scalars['Boolean']>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  archiveClassrooms?: Maybe<BatchMutationResult>;
  assignAvailableLicense?: Maybe<License>;
  assignLicense?: Maybe<License>;
  bulkAssignAvailableLicenses: Array<BulkAssignResult>;
  bulkGroupEnrollmentAction?: Maybe<Array<BulkGroupEnrollmentActionResult>>;
  bulkLicenseAction: Array<BulkLicenseActionResult>;
  /**
   * - Required privileges:
   *   - academic-session.create
   */
  createAcademicSession?: Maybe<AcademicSession>;
  createAssetTag?: Maybe<AssetTag>;
  createAssetTags?: Maybe<Array<Maybe<AssetTag>>>;
  createAssetVtt: AssetVtt;
  createAssets: Array<FileUploadData>;
  /**
   * - Required privileges:
   *   - classroom.create
   */
  createClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated No longer supported
   */
  createClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - contact.create
   */
  createContact?: Maybe<Contact>;
  createCourses: Array<Course>;
  createFeatureToggle?: Maybe<FeatureToggle>;
  createGroup?: Maybe<Group>;
  createKeyTeacherCreatedActivityPreview: KeyTeacherCreatedActivityPreview;
  /**
   * - Required privileges:
   *   - organization.create
   */
  createOrganization?: Maybe<Organization>;
  createResourceFavorite?: Maybe<ResourceFavorite>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated No longer supported
   */
  createStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student.create
   */
  createStudents: Array<Maybe<Student>>;
  createUploadUrls: Array<UploadUrl>;
  /**
   * - Required privileges:
   *   - user.create
   */
  createUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated No longer supported
   */
  createUserSetting?: Maybe<UserSetting>;
  deleteAsset?: Maybe<Asset>;
  deleteCourse?: Maybe<Course>;
  deleteExpiredAssets: AssetResponse;
  deleteExpiredCourses: AssetResponse;
  deleteExpiredOrphanedS3Assets?: Maybe<BatchMutationResult>;
  deleteOrphanedCourses: BatchMutationResult;
  deleteResourceFavorite?: Maybe<ResourceFavorite>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  enroll?: Maybe<Array<Maybe<Enrollment>>>;
  enrollGroup?: Maybe<Array<GroupEnrollment>>;
  expireMastercode: Mastercode;
  extendMastercode: Mastercode;
  moveMastercode: Mastercode;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  removeAcademicSessions?: Maybe<BatchMutationResult>;
  removeAsset?: Maybe<Asset>;
  removeAssetTag?: Maybe<AssetTag>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  removeClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  removeClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeContacts: BatchMutationResult;
  removeCourse?: Maybe<Course>;
  removeFeatureToggle?: Maybe<FeatureToggle>;
  removeFeatureToggles?: Maybe<BatchMutationResult>;
  removeGroup?: Maybe<Group>;
  removeGroups: BatchMutationResult;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganization?: Maybe<Organization>;
  removeOrganizationSetting?: Maybe<Scalars['Void']>;
  removeOrganizationSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  removeOrganizations?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  removeStudentFromContact: BatchMutationResult;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  removeStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  removeStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSetting?: Maybe<Scalars['Void']>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  removeUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  removeUsers?: Maybe<BatchMutationResult>;
  restoreAsset: Asset;
  restoreCourse: Course;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   */
  saveClassroomSettings?: Maybe<BatchMutationResult>;
  saveOrganizationSetting?: Maybe<OrganizationSetting>;
  saveOrganizationSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   */
  saveStudentSettings?: Maybe<BatchMutationResult>;
  saveToursSettings: Array<Maybe<TourSettings>>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.write
   */
  saveUserSettings?: Maybe<BatchMutationResult>;
  scheduleUnlockMastercode: Mastercode;
  scheduleUnlockOrderMastercodes: BatchMutationResult;
  sendLicenseAssignmentEmail?: Maybe<Scalars['Boolean']>;
  sendSupportTicket?: Maybe<Scalars['Boolean']>;
  sendUserInviteEmail?: Maybe<Scalars['Boolean']>;
  swapLicenses: Array<Maybe<License>>;
  transferMastercode: Mastercode;
  transferOrderMastercodes: BatchMutationResult;
  /**
   * - Required privileges:
   *   - student.write
   */
  transferStudent?: Maybe<Enrollment>;
  unassignLicense?: Maybe<License>;
  unassignLicenses?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  unenroll?: Maybe<BatchMutationResult>;
  unenrollGroup?: Maybe<BatchMutationResult>;
  unlockMastercode: ProvisioningResult;
  unlockOrderMastercodes: ProvisioningResult;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.write
   */
  updateAcademicSessions?: Maybe<BatchMutationResult>;
  updateAsset?: Maybe<FileUploadData>;
  updateAssetMetadata: AssetResponse;
  updateAssetTag?: Maybe<AssetTag>;
  updateAssetVersion: AssetResponse;
  updateAzsappClassroomSettingExposeLetterBooks: Array<Maybe<BaseClassroomSettingResponse>>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassroom?: Maybe<Classroom>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated No longer supported
   */
  updateClassroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.write
   * @deprecated No longer supported
   */
  updateClassroomSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - classroom.write
   */
  updateClassrooms?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.write
   */
  updateContacts: BatchMutationResult;
  updateCourse: Course;
  updateCourseMetadata: AssetResponse;
  updateCourseVersion: AssetResponse;
  updateFeatureToggle?: Maybe<FeatureToggle>;
  updateFeatureToggles?: Maybe<BatchMutationResult>;
  updateGroup?: Maybe<Group>;
  updateGssClassroomSettingCharacterOrder: Array<BaseClassroomSettingResponse>;
  updateGssClassroomSettingLanguage: Array<BaseClassroomSettingResponse>;
  updateGssClassroomSettingLeftHandedness: Array<BaseClassroomSettingResponse>;
  updateGssStudentSettingCharacterOrder: Array<BaseStudentSettingResponse>;
  updateGssStudentSettingLanguage: Array<BaseStudentSettingResponse>;
  updateGssStudentSettingLeftHandedness: Array<BaseStudentSettingResponse>;
  updateHwtClassroomSettingLanguage: Array<BaseClassroomSettingResponse>;
  updateHwtStudentSettingLanguage: Array<BaseStudentSettingResponse>;
  updateKeyClassroomAssessmentAcceleratorModules: KeyAssessmentAcceleratorSettings;
  updateKeyClassroomSettingAssessments: KeyScheduledActivitySettings;
  updateKeyClassroomSettingEnrichmentActivities: KeyEnrichmentActivitySettings;
  updateKeyClassroomSettingHomeUse: Array<Maybe<BaseStudentSettingResponse>>;
  updateKeyClassroomSettingSkipJumpIn: Array<Maybe<BaseClassroomSettingResponse>>;
  updateKeyClassroomSettingStopAndReview: Array<BaseClassroomSettingResponse>;
  updateKeyStudentSettingHomeUse: Array<Maybe<BaseStudentSettingResponse>>;
  updateKeyStudentSettingOneHandedTypingHand: Array<Maybe<BaseStudentSettingResponse>>;
  updateKeyStudentSettingSkipJumpIn: Array<BaseStudentSettingResponse>;
  updateKeyStudentSettingStopAndReview: Array<BaseStudentSettingResponse>;
  updateLicense?: Maybe<License>;
  updateLicenses?: Maybe<BatchMutationResult>;
  updateMe?: Maybe<User>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganization?: Maybe<Organization>;
  /**
   * - Required privileges:
   *   - organization.write
   */
  updateOrganizations?: Maybe<BatchMutationResult>;
  updatePliUserSetting: UserSetting;
  updateSiteLicense?: Maybe<SiteLicense>;
  updateSiteLicenses?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudent?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated No longer supported
   */
  updateStudentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.write
   * @deprecated No longer supported
   */
  updateStudentSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - student.write
   */
  updateStudents?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUser?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated No longer supported
   */
  updateUserSetting?: Maybe<UserSetting>;
  updateUserSettingPliOnboardingWelcome: UserSetting;
  /**
   * - Required privileges:
   *   - user-setting.write
   * @deprecated No longer supported
   */
  updateUserSettings?: Maybe<BatchMutationResult>;
  /**
   * - Required privileges:
   *   - user.write
   */
  updateUsers?: Maybe<BatchMutationResult>;
  updateWdtClassroomSettingCharacterOrder: Array<BaseClassroomSettingResponse>;
  updateWdtClassroomSettingLeftHandedness: Array<BaseClassroomSettingResponse>;
  updateWdtStudentSettingCharacterOrder: Array<BaseStudentSettingResponse>;
  updateWdtStudentSettingLeftHandedness: Array<BaseStudentSettingResponse>;
  uploadBulkImportFile?: Maybe<BulkImportFileUploadResult>;
};


export type MutationArchiveClassroomArgs = {
  where: ClassroomWhereInput;
};


export type MutationArchiveClassroomsArgs = {
  where: ClassroomsWhereInput;
};


export type MutationAssignAvailableLicenseArgs = {
  data: AssignAvailableLicenseInput;
  where: AssignAvailableLicenseWhereInput;
};


export type MutationAssignLicenseArgs = {
  data: LicenseAssignInput;
  where: LicenseWhereInput;
};


export type MutationBulkAssignAvailableLicensesArgs = {
  data: Array<BulkAssignAvailableLicenseInput>;
  where?: InputMaybe<BulkAssignAvailableWhereInput>;
};


export type MutationBulkGroupEnrollmentActionArgs = {
  data: Array<BulkGroupEnrollmentActionInput>;
};


export type MutationBulkLicenseActionArgs = {
  data: Array<BulkLicenseActionInput>;
  where?: InputMaybe<BulkLicenseActionWhereInput>;
};


export type MutationCreateAcademicSessionArgs = {
  data: AcademicSessionCreateInput;
};


export type MutationCreateAssetTagArgs = {
  data: AssetTagCreateInput;
};


export type MutationCreateAssetTagsArgs = {
  data: Array<AssetTagCreateInput>;
};


export type MutationCreateAssetVttArgs = {
  data: AssetVttCreateInput;
};


export type MutationCreateAssetsArgs = {
  data: Array<AssetCreateInput>;
};


export type MutationCreateClassroomArgs = {
  data: ClassroomCreateInput;
};


export type MutationCreateClassroomSettingArgs = {
  data: ClassroomSettingCreateInput;
};


export type MutationCreateContactArgs = {
  data: ContactInput;
};


export type MutationCreateCoursesArgs = {
  data: Array<CourseCreateInput>;
};


export type MutationCreateFeatureToggleArgs = {
  data: FeatureToggleInput;
};


export type MutationCreateGroupArgs = {
  data: GroupCreateInput;
};


export type MutationCreateKeyTeacherCreatedActivityPreviewArgs = {
  data: KeyTeacherCreatedActivityPreviewInput;
};


export type MutationCreateOrganizationArgs = {
  data: OrganizationCreateInput;
};


export type MutationCreateResourceFavoriteArgs = {
  data: ResourceFavoriteCreateInput;
};


export type MutationCreateStudentArgs = {
  data: StudentCreateInput;
};


export type MutationCreateStudentSettingArgs = {
  data: StudentSettingCreateInput;
};


export type MutationCreateStudentsArgs = {
  data: Array<StudentCreateInput>;
};


export type MutationCreateUploadUrlsArgs = {
  data: UploadUrlsCreateInput;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
  upsert?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateUserSettingArgs = {
  data: UserSettingCreateInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereInput;
};


export type MutationDeleteCourseArgs = {
  where: CourseWhereInput;
};


export type MutationDeleteResourceFavoriteArgs = {
  where: ResourceFavoriteDeleteInput;
};


export type MutationEnrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};


export type MutationEnrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};


export type MutationExpireMastercodeArgs = {
  data?: InputMaybe<MastercodeUpdateInput>;
  where: MastercodeWhereInput;
};


export type MutationExtendMastercodeArgs = {
  data: MastercodeUpdateInput;
  where: MastercodeWhereInput;
};


export type MutationMoveMastercodeArgs = {
  data: MastercodeUpdateInput;
  where: MastercodeWhereInput;
};


export type MutationRemoveAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};


export type MutationRemoveAcademicSessionsArgs = {
  where: AcademicSessionsWhereInput;
};


export type MutationRemoveAssetArgs = {
  where: AssetWhereInput;
};


export type MutationRemoveAssetTagArgs = {
  where: AssetTagWhereInput;
};


export type MutationRemoveClassroomArgs = {
  where: ClassroomWhereInput;
};


export type MutationRemoveClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};


export type MutationRemoveClassroomSettingsArgs = {
  where: ClassroomSettingsWhereInput;
};


export type MutationRemoveClassroomsArgs = {
  where: ClassroomsWhereInput;
};


export type MutationRemoveContactArgs = {
  where: ContactWhereInput;
};


export type MutationRemoveContactsArgs = {
  where: ContactsWhereInput;
};


export type MutationRemoveCourseArgs = {
  where: CourseWhereInput;
};


export type MutationRemoveFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};


export type MutationRemoveFeatureTogglesArgs = {
  where: FeatureTogglesWhereInput;
};


export type MutationRemoveGroupArgs = {
  where: GroupWhereInput;
};


export type MutationRemoveGroupsArgs = {
  where: GroupsWhereInput;
};


export type MutationRemoveOrganizationArgs = {
  where: OrganizationWhereInput;
};


export type MutationRemoveOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};


export type MutationRemoveOrganizationSettingsArgs = {
  where: OrganizationSettingsWhereInput;
};


export type MutationRemoveOrganizationsArgs = {
  where: OrganizationsWhereInput;
};


export type MutationRemoveStudentArgs = {
  where: StudentWhereInput;
};


export type MutationRemoveStudentFromContactArgs = {
  data: ContactStudentRemoveInput;
};


export type MutationRemoveStudentSettingArgs = {
  where: StudentSettingWhereInput;
};


export type MutationRemoveStudentSettingsArgs = {
  where: StudentSettingsWhereInput;
};


export type MutationRemoveStudentsArgs = {
  where: StudentsWhereInput;
};


export type MutationRemoveUserArgs = {
  where: UserWhereInput;
};


export type MutationRemoveUserSettingArgs = {
  where: UserSettingWhereInput;
};


export type MutationRemoveUserSettingsArgs = {
  where: UserSettingsWhereInput;
};


export type MutationRemoveUsersArgs = {
  where: UsersWhereInput;
};


export type MutationRestoreAssetArgs = {
  where: AssetWhereInput;
};


export type MutationRestoreCourseArgs = {
  where: CourseWhereInput;
};


export type MutationSaveClassroomSettingArgs = {
  value: Scalars['JSON'];
  where: ClassroomSettingWhereInput;
};


export type MutationSaveClassroomSettingsArgs = {
  value: Scalars['JSON'];
  where: ClassroomSettingsWhereInput;
};


export type MutationSaveOrganizationSettingArgs = {
  value: Scalars['JSON'];
  where: OrganizationSettingWhereInput;
};


export type MutationSaveOrganizationSettingsArgs = {
  value: Scalars['JSON'];
  where: OrganizationSettingsWhereInput;
};


export type MutationSaveStudentSettingArgs = {
  value: Scalars['JSON'];
  where: StudentSettingWhereInput;
};


export type MutationSaveStudentSettingsArgs = {
  value: Scalars['JSON'];
  where: StudentSettingsWhereInput;
};


export type MutationSaveToursSettingsArgs = {
  data: SaveToursSettingsInput;
};


export type MutationSaveUserSettingArgs = {
  value: Scalars['JSON'];
  where: UserSettingWhereInput;
};


export type MutationSaveUserSettingsArgs = {
  value: Scalars['JSON'];
  where: UserSettingsWhereInput;
};


export type MutationScheduleUnlockMastercodeArgs = {
  date: Scalars['DateTime'];
  where: MastercodeWhereInput;
};


export type MutationScheduleUnlockOrderMastercodesArgs = {
  date: Scalars['DateTime'];
  where: OrderWhereInput;
};


export type MutationSendLicenseAssignmentEmailArgs = {
  data: SendLicenseAssignmentEmailInput;
};


export type MutationSendSupportTicketArgs = {
  data: SendSupportTicketInput;
};


export type MutationSendUserInviteEmailArgs = {
  data: SendUserInviteEmailInput;
};


export type MutationSwapLicensesArgs = {
  data: SwapLicensesInput;
  where: SwapLicensesWhereInput;
};


export type MutationTransferMastercodeArgs = {
  data: MastercodeTransferInput;
  where: MastercodeWhereInput;
};


export type MutationTransferOrderMastercodesArgs = {
  data: MastercodeTransferInput;
  where: OrderWhereInput;
};


export type MutationTransferStudentArgs = {
  data: TransferStudentInput;
  where: TransferStudentWhereInput;
};


export type MutationUnassignLicenseArgs = {
  where: LicenseWhereInput;
};


export type MutationUnassignLicensesArgs = {
  where: LicensesWhereInput;
};


export type MutationUnenrollArgs = {
  classroomId: Scalars['Int'];
  studentIds?: InputMaybe<Array<Scalars['Int']>>;
  userEnrollments?: InputMaybe<Array<UserEnrollmentInput>>;
};


export type MutationUnenrollGroupArgs = {
  groupId: Scalars['Int'];
  studentIds: Array<Scalars['Int']>;
};


export type MutationUnlockMastercodeArgs = {
  where: MastercodeWhereInput;
};


export type MutationUnlockOrderMastercodesArgs = {
  where: OrderWhereInput;
};


export type MutationUpdateAcademicSessionArgs = {
  data: AcademicSessionUpdateInput;
  where: AcademicSessionWhereInput;
};


export type MutationUpdateAcademicSessionsArgs = {
  data: AcademicSessionsUpdateInput;
  where: AcademicSessionsWhereInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereInput;
};


export type MutationUpdateAssetMetadataArgs = {
  data: AssetMetadataUpdateInput;
  where: AssetWhereInput;
};


export type MutationUpdateAssetTagArgs = {
  data: AssetTagUpdateInput;
  where: AssetTagWhereInput;
};


export type MutationUpdateAssetVersionArgs = {
  data: AssetVersionUpdateInput;
  where: AssetWhereInput;
};


export type MutationUpdateAzsappClassroomSettingExposeLetterBooksArgs = {
  data: Array<UpdateAzsappClassroomSettingExposeLetterBooksInput>;
};


export type MutationUpdateClassroomArgs = {
  data: ClassroomUpdateInput;
  where: ClassroomWhereInput;
};


export type MutationUpdateClassroomSettingArgs = {
  data: ClassroomSettingUpdateInput;
  where: ClassroomSettingWhereInput;
};


export type MutationUpdateClassroomSettingsArgs = {
  data: ClassroomSettingsUpdateInput;
  where: ClassroomSettingsWhereInput;
};


export type MutationUpdateClassroomsArgs = {
  data: ClassroomsUpdateInput;
  where: ClassroomsWhereInput;
};


export type MutationUpdateContactArgs = {
  data: ContactUpdateInput;
  where: ContactWhereInput;
};


export type MutationUpdateContactsArgs = {
  data: ContactUpdateInput;
  where: ContactsWhereInput;
};


export type MutationUpdateCourseArgs = {
  data: CourseUpdateInput;
  where: CourseWhereInput;
};


export type MutationUpdateCourseMetadataArgs = {
  data: AssetMetadataUpdateInput;
  where: CourseWhereInput;
};


export type MutationUpdateCourseVersionArgs = {
  data: AssetVersionUpdateInput;
  where: CourseWhereInput;
};


export type MutationUpdateFeatureToggleArgs = {
  data: FeatureToggleUpdateInput;
  where: FeatureToggleWhereInput;
};


export type MutationUpdateFeatureTogglesArgs = {
  data: FeatureToggleUpdateInput;
  where: FeatureTogglesWhereInput;
};


export type MutationUpdateGroupArgs = {
  data: GroupUpdateInput;
};


export type MutationUpdateGssClassroomSettingCharacterOrderArgs = {
  data: Array<UpdateGssClassroomSettingCharacterOrderInput>;
};


export type MutationUpdateGssClassroomSettingLanguageArgs = {
  data: Array<UpdateGssClassroomSettingLocaleInput>;
};


export type MutationUpdateGssClassroomSettingLeftHandednessArgs = {
  data: Array<UpdateGssClassroomSettingLeftHandednessInput>;
};


export type MutationUpdateGssStudentSettingCharacterOrderArgs = {
  data: Array<UpdateGssStudentSettingCharacterOrderInput>;
};


export type MutationUpdateGssStudentSettingLanguageArgs = {
  data: Array<UpdateGssStudentSettingLocaleInput>;
};


export type MutationUpdateGssStudentSettingLeftHandednessArgs = {
  data: Array<UpdateGssStudentSettingLeftHandednessInput>;
};


export type MutationUpdateHwtClassroomSettingLanguageArgs = {
  data: Array<UpdateHwtClassroomSettingLocaleInput>;
};


export type MutationUpdateHwtStudentSettingLanguageArgs = {
  data: Array<UpdateHwtStudentSettingLocaleInput>;
};


export type MutationUpdateKeyClassroomAssessmentAcceleratorModulesArgs = {
  data: UpdateKeyClassroomSettingAssessmentAcceleratorInput;
};


export type MutationUpdateKeyClassroomSettingAssessmentsArgs = {
  data: UpdateKeyClassroomSettingScheduledActivityInput;
};


export type MutationUpdateKeyClassroomSettingEnrichmentActivitiesArgs = {
  data: UpdateKeyClassroomSettingEnrichmentInput;
};


export type MutationUpdateKeyClassroomSettingHomeUseArgs = {
  data: UpdateKeyClassroomSettingHomeUseInput;
};


export type MutationUpdateKeyClassroomSettingSkipJumpInArgs = {
  data: Array<UpdateKeyClassroomSettingSkipJumpInInput>;
};


export type MutationUpdateKeyClassroomSettingStopAndReviewArgs = {
  data: Array<UpdateKeyClassroomSettingStopAndReviewInput>;
};


export type MutationUpdateKeyStudentSettingHomeUseArgs = {
  data: Array<UpdateKeyStudentSettingHomeUseInput>;
};


export type MutationUpdateKeyStudentSettingOneHandedTypingHandArgs = {
  data: Array<UpdateKeyStudentSettingOneHandedTypingHandInput>;
};


export type MutationUpdateKeyStudentSettingSkipJumpInArgs = {
  data: Array<UpdateKeyStudentSettingSkipJumpInInput>;
};


export type MutationUpdateKeyStudentSettingStopAndReviewArgs = {
  data: Array<UpdateKeyStudentSettingStopAndReviewInput>;
};


export type MutationUpdateLicenseArgs = {
  data: LicenseUpdateInput;
  where: LicenseWhereInput;
};


export type MutationUpdateLicensesArgs = {
  data: LicenseUpdateInput;
  where: LicensesWhereInput;
};


export type MutationUpdateMeArgs = {
  data: UserUpdateInput;
};


export type MutationUpdateOrganizationArgs = {
  data: OrganizationUpdateInput;
  where: OrganizationWhereInput;
};


export type MutationUpdateOrganizationsArgs = {
  data: OrganizationsUpdateInput;
  where: OrganizationsWhereInput;
};


export type MutationUpdatePliUserSettingArgs = {
  data: PliUserSettingInput;
};


export type MutationUpdateSiteLicenseArgs = {
  data: SiteLicenseUpdateInput;
  where: SiteLicenseWhereInput;
};


export type MutationUpdateSiteLicensesArgs = {
  data: SiteLicenseUpdateInput;
  where: SiteLicensesWhereInput;
};


export type MutationUpdateStudentArgs = {
  data: StudentUpdateInput;
  where: StudentWhereInput;
};


export type MutationUpdateStudentSettingArgs = {
  data: StudentSettingUpdateInput;
  where: StudentSettingWhereInput;
};


export type MutationUpdateStudentSettingsArgs = {
  data: StudentSettingsUpdateInput;
  where: StudentSettingsWhereInput;
};


export type MutationUpdateStudentsArgs = {
  data: StudentsUpdateInput;
  where: StudentsWhereInput;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereInput;
};


export type MutationUpdateUserSettingArgs = {
  data: UserSettingUpdateInput;
  where: UserSettingWhereInput;
};


export type MutationUpdateUserSettingPliOnboardingWelcomeArgs = {
  data: PliUserOnboardingWelcomeDataInput;
};


export type MutationUpdateUserSettingsArgs = {
  data: UserSettingsUpdateInput;
  where: UserSettingsWhereInput;
};


export type MutationUpdateUsersArgs = {
  data: UsersUpdateInput;
  where: UsersWhereInput;
};


export type MutationUpdateWdtClassroomSettingCharacterOrderArgs = {
  data: Array<UpdateWdtClassroomSettingCharacterOrderInput>;
};


export type MutationUpdateWdtClassroomSettingLeftHandednessArgs = {
  data: Array<UpdateWdtClassroomSettingLeftHandednessInput>;
};


export type MutationUpdateWdtStudentSettingCharacterOrderArgs = {
  data: Array<UpdateWdtStudentSettingCharacterOrderInput>;
};


export type MutationUpdateWdtStudentSettingLeftHandednessArgs = {
  data: Array<UpdateWdtStudentSettingLeftHandednessInput>;
};


export type MutationUploadBulkImportFileArgs = {
  data: BulkImportFileUploadInput;
};

export type Offset = {
  __typename?: 'Offset';
  bottom?: Maybe<Scalars['Int']>;
  left?: Maybe<Scalars['Int']>;
  right?: Maybe<Scalars['Int']>;
  top?: Maybe<Scalars['Int']>;
};

export type Order = {
  __typename?: 'Order';
  cmsCustomerNumber?: Maybe<Scalars['String']>;
  crmNumber?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  dateFulfilled?: Maybe<Scalars['DateTime']>;
  dateOrdered: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  ecmsOrderNumber?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemFulfillmentNumber?: Maybe<Scalars['String']>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orderItems?: Maybe<Array<OrderItem>>;
  orderNumber?: Maybe<Scalars['String']>;
  parentOrder?: Maybe<Order>;
  parentOrderId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};


export type OrderMastercodesArgs = {
  where?: InputMaybe<MastercodesWhereInput>;
};

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  dateCreated: Scalars['DateTime'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  licenseCount: Scalars['Int'];
  licenseType: LicenseType;
  licenseTypeId: Scalars['Int'];
  licenses?: Maybe<Array<License>>;
  lineId?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['Int']>;
  mastercode?: Maybe<Mastercode>;
  mastercodeId: Scalars['Int'];
  multiyearTerm?: Maybe<Scalars['Int']>;
  order: Order;
  orderId: Scalars['Int'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  siteLicense?: Maybe<SiteLicense>;
  siteLicenseRangeMax?: Maybe<Scalars['Int']>;
  siteLicenseRangeMin?: Maybe<Scalars['Int']>;
};


export type OrderItemDateExpirationArgs = {
  where?: InputMaybe<OrderItemDateExpirationInput>;
};

export type OrderItemDateExpirationInput = {
  dateUnlocked?: InputMaybe<Scalars['DateTime']>;
};

export type OrderItemProvisioningResult = {
  __typename?: 'OrderItemProvisioningResult';
  dateExpiration?: Maybe<Scalars['DateTime']>;
  licenseCount: Scalars['Int'];
  orderItem?: Maybe<OrderItem>;
  orderItemId: Scalars['Int'];
};

export enum OrderOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_FULFILLED = 'DATE_FULFILLED',
  DATE_ORDERED = 'DATE_ORDERED',
  DATE_REMOVED = 'DATE_REMOVED',
  ID = 'ID',
  ITEM_FULFILLMENT_NUMBER = 'ITEM_FULFILLMENT_NUMBER',
  ORDER_NUMBER = 'ORDER_NUMBER',
  TYPE = 'TYPE',
  WEBSTORE_ORDER_NUMBER = 'WEBSTORE_ORDER_NUMBER'
}

export type OrderWhereInput = {
  id: Scalars['Int'];
  ownerEmail?: InputMaybe<Scalars['String']>;
};

export type OrdersOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrderOrderField>;
};

export type OrdersWhereInput = {
  AND?: InputMaybe<Array<OrdersWhereInput>>;
  OR?: InputMaybe<Array<OrdersWhereInput>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  ecmsOrderNumber?: InputMaybe<Array<Scalars['String']>>;
  excludeTrialType?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  itemFulfillmentNumber?: InputMaybe<Array<Scalars['String']>>;
  mastercode?: InputMaybe<Array<Scalars['String']>>;
  mastercodeId?: InputMaybe<Array<Scalars['Int']>>;
  orderNumber?: InputMaybe<Array<Scalars['String']>>;
  ownerEmail?: InputMaybe<Array<Scalars['String']>>;
  ownerEmail_contains?: InputMaybe<Scalars['String']>;
  parentOrderNumber?: InputMaybe<Array<Scalars['String']>>;
  products?: InputMaybe<ProductsWhereInput>;
  type?: InputMaybe<Array<Scalars['String']>>;
  type_contains?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export type Organization = {
  __typename?: 'Organization';
  academicSessions?: Maybe<Array<Maybe<AcademicSession>>>;
  address?: Maybe<Scalars['String']>;
  ancestorMastercodes?: Maybe<Array<Mastercode>>;
  ancestorOrganizations?: Maybe<Array<Maybe<Organization>>>;
  city?: Maybe<Scalars['String']>;
  classrooms?: Maybe<Array<Classroom>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  externalId?: Maybe<ExternalId>;
  id: Scalars['Int'];
  licenseUsage?: Maybe<Array<OrganizationLicenseUsage>>;
  licenses?: Maybe<Array<License>>;
  mastercodes?: Maybe<Array<Mastercode>>;
  mdrNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ncesId?: Maybe<Scalars['String']>;
  organizationTypeId?: Maybe<Scalars['Int']>;
  parentOrganization?: Maybe<Organization>;
  parentOrganizationId?: Maybe<Scalars['Int']>;
  rootOrganization?: Maybe<Organization>;
  settings?: Maybe<Array<OrganizationSetting>>;
  sisId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stats: OrganizationStats;
  subOrganizations?: Maybe<Array<Maybe<Organization>>>;
  type: OrganizationType;
  users?: Maybe<Array<UserOrganization>>;
  zip?: Maybe<Scalars['String']>;
};


export type OrganizationAcademicSessionsArgs = {
  orderBy?: InputMaybe<AcademicSessionsOrderInput>;
  where?: InputMaybe<AcademicSessionsWhereInput>;
};


export type OrganizationAncestorMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  where?: InputMaybe<MastercodesWhereInput>;
};


export type OrganizationAncestorOrganizationsArgs = {
  maxHeight?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrganizationsOrderInput>;
  where?: InputMaybe<OrganizationsWhereInput>;
};


export type OrganizationLicenseUsageArgs = {
  where?: InputMaybe<LicenseUsageWhereInput>;
};


export type OrganizationLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  where?: InputMaybe<LicensesWhereInput>;
};


export type OrganizationMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  where?: InputMaybe<MastercodesWhereInput>;
};


export type OrganizationSettingsArgs = {
  orderBy?: InputMaybe<OrganizationSettingsOrderInput>;
  where?: InputMaybe<OrganizationSettingsWhereInput>;
};


export type OrganizationSubOrganizationsArgs = {
  maxDepth?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrganizationsOrderInput>;
  where?: InputMaybe<OrganizationsWhereInput>;
};


export type OrganizationUsersArgs = {
  where?: InputMaybe<UserOrganizationWhereInput>;
};

export type OrganizationCreateInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  mdrNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  ncesId?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type: OrganizationType;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationInvite = {
  organizationName: Scalars['String'];
  organizationRole?: InputMaybe<Scalars['String']>;
};

export type OrganizationLicenseUsage = {
  __typename?: 'OrganizationLicenseUsage';
  assignedCount: Scalars['Int'];
  availableCount: Scalars['Int'];
  classroomAssignedCount: Scalars['Int'];
  expiringCount: Scalars['Int'];
  inUseCount: Scalars['Int'];
  organizationId: Scalars['Int'];
  overageStats?: Maybe<OrganizationLicenseUsageOverageStats>;
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  siteLicensed: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type OrganizationLicenseUsageOverageStats = {
  __typename?: 'OrganizationLicenseUsageOverageStats';
  assignedCount: Scalars['Int'];
  availableCount: Scalars['Int'];
  expiringCount: Scalars['Int'];
  overageLimitCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum OrganizationOrderField {
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION_TYPE_ID = 'ORGANIZATION_TYPE_ID',
  PARENT_ORGANIZATION_ID = 'PARENT_ORGANIZATION_ID',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID'
}

export type OrganizationPrivilege = {
  __typename?: 'OrganizationPrivilege';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  public: Scalars['Boolean'];
};

export enum OrganizationPrivilegeOrderField {
  ID = 'ID',
  NAME = 'NAME'
}

export type OrganizationPrivilegeWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationPrivilegesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationPrivilegeOrderField>;
};

export type OrganizationPrivilegesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  classification: OrganizationRoleClassification;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']>;
  privileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  public: Scalars['Boolean'];
};

export enum OrganizationRoleClassification {
  ADMIN = 'ADMIN',
  AUDITOR = 'AUDITOR',
  FACULTY = 'FACULTY'
}

export enum OrganizationRoleOrderField {
  APP = 'APP',
  ID = 'ID',
  NAME = 'NAME',
  ORGANIZATION = 'ORGANIZATION'
}

export type OrganizationRoleWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationRolesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationRoleOrderField>;
};

export type OrganizationRolesWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  classification?: InputMaybe<Array<OrganizationRoleClassification>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  app?: Maybe<App>;
  appId?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  organization: Organization;
  organizationId: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['JSON'];
};

export enum OrganizationSettingOrderField {
  APP_ID = 'APP_ID',
  ORGANIZATION_ID = 'ORGANIZATION_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING'
}

export type OrganizationSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
};

export type OrganizationSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationSettingOrderField>;
};

export type OrganizationSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
};

export type OrganizationStats = {
  __typename?: 'OrganizationStats';
  classroomCount: Scalars['Int'];
  classroomStudentCount: Scalars['Int'];
  classroomUserCount: Scalars['Int'];
  enrolledStudentCount: Scalars['Int'];
  studentCount: Scalars['Int'];
  userCount: Scalars['Int'];
};

export enum OrganizationType {
  DEPARTMENT = 'DEPARTMENT',
  DISTRICT = 'DISTRICT',
  LOCAL = 'LOCAL',
  NATIONAL = 'NATIONAL',
  SCHOOL = 'SCHOOL',
  STATE = 'STATE',
  USER_GROUP = 'USER_GROUP'
}

export type OrganizationUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  mdrNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ncesId?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['Int']>;
  sisId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OrganizationType>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type OrganizationsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<OrganizationOrderField>;
};

export type OrganizationsUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  parentOrganizationId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OrganizationType>;
};

export type OrganizationsWhereInput = {
  AND?: InputMaybe<Array<OrganizationsWhereInput>>;
  OR?: InputMaybe<Array<OrganizationsWhereInput>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  isRootOrganization?: InputMaybe<Scalars['Boolean']>;
  mdrNumber?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  nsecId?: InputMaybe<Array<Scalars['String']>>;
  parentOrganization?: InputMaybe<OrganizationsWhereInput>;
  sisId?: InputMaybe<Array<Scalars['String']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  type?: InputMaybe<Array<OrganizationType>>;
};

export type PagedAssets = {
  __typename?: 'PagedAssets';
  assets: Array<Maybe<Asset>>;
  totalCount: Scalars['Int'];
};

export type PagedCourses = {
  __typename?: 'PagedCourses';
  courses: Array<Maybe<Course>>;
  totalCount: Scalars['Int'];
};

export type PagingInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum Placement {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export type PliClassroomSettingsWhereInput = {
  classroomId: Scalars['Int'];
};

export enum PliOnboardingSettingValueKeys {
  viewedWelcome = 'viewedWelcome'
}

export type PliStudentSettingsWhereInput = {
  studentId: Scalars['Int'];
};

export type PliUserOnboardingWelcomeDataInput = {
  value: Scalars['Boolean'];
};

export enum PliUserSetting {
  onboarding = 'onboarding'
}

export type PliUserSettingInput = {
  setting: Scalars['String'];
  value?: InputMaybe<Scalars['JSON']>;
};

export type Position = {
  __typename?: 'Position';
  offset?: Maybe<Offset>;
  placement?: Maybe<Placement>;
};

export type PrmActiveStudentsReportResult = {
  __typename?: 'PrmActiveStudentsReportResult';
  activeStudentCount: Scalars['Int'];
  totalStudentCount: Scalars['Int'];
};

export type PrmActiveStudentsReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type PrmClassroomCurriculumProgress = PrmCurriculumLessonProgress & {
  __typename?: 'PrmClassroomCurriculumProgress';
  averageLessonAssignedCount: Scalars['Int'];
  averageLessonCompletedCount: Scalars['Int'];
  classroom?: Maybe<Classroom>;
  classroomId: Scalars['Int'];
  overallCompletionStats: PrmLessonCompletionStats;
  totalLessonCount: Scalars['Int'];
};

export type PrmClassroomEngagementCurriculumReportResult = {
  __typename?: 'PrmClassroomEngagementCurriculumReportResult';
  classroomCurriculumProgress: Array<PrmClassroomCurriculumProgress>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId: Scalars['Int'];
};

export type PrmClassroomEngagementCurriculumReportWhereInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  productCurriculumId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type PrmClassroomEngagementOverviewReportResult = {
  __typename?: 'PrmClassroomEngagementOverviewReportResult';
  classroomOverviews: Array<PrmClassroomOverview>;
};

export type PrmClassroomEngagementOverviewReportWhereInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type PrmClassroomOverview = {
  __typename?: 'PrmClassroomOverview';
  activeStudentCount: Scalars['Int'];
  averageLessonTimeSpentSeconds?: Maybe<Scalars['Int']>;
  classroom?: Maybe<Classroom>;
  classroomId: Scalars['Int'];
  overallProgressPercentage?: Maybe<Scalars['Float']>;
  totalStudentCount: Scalars['Int'];
};

export type PrmCurriculumLessonDetail = {
  __typename?: 'PrmCurriculumLessonDetail';
  averageTimeSpentSeconds?: Maybe<Scalars['Int']>;
  completionStats?: Maybe<PrmLessonCompletionStats>;
  lesson?: Maybe<PrmLesson>;
  lessonId: Scalars['Int'];
};

export type PrmCurriculumLessonProgress = {
  averageLessonAssignedCount: Scalars['Int'];
  averageLessonCompletedCount: Scalars['Int'];
  totalLessonCount: Scalars['Int'];
};

export type PrmCurriculumLessonReportResult = PrmCurriculumLessonProgress & {
  __typename?: 'PrmCurriculumLessonReportResult';
  averageLessonAssignedCount: Scalars['Int'];
  averageLessonCompletedCount: Scalars['Int'];
  lessons: Array<PrmCurriculumLessonDetail>;
  overallCompletionStats: PrmLessonCompletionStats;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId: Scalars['Int'];
  totalLessonCount: Scalars['Int'];
};

export type PrmCurriculumLessonReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  productCurriculumId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type PrmCurriculumProgress = PrmCurriculumLessonProgress & {
  __typename?: 'PrmCurriculumProgress';
  averageLessonAssignedCount: Scalars['Int'];
  averageLessonCompletedCount: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId: Scalars['Int'];
  totalLessonCount: Scalars['Int'];
};

export type PrmCurriculumProgressReportResult = {
  __typename?: 'PrmCurriculumProgressReportResult';
  curriculums: Array<PrmCurriculumProgress>;
  overallProgressPercentage: Scalars['Float'];
};

export type PrmCurriculumProgressReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type PrmLesson = {
  __typename?: 'PrmLesson';
  id: Scalars['Int'];
  lessonNumber: Scalars['Int'];
  primarySkillPhonics?: Maybe<Scalars['String']>;
  primarySkillWordStudy?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PrmLessonCompletionStats = {
  __typename?: 'PrmLessonCompletionStats';
  metSkillPercentage: Scalars['Float'];
  metSkillWithSupportPercentage: Scalars['Float'];
  metSkillWithoutSupportPercentage: Scalars['Float'];
  unmetSkillPercentage: Scalars['Float'];
};

export type PrmOrganizationCurriculumProgress = PrmCurriculumLessonProgress & {
  __typename?: 'PrmOrganizationCurriculumProgress';
  averageLessonAssignedCount: Scalars['Int'];
  averageLessonCompletedCount: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  overallCompletionStats: PrmLessonCompletionStats;
  totalLessonCount: Scalars['Int'];
};

export type PrmOrganizationEngagementCurriculumReportResult = {
  __typename?: 'PrmOrganizationEngagementCurriculumReportResult';
  organizationCurriculumProgress: Array<PrmOrganizationCurriculumProgress>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId: Scalars['Int'];
};

export type PrmOrganizationEngagementCurriculumReportWhereInput = {
  organizationId: Scalars['Int'];
  productCurriculumId: Scalars['Int'];
};

export type PrmOrganizationEngagementOverviewReportResult = {
  __typename?: 'PrmOrganizationEngagementOverviewReportResult';
  organizationOverviews: Array<PrmOrganizationOverview>;
};

export type PrmOrganizationEngagementOverviewReportWhereInput = {
  organizationId: Scalars['Int'];
};

export type PrmOrganizationOverview = {
  __typename?: 'PrmOrganizationOverview';
  activeStudentCount: Scalars['Int'];
  averageLessonTimeSpentSeconds?: Maybe<Scalars['Int']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  overallProgressPercentage?: Maybe<Scalars['Float']>;
  totalStudentCount: Scalars['Int'];
};

export type PrmStudentCurriculumDetail = {
  __typename?: 'PrmStudentCurriculumDetail';
  currentLesson?: Maybe<PrmLesson>;
  currentLessonId?: Maybe<Scalars['Int']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lessonAssignedCount: Scalars['Int'];
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId: Scalars['Int'];
  totalLessonCount: Scalars['Int'];
};

export type PrmStudentCurriculumLessonReportResult = {
  __typename?: 'PrmStudentCurriculumLessonReportResult';
  curriculumDetail?: Maybe<PrmStudentCurriculumDetail>;
  lessonDetail?: Maybe<PrmStudentLessonDetail>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type PrmStudentCurriculumLessonReportWhereInput = {
  studentId: Scalars['Int'];
};

export type PrmStudentCurriculumProgress = {
  __typename?: 'PrmStudentCurriculumProgress';
  lessonCompletionStats?: Maybe<PrmStudentLessonCompletionStats>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type PrmStudentEngagementReportResult = {
  __typename?: 'PrmStudentEngagementReportResult';
  studentCurriculumProgress: Array<PrmStudentCurriculumProgress>;
};

export type PrmStudentEngagementReportWhereInput = {
  classroomId: Scalars['Int'];
};

export type PrmStudentLessonCompletionStats = {
  __typename?: 'PrmStudentLessonCompletionStats';
  metSkillWithSupportCount: Scalars['Int'];
  metSkillWithoutSupportCount: Scalars['Int'];
  unmetSkillCount: Scalars['Int'];
};

export type PrmStudentLessonDetail = {
  __typename?: 'PrmStudentLessonDetail';
  averageLessonTimeSpentSeconds?: Maybe<Scalars['Int']>;
  lessons: Array<PrmStudentLessonProgress>;
};

export type PrmStudentLessonProgress = {
  __typename?: 'PrmStudentLessonProgress';
  lesson?: Maybe<PrmLesson>;
  lessonId: Scalars['Int'];
  metSkill?: Maybe<Scalars['Boolean']>;
  timeSpentSeconds?: Maybe<Scalars['Int']>;
  usedSupport?: Maybe<Scalars['Boolean']>;
};

export type Product = {
  __typename?: 'Product';
  bannerUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color: Scalars['String'];
  curriculums?: Maybe<Array<ProductCurriculum>>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  family: ProductFamily;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  trialAvailable: Scalars['Boolean'];
  type: ProductType;
};

export type ProductBundle = {
  __typename?: 'ProductBundle';
  code: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  products: Array<Maybe<Product>>;
};

export enum ProductBundleOrderField {
  CODE = 'CODE',
  DATE_CREATED = 'DATE_CREATED',
  DATE_UPDATED = 'DATE_UPDATED',
  ID = 'ID',
  NAME = 'NAME'
}

export type ProductBundleWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductBundlesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductBundleOrderField>;
};

export type ProductBundlesWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductCurriculum = {
  __typename?: 'ProductCurriculum';
  bannerUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  defaultGradeLevel?: Maybe<Array<Scalars['String']>>;
  gradeLevel?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  product?: Maybe<Product>;
  productId: Scalars['Int'];
  trialAvailable: Scalars['Boolean'];
};

export type ProductCurriculumActivitiesCompleted = {
  __typename?: 'ProductCurriculumActivitiesCompleted';
  activitiesCompletedCount: Scalars['Int'];
  productCurriculumCode: Scalars['String'];
};

export type ProductCurriculumAverageWeeklyTimeSpent = {
  __typename?: 'ProductCurriculumAverageWeeklyTimeSpent';
  averageWeeklyMinutesSpent: Scalars['Float'];
  productCurriculumCode: Scalars['String'];
};

export enum ProductCurriculumOrderField {
  CODE = 'CODE',
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_ID = 'PRODUCT_ID',
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE'
}

export type ProductCurriculumWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductCurriculumsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductCurriculumOrderField>;
};

export type ProductCurriculumsWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  product?: InputMaybe<ProductsWhereInput>;
  trialAvailable?: InputMaybe<Array<Scalars['Boolean']>>;
  type?: InputMaybe<Array<ProductType>>;
};

export type ProductFamiliesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductFamilyOrderField>;
};

export type ProductFamiliesWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  pliManaged?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<ProductType>>;
};

export type ProductFamily = {
  __typename?: 'ProductFamily';
  bannerUrl?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  pliManaged?: Maybe<Scalars['Boolean']>;
  products: Array<Maybe<Product>>;
  types: Array<Maybe<ProductType>>;
};

export type ProductFamilyAccessDetails = {
  __typename?: 'ProductFamilyAccessDetails';
  bannerUrl: Scalars['String'];
  iosUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum ProductFamilyOrderField {
  CODE = 'CODE',
  ID = 'ID',
  NAME = 'NAME'
}

export type ProductFamilyPurchaseDetails = {
  __typename?: 'ProductFamilyPurchaseDetails';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ProductFamilyWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductIdentifierInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export enum ProductOrderField {
  CODE = 'CODE',
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_FAMILY_ID = 'PRODUCT_FAMILY_ID',
  TRIAL_AVAILABLE = 'TRIAL_AVAILABLE'
}

export enum ProductType {
  STUDENT = 'STUDENT',
  USER = 'USER'
}

export type ProductWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<ProductOrderField>;
};

export type ProductsWhereInput = {
  code?: InputMaybe<Array<Scalars['String']>>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  productFamilyId?: InputMaybe<Array<Scalars['Int']>>;
  trialAvailable?: InputMaybe<Array<Scalars['Boolean']>>;
  type?: InputMaybe<Array<ProductType>>;
};

export type ProvisioningResult = {
  __typename?: 'ProvisioningResult';
  fail?: Maybe<Array<OrderItemProvisioningResult>>;
  success?: Maybe<Array<OrderItemProvisioningResult>>;
};

export type Query = {
  __typename?: 'Query';
  _dummyCore?: Maybe<Scalars['Boolean']>;
  _dummyFulfillment?: Maybe<Scalars['Boolean']>;
  _dummyLicenseManager?: Maybe<Scalars['Boolean']>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSession?: Maybe<AcademicSession>;
  /**
   * - Required privileges:
   *   - academic-session.read
   */
  academicSessions: Array<Maybe<AcademicSession>>;
  apps: Array<Maybe<App>>;
  asset?: Maybe<Asset>;
  assetChanges?: Maybe<Array<AssetChange>>;
  assetMetadata: AssetMetadata;
  assetTags?: Maybe<Array<AssetTag>>;
  assetVersions: Array<AssetVersion>;
  assets: Array<Maybe<Asset>>;
  availableLicenses: Array<Maybe<License>>;
  azsappClassroomSettings?: Maybe<AzsappClassroomSettings>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classroom?: Maybe<Classroom>;
  classroomPrivilege?: Maybe<ClassroomPrivilege>;
  classroomPrivileges?: Maybe<Array<Maybe<ClassroomPrivilege>>>;
  classroomRole?: Maybe<ClassroomRole>;
  classroomRoles?: Maybe<Array<Maybe<ClassroomRole>>>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSetting?: Maybe<ClassroomSetting>;
  /**
   * - Required privileges:
   *   - classroom-setting.read
   */
  classroomSettings: Array<Maybe<ClassroomSetting>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  classrooms?: Maybe<Array<Classroom>>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contact?: Maybe<Contact>;
  /**
   * - Required privileges:
   *   - contact.read
   */
  contacts: Array<Maybe<Contact>>;
  course?: Maybe<Course>;
  courseMetadata: AssetMetadata;
  courseVersions: Array<AssetVersion>;
  courses: Array<Maybe<Course>>;
  defaultGroupSettings?: Maybe<Array<DefaultGroupSetting>>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollment?: Maybe<Enrollment>;
  /**
   * - Required privileges:
   *   - classroom.read
   */
  enrollments?: Maybe<Array<Maybe<Enrollment>>>;
  featureToggle?: Maybe<FeatureToggle>;
  featureToggles: Array<Maybe<FeatureToggle>>;
  group?: Maybe<Group>;
  groupCategories: Array<Maybe<GroupCategory>>;
  groupCategory?: Maybe<GroupCategory>;
  groupEnrollment?: Maybe<GroupEnrollment>;
  groupEnrollments: Array<Maybe<GroupEnrollment>>;
  groups: Array<Maybe<Group>>;
  gssClassroomSettings?: Maybe<GssClassroomSettings>;
  gssStudentSettings?: Maybe<GssStudentSettings>;
  hwtClassroomSettings?: Maybe<HwtClassroomSettings>;
  hwtStudentSettings?: Maybe<HwtStudentSettings>;
  keyActiveStudentsReport: KeyActiveStudentsReportResult;
  keyActiveStudentsReportAsync: KeyActiveStudentsReportAsyncResult;
  keyActivitiesCompletedAndTimeSpentReport: KeyActivitiesCompletedAndTimeSpentReportResult;
  keyActivitiesCompletedReport: KeyActivitiesCompletedReportResult;
  keyActivitiesCompletedReportAsync: KeyActivitiesCompletedReportAsyncResult;
  keyAssessmentAndEnrichmentActivityReport: KeyAssessmentAndEnrichmentActivityReportResult;
  keyAverageWeeklyTimeSpentReport: KeyAverageWeeklyTimeSpentReportResult;
  keyAverageWeeklyTimeSpentReportAsync: KeyAverageWeeklyTimeSpentReportAsyncResult;
  keyClassroomEngagementReport?: Maybe<KeyClassroomEngagementReportResult>;
  keyClassroomEngagementReportAsync: KeyClassroomEngagementReportAsyncResult;
  keyClassroomExportReport: KeyOrganizationClassroomEngagementReportResult;
  keyClassroomSettings?: Maybe<KeyClassroomSettings>;
  keyCurriculumProgressReport?: Maybe<KeyCurriculumProgressReportResult>;
  keyCurriculumProgressReportAsync: KeyCurriculumProgressReportAsyncResult;
  keyOrganizationClassroomEngagementReport?: Maybe<Array<KeyOrganizationClassroomEngagementReportResult>>;
  keyOrganizationClassroomEngagementReportAsync: KeyOrganizationClassroomEngagementReportAsyncResult;
  keyOrganizationEngagementReport?: Maybe<Array<KeyOrganizationEngagementReportResult>>;
  keyOrganizationEngagementReportAsync: KeyOrganizationEngagementReportAsyncResult;
  keyOrganizationExportReport: KeyOrganizationEngagementReportResult;
  keyStudentEngagementReport: KeyStudentEngagementReportResult;
  keyStudentProgressReport: KeyStudentProgressReportResult;
  keyStudentSettings?: Maybe<KeyStudentSettings>;
  keyboardingCurriculum?: Maybe<KeyboardingCurriculum>;
  keyboardingCurriculums: Array<Maybe<KeyboardingCurriculum>>;
  keyboardingModule?: Maybe<KeyboardingModule>;
  keyboardingModules: Array<Maybe<KeyboardingModule>>;
  license?: Maybe<License>;
  licenses: Array<Maybe<License>>;
  mastercode?: Maybe<Mastercode>;
  mastercodeTransferHistories?: Maybe<Array<MastercodeTransferHistory>>;
  mastercodeTransferHistory?: Maybe<MastercodeTransferHistory>;
  mastercodes?: Maybe<Array<Mastercode>>;
  me?: Maybe<User>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Order>>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organization?: Maybe<Organization>;
  organizationPrivilege?: Maybe<OrganizationPrivilege>;
  organizationPrivileges?: Maybe<Array<Maybe<OrganizationPrivilege>>>;
  organizationRole?: Maybe<OrganizationRole>;
  organizationRoles?: Maybe<Array<Maybe<OrganizationRole>>>;
  organizationSetting?: Maybe<OrganizationSetting>;
  organizationSettings: Array<Maybe<OrganizationSetting>>;
  /**
   * - Required privileges:
   *   - organization.read
   */
  organizations: Array<Maybe<Organization>>;
  pagedAssets: PagedAssets;
  pagedCourses: PagedCourses;
  prmActiveStudentsReport?: Maybe<PrmActiveStudentsReportResult>;
  prmClassroomEngagementCurriculumReport?: Maybe<PrmClassroomEngagementCurriculumReportResult>;
  prmClassroomEngagementOverviewReport?: Maybe<PrmClassroomEngagementOverviewReportResult>;
  prmCurriculumLessonReport?: Maybe<PrmCurriculumLessonReportResult>;
  prmCurriculumProgressReport?: Maybe<PrmCurriculumProgressReportResult>;
  prmOrganizationEngagementCurriculumReport?: Maybe<PrmOrganizationEngagementCurriculumReportResult>;
  prmOrganizationEngagementOverviewReport?: Maybe<PrmOrganizationEngagementOverviewReportResult>;
  prmStudentCurriculumLessonReport?: Maybe<PrmStudentCurriculumLessonReportResult>;
  prmStudentEngagementReport?: Maybe<PrmStudentEngagementReportResult>;
  product?: Maybe<Product>;
  productBundle?: Maybe<ProductBundle>;
  productBundles: Array<Maybe<ProductBundle>>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculums: Array<ProductCurriculum>;
  productFamilies: Array<Maybe<ProductFamily>>;
  productFamily?: Maybe<ProductFamily>;
  products: Array<Maybe<Product>>;
  resource?: Maybe<Resource>;
  resourceFavorites: Array<Maybe<Resource>>;
  resourceType?: Maybe<ResourceType>;
  resourceTypes: Array<ResourceType>;
  resources: Array<Resource>;
  siteLicense?: Maybe<SiteLicense>;
  siteLicenses: Array<Maybe<SiteLicense>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  student?: Maybe<Student>;
  /**
   * - Required privileges:
   *   - student.read
   */
  studentSearch: Array<Student>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSetting?: Maybe<StudentSetting>;
  /**
   * - Required privileges:
   *   - student-setting.read
   */
  studentSettings: Array<Maybe<StudentSetting>>;
  /**
   * - Required privileges:
   *   - student.read
   */
  students: Array<Maybe<Student>>;
  supportCategories: Array<SupportCategory>;
  supportCategory?: Maybe<SupportCategory>;
  supportTopic?: Maybe<SupportTopic>;
  supportTopics: Array<SupportTopic>;
  tags: Array<Tag>;
  tour?: Maybe<Tour>;
  tourStep?: Maybe<TourStep>;
  tourSteps: Array<Maybe<TourStep>>;
  tours: Array<Maybe<Tour>>;
  toursSettings: Array<Maybe<TourSettings>>;
  /**
   * - Required privileges:
   *   - user.read
   */
  user?: Maybe<User>;
  /**
   * - Required privileges:
   *   - user.read
   */
  userSearch: Array<User>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSetting?: Maybe<UserSetting>;
  /**
   * - Required privileges:
   *   - user-setting.read
   */
  userSettings: Array<Maybe<UserSetting>>;
  /**
   * - Required privileges:
   *   - user.read
   */
  users: Array<User>;
  wdtActiveStudentsReport: WdtActiveStudentsReportResult;
  wdtCharactersCompletedAndTimeSpentReport: WdtCharactersCompletedAndTimeSpentReportResult;
  wdtClassroomErrorsByCharactersReport: WdtClassroomErrorsByCharactersReportResult;
  wdtClassroomErrorsByStudentsReport: WdtClassroomErrorsByStudentsReportResult;
  wdtClassroomOverallProgressReport: WdtClassroomOverallProgressReportResult;
  wdtClassroomProgressByCharactersReport: WdtClassroomProgressByCharactersReportResult;
  wdtClassroomProgressByStudentsReport: WdtClassroomProgressByStudentsReportResult;
  wdtClassroomSettings?: Maybe<WdtClassroomSettings>;
  wdtOverallErrorsReport: WdtOverallErrorsReportResult;
  wdtStudentErrorsReport: WdtStudentErrorsReportResult;
  wdtStudentOverallProgressReport: WdtStudentOverallProgressReportResult;
  wdtStudentProgressReport: WdtStudentProgressReportResult;
  wdtStudentSettings?: Maybe<WdtStudentSettings>;
};


export type QueryAcademicSessionArgs = {
  where: AcademicSessionWhereInput;
};


export type QueryAcademicSessionsArgs = {
  orderBy?: InputMaybe<AcademicSessionsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<AcademicSessionsWhereInput>;
};


export type QueryAssetArgs = {
  where: AssetWhereInput;
};


export type QueryAssetChangesArgs = {
  where?: InputMaybe<AssetChangesWhereInput>;
};


export type QueryAssetMetadataArgs = {
  where: AssetWhereInput;
};


export type QueryAssetTagsArgs = {
  orderBy?: InputMaybe<AssetTagsOrderInput>;
  where?: InputMaybe<AssetTagsWhereInput>;
};


export type QueryAssetVersionsArgs = {
  where: AssetWhereInput;
};


export type QueryAssetsArgs = {
  orderBy?: InputMaybe<AssetsOrderInput>;
  where: AssetsWhereInput;
};


export type QueryAvailableLicensesArgs = {
  where: FindAvailableLicenseWhereInput;
};


export type QueryAzsappClassroomSettingsArgs = {
  where: PliClassroomSettingsWhereInput;
};


export type QueryClassroomArgs = {
  where: ClassroomWhereInput;
};


export type QueryClassroomPrivilegeArgs = {
  where: ClassroomPrivilegeWhereInput;
};


export type QueryClassroomPrivilegesArgs = {
  orderBy?: InputMaybe<ClassroomPrivilegesOrderInput>;
  where?: InputMaybe<ClassroomPrivilegesWhereInput>;
};


export type QueryClassroomRoleArgs = {
  where: ClassroomRoleWhereInput;
};


export type QueryClassroomRolesArgs = {
  orderBy?: InputMaybe<ClassroomRolesOrderInput>;
  where?: InputMaybe<ClassroomRolesWhereInput>;
};


export type QueryClassroomSettingArgs = {
  where: ClassroomSettingWhereInput;
};


export type QueryClassroomSettingsArgs = {
  orderBy?: InputMaybe<ClassroomSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ClassroomSettingsWhereInput>;
};


export type QueryClassroomsArgs = {
  orderBy?: InputMaybe<ClassroomsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ClassroomsWhereInput>;
  whereUser?: InputMaybe<UsersWhereInput>;
};


export type QueryContactArgs = {
  where: ContactWhereInput;
};


export type QueryContactsArgs = {
  orderBy?: InputMaybe<ContactsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ContactsWhereInput>;
};


export type QueryCourseArgs = {
  where: CourseWhereInput;
};


export type QueryCourseMetadataArgs = {
  where: CourseWhereInput;
};


export type QueryCourseVersionsArgs = {
  where: CourseWhereInput;
};


export type QueryCoursesArgs = {
  orderBy?: InputMaybe<CoursesOrderInput>;
  where?: InputMaybe<CoursesWhereInput>;
};


export type QueryEnrollmentArgs = {
  where: EnrollmentWhereInput;
};


export type QueryEnrollmentsArgs = {
  orderBy?: InputMaybe<EnrollmentsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<EnrollmentsWhereInput>;
};


export type QueryFeatureToggleArgs = {
  where: FeatureToggleWhereInput;
};


export type QueryFeatureTogglesArgs = {
  orderBy?: InputMaybe<FeatureTogglesOrderInput>;
  where?: InputMaybe<FeatureTogglesWhereInput>;
};


export type QueryGroupArgs = {
  where: GroupWhereInput;
};


export type QueryGroupCategoriesArgs = {
  orderBy?: InputMaybe<GroupCategoriesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: GroupCategoriesWhereInput;
};


export type QueryGroupCategoryArgs = {
  where: GroupCategoryWhereInput;
};


export type QueryGroupEnrollmentArgs = {
  where: GroupEnrollmentWhereInput;
};


export type QueryGroupEnrollmentsArgs = {
  orderBy?: InputMaybe<GroupEnrollmentsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: GroupEnrollmentsWhereInput;
};


export type QueryGroupsArgs = {
  orderBy?: InputMaybe<GroupsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: GroupsWhereInput;
};


export type QueryGssClassroomSettingsArgs = {
  where: PliClassroomSettingsWhereInput;
};


export type QueryGssStudentSettingsArgs = {
  where: PliStudentSettingsWhereInput;
};


export type QueryHwtClassroomSettingsArgs = {
  where: PliClassroomSettingsWhereInput;
};


export type QueryHwtStudentSettingsArgs = {
  where: PliStudentSettingsWhereInput;
};


export type QueryKeyActiveStudentsReportArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyActiveStudentsReportAsyncArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyActivitiesCompletedAndTimeSpentReportArgs = {
  dateRange: DateRangeInput;
  where: KeyActivitiesCompletedAndTimeSpentReportWhereInput;
};


export type QueryKeyActivitiesCompletedReportArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyActivitiesCompletedReportAsyncArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyAssessmentAndEnrichmentActivityReportArgs = {
  dateRange: DateRangeInput;
  where: KeyAssessmentAndEnrichmentActivityReportWhereInput;
};


export type QueryKeyAverageWeeklyTimeSpentReportArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyAverageWeeklyTimeSpentReportAsyncArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyClassroomEngagementReportArgs = {
  dateRange: DateRangeInput;
  where: KeyClassroomEngagementReportWhereInput;
};


export type QueryKeyClassroomEngagementReportAsyncArgs = {
  dateRange: DateRangeInput;
  where: KeyClassroomEngagementReportWhereInput;
};


export type QueryKeyClassroomExportReportArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyClassroomSettingsArgs = {
  where: PliClassroomSettingsWhereInput;
};


export type QueryKeyCurriculumProgressReportArgs = {
  where: KeyReportWhereInput;
};


export type QueryKeyCurriculumProgressReportAsyncArgs = {
  where: KeyReportWhereInput;
};


export type QueryKeyOrganizationClassroomEngagementReportArgs = {
  dateRange: DateRangeInput;
  where: KeyOrganizationClassroomEngagementReportWhereInput;
};


export type QueryKeyOrganizationClassroomEngagementReportAsyncArgs = {
  dateRange: DateRangeInput;
  where: KeyOrganizationClassroomEngagementReportWhereInput;
};


export type QueryKeyOrganizationEngagementReportArgs = {
  dateRange: DateRangeInput;
  where: KeyOrganizationEngagementReportWhereInput;
};


export type QueryKeyOrganizationEngagementReportAsyncArgs = {
  dateRange: DateRangeInput;
  where: KeyOrganizationEngagementReportWhereInput;
};


export type QueryKeyOrganizationExportReportArgs = {
  dateRange: DateRangeInput;
  where: KeyReportWhereInput;
};


export type QueryKeyStudentEngagementReportArgs = {
  dateRange: DateRangeInput;
  where: KeyStudentEngagementReportWhereInput;
};


export type QueryKeyStudentProgressReportArgs = {
  dateRange: DateRangeInput;
  where: KeyStudentProgressReportWhereInput;
};


export type QueryKeyStudentSettingsArgs = {
  where: PliStudentSettingsWhereInput;
};


export type QueryKeyboardingCurriculumArgs = {
  where: KeyboardingCurriculumWhereInput;
};


export type QueryKeyboardingCurriculumsArgs = {
  orderBy?: InputMaybe<KeyboardingCurriculumOrderField>;
  where?: InputMaybe<KeyboardingCurriculumsWhereInput>;
};


export type QueryKeyboardingModuleArgs = {
  where: KeyboardingModuleWhereInput;
};


export type QueryKeyboardingModulesArgs = {
  orderBy?: InputMaybe<KeyboardingModuleOrderField>;
  where?: InputMaybe<KeyboardingModulesWhereInput>;
};


export type QueryLicenseArgs = {
  where: LicenseWhereInput;
};


export type QueryLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<LicensesWhereInput>;
};


export type QueryMastercodeArgs = {
  where: MastercodeWhereInput;
};


export type QueryMastercodeTransferHistoriesArgs = {
  orderBy?: InputMaybe<MastercodeTransferHistoryOrderInput>;
  where: MastercodeTransferHistoriesWhereInput;
};


export type QueryMastercodeTransferHistoryArgs = {
  where: MastercodeTransferHistoryWhereInput;
};


export type QueryMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where: MastercodesWhereInput;
};


export type QueryOrderArgs = {
  where: OrderWhereInput;
};


export type QueryOrdersArgs = {
  mastercodeWhere?: InputMaybe<MastercodesWhereInput>;
  orderBy?: InputMaybe<OrdersOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<OrdersWhereInput>;
};


export type QueryOrganizationArgs = {
  where: OrganizationWhereInput;
};


export type QueryOrganizationPrivilegeArgs = {
  where: OrganizationPrivilegeWhereInput;
};


export type QueryOrganizationPrivilegesArgs = {
  orderBy?: InputMaybe<OrganizationPrivilegesOrderInput>;
  where?: InputMaybe<OrganizationPrivilegesWhereInput>;
};


export type QueryOrganizationRoleArgs = {
  where: OrganizationRoleWhereInput;
};


export type QueryOrganizationRolesArgs = {
  orderBy?: InputMaybe<OrganizationRolesOrderInput>;
  where?: InputMaybe<OrganizationRolesWhereInput>;
};


export type QueryOrganizationSettingArgs = {
  where: OrganizationSettingWhereInput;
};


export type QueryOrganizationSettingsArgs = {
  orderBy?: InputMaybe<OrganizationSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<OrganizationSettingsWhereInput>;
};


export type QueryOrganizationsArgs = {
  orderBy?: InputMaybe<OrganizationsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<OrganizationsWhereInput>;
  whereUserOrganization?: InputMaybe<UserOrganizationInput>;
};


export type QueryPagedAssetsArgs = {
  orderBy?: InputMaybe<AssetsOrderInput>;
  paging: PagingInput;
  where: AssetsWhereInput;
};


export type QueryPagedCoursesArgs = {
  orderBy?: InputMaybe<CoursesOrderInput>;
  paging: PagingInput;
  where?: InputMaybe<CoursesWhereInput>;
};


export type QueryPrmActiveStudentsReportArgs = {
  where: PrmActiveStudentsReportWhereInput;
};


export type QueryPrmClassroomEngagementCurriculumReportArgs = {
  where: PrmClassroomEngagementCurriculumReportWhereInput;
};


export type QueryPrmClassroomEngagementOverviewReportArgs = {
  where: PrmClassroomEngagementOverviewReportWhereInput;
};


export type QueryPrmCurriculumLessonReportArgs = {
  where: PrmCurriculumLessonReportWhereInput;
};


export type QueryPrmCurriculumProgressReportArgs = {
  where: PrmCurriculumProgressReportWhereInput;
};


export type QueryPrmOrganizationEngagementCurriculumReportArgs = {
  where: PrmOrganizationEngagementCurriculumReportWhereInput;
};


export type QueryPrmOrganizationEngagementOverviewReportArgs = {
  where: PrmOrganizationEngagementOverviewReportWhereInput;
};


export type QueryPrmStudentCurriculumLessonReportArgs = {
  where: PrmStudentCurriculumLessonReportWhereInput;
};


export type QueryPrmStudentEngagementReportArgs = {
  where: PrmStudentEngagementReportWhereInput;
};


export type QueryProductArgs = {
  where: ProductWhereInput;
};


export type QueryProductBundleArgs = {
  where: ProductBundleWhereInput;
};


export type QueryProductBundlesArgs = {
  orderBy?: InputMaybe<ProductBundlesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductBundlesWhereInput>;
};


export type QueryProductCurriculumArgs = {
  where: ProductCurriculumWhereInput;
};


export type QueryProductCurriculumsArgs = {
  orderBy?: InputMaybe<ProductCurriculumsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductCurriculumsWhereInput>;
};


export type QueryProductFamiliesArgs = {
  orderBy?: InputMaybe<ProductFamiliesOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductFamiliesWhereInput>;
};


export type QueryProductFamilyArgs = {
  where: ProductFamilyWhereInput;
};


export type QueryProductsArgs = {
  orderBy?: InputMaybe<ProductsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<ProductsWhereInput>;
};


export type QueryResourceArgs = {
  where: ResourceWhereInput;
};


export type QueryResourceTypeArgs = {
  where: ResourceTypeWhereInput;
};


export type QueryResourceTypesArgs = {
  where?: InputMaybe<ResourceTypesWhereInput>;
};


export type QueryResourcesArgs = {
  where?: InputMaybe<ResourcesWhereInput>;
};


export type QuerySiteLicenseArgs = {
  where: SiteLicenseWhereInput;
};


export type QuerySiteLicensesArgs = {
  orderBy?: InputMaybe<SiteLicensesOrderInput>;
  where?: InputMaybe<SiteLicensesWhereInput>;
};


export type QueryStudentArgs = {
  where: StudentWhereInput;
};


export type QueryStudentSearchArgs = {
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  orderBy?: InputMaybe<StudentsOrderInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  paging?: InputMaybe<PagingInput>;
  searchFields?: InputMaybe<Array<StudentSearchField>>;
  searchText: Scalars['String'];
  where?: InputMaybe<StudentsWhereInput>;
};


export type QueryStudentSettingArgs = {
  where: StudentSettingWhereInput;
};


export type QueryStudentSettingsArgs = {
  orderBy?: InputMaybe<StudentSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<StudentSettingsWhereInput>;
};


export type QueryStudentsArgs = {
  orderBy?: InputMaybe<StudentsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<StudentsWhereInput>;
};


export type QuerySupportCategoriesArgs = {
  where?: InputMaybe<SupportCategoriesWhereInput>;
};


export type QuerySupportCategoryArgs = {
  where: SupportCategoryWhereInput;
};


export type QuerySupportTopicArgs = {
  where: SupportTopicWhereInput;
};


export type QuerySupportTopicsArgs = {
  where?: InputMaybe<SupportTopicsWhereInput>;
};


export type QueryTagsArgs = {
  where?: InputMaybe<TagsWhereInput>;
};


export type QueryTourArgs = {
  where: TourWhereInput;
};


export type QueryTourStepArgs = {
  where: TourStepWhereInput;
};


export type QueryTourStepsArgs = {
  where: TourStepsWhereInput;
};


export type QueryToursArgs = {
  orderBy?: InputMaybe<ToursOrderInput>;
  where: ToursWhereInput;
};


export type QueryToursSettingsArgs = {
  where: ToursSettingsWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereInput;
};


export type QueryUserSearchArgs = {
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  orderBy?: InputMaybe<UsersOrderInput>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  paging?: InputMaybe<PagingInput>;
  searchFields?: InputMaybe<Array<UserSearchField>>;
  searchText: Scalars['String'];
  where?: InputMaybe<UsersWhereInput>;
};


export type QueryUserSettingArgs = {
  where: UserSettingWhereInput;
};


export type QueryUserSettingsArgs = {
  orderBy?: InputMaybe<UserSettingsOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<UserSettingsWhereInput>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<UsersOrderInput>;
  paging?: InputMaybe<PagingInput>;
  where?: InputMaybe<UsersWhereInput>;
};


export type QueryWdtActiveStudentsReportArgs = {
  dateRange: DateRangeInput;
  where: WdtActiveStudentsReportWhereInput;
};


export type QueryWdtCharactersCompletedAndTimeSpentReportArgs = {
  dateRange: DateRangeInput;
  where: WdtCharactersCompletedAndTimeSpentReportWhereInput;
};


export type QueryWdtClassroomErrorsByCharactersReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtClassroomErrorsByCharactersReportWhereInput;
};


export type QueryWdtClassroomErrorsByStudentsReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtClassroomErrorsByStudentsReportWhereInput;
};


export type QueryWdtClassroomOverallProgressReportArgs = {
  where: WdtClassroomOverallProgressReportWhereInput;
};


export type QueryWdtClassroomProgressByCharactersReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtClassroomProgressByCharactersReportWhereInput;
};


export type QueryWdtClassroomProgressByStudentsReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtClassroomProgressByStudentsReportWhereInput;
};


export type QueryWdtClassroomSettingsArgs = {
  where: PliClassroomSettingsWhereInput;
};


export type QueryWdtOverallErrorsReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtOverallErrorsReportWhereInput;
};


export type QueryWdtStudentErrorsReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtStudentErrorsReportWhereInput;
};


export type QueryWdtStudentOverallProgressReportArgs = {
  where: WdtStudentOverallProgressReportWhereInput;
};


export type QueryWdtStudentProgressReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  where: WdtStudentProgressReportWhereInput;
};


export type QueryWdtStudentSettingsArgs = {
  where: PliStudentSettingsWhereInput;
};

export enum ReportIntervalUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type Resource = {
  __typename?: 'Resource';
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  favorite?: Maybe<ResourceFavorite>;
  grades?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  locale: Locale;
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productFamily?: Maybe<ProductFamily>;
  products?: Maybe<Array<Product>>;
  resourceAsset?: Maybe<Asset>;
  resourceAssetId?: Maybe<Scalars['Int']>;
  resourceTypeId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  thumbnailAsset: Asset;
  thumbnailAssetId: Scalars['Int'];
  title: Scalars['String'];
  type: ResourceType;
};

export type ResourceFavorite = {
  __typename?: 'ResourceFavorite';
  dateCreated: Scalars['DateTime'];
  id?: Maybe<Scalars['Int']>;
  resourceId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ResourceFavoriteCreateInput = {
  resourceId: Scalars['Int'];
};

export type ResourceFavoriteDeleteInput = {
  favoriteId: Scalars['Int'];
};

export enum ResourceOrderField {
  ID = 'ID',
  SORT_INDEX = 'SORT_INDEX',
  TITLE = 'TITLE'
}

export type ResourceType = {
  __typename?: 'ResourceType';
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  description: Scalars['String'];
  iconAsset: Asset;
  iconAssetId: Scalars['Int'];
  id: Scalars['Int'];
  imageAsset: Asset;
  imageAssetId: Scalars['Int'];
  sortIndex: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export enum ResourceTypeOrderField {
  ID = 'ID',
  SORT_INDEX = 'SORT_INDEX',
  TITLE = 'TITLE'
}

export type ResourceTypeWhereInput = {
  id: Scalars['Int'];
};

export type ResourceTypesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field?: InputMaybe<Array<ResourceTypeOrderField>>;
};

export type ResourceTypesWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ResourceWhereInput = {
  id: Scalars['Int'];
};

export type ResourcesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field?: InputMaybe<Array<ResourceOrderField>>;
};

export type ResourcesWhereInput = {
  grades?: InputMaybe<Array<Grade>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  productCodes?: InputMaybe<Array<Scalars['String']>>;
  resourceTypeId?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SaveTourSettingsInput = {
  tourId: Scalars['Int'];
  tourStepSettings: Array<SaveTourStepSettingInput>;
};

export type SaveTourStepSettingInput = {
  tourStepId: Scalars['Int'];
  viewed: Scalars['Boolean'];
};

export type SaveToursSettingsInput = {
  studentId?: InputMaybe<Scalars['Int']>;
  toursSettings: Array<SaveTourSettingsInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum ScheduledActivityScheduleType {
  CALENDAR = 'CALENDAR',
  CURRICULUM = 'CURRICULUM'
}

export type SendEmailInput = {
  message: Scalars['String'];
};

export type SendLicenseAssignmentEmailInput = {
  productNames?: InputMaybe<Array<Scalars['String']>>;
  recipient: InviteRecipient;
  sender: InviteSender;
};

export type SendSupportTicketInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topic: Scalars['String'];
};

export type SendUserInviteEmailInput = {
  organizationInvites?: InputMaybe<Array<OrganizationInvite>>;
  recipient: InviteRecipient;
  sender: InviteSender;
};

export type SiteLicense = {
  __typename?: 'SiteLicense';
  dateCreated: Scalars['DateTime'];
  dateExpiration: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  licenseRangeMax: Scalars['Int'];
  licenseRangeMin: Scalars['Int'];
  licenseType: LicenseType;
  orderItemId: Scalars['Int'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  ownerUser?: Maybe<User>;
  ownerUserId: Scalars['Int'];
  productFamily?: Maybe<ProductFamily>;
  productFamilyId: Scalars['Int'];
};

export enum SiteLicenseOrderField {
  DATE_CREATED = 'DATE_CREATED',
  DATE_EXPIRATION = 'DATE_EXPIRATION',
  DATE_UPDATED = 'DATE_UPDATED',
  DATE_UPDATED_ASSIGNMENT = 'DATE_UPDATED_ASSIGNMENT',
  ID = 'ID',
  PRODUCT_ID = 'PRODUCT_ID'
}

export type SiteLicenseUpdateInput = {
  dateExpiration?: InputMaybe<Scalars['DateTime']>;
  orderItemId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type SiteLicenseWhereInput = {
  id: Scalars['Int'];
};

export type SiteLicensesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<SiteLicenseOrderField>;
};

export type SiteLicensesWhereInput = {
  expired?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  orderItemId?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  ownerUserId?: InputMaybe<Array<Scalars['Int']>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
};

export type SkipJumpInClassroomDataInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type SkipJumpInStudentDataInput = {
  enabled: Scalars['Boolean'];
  productCurriculumCode: Scalars['String'];
};

export enum SourceKind {
  CLASS_LINK = 'CLASS_LINK',
  CLEVER = 'CLEVER',
  FIREBASE = 'FIREBASE',
  GOOGLE = 'GOOGLE',
  ONE_ROSTER = 'ONE_ROSTER',
  ONE_ROSTER_API = 'ONE_ROSTER_API',
  ONE_ROSTER_NYCPS = 'ONE_ROSTER_NYCPS'
}

export type StopAndReviewClassroomDataInput = {
  enabled: Scalars['Boolean'];
  week: Scalars['Int'];
};

export type StopAndReviewStudentDataInput = {
  enabled: Scalars['Boolean'];
  productCurriculumCode: Scalars['String'];
  week: Scalars['Int'];
};

export type Student = {
  __typename?: 'Student';
  classrooms?: Maybe<Array<Classroom>>;
  contacts?: Maybe<Array<Contact>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<ExternalId>;
  firstName: Scalars['String'];
  gradeLevel: Scalars['String'];
  groups?: Maybe<Array<Group>>;
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseUsage?: Maybe<Array<StudentLicenseUsage>>;
  licenses?: Maybe<Array<License>>;
  loginType: StudentLoginType;
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int'];
  password?: Maybe<Scalars['String']>;
  settings?: Maybe<Array<StudentSetting>>;
  sisId?: Maybe<Scalars['String']>;
  status?: Maybe<StudentStatus>;
  toursSettings?: Maybe<Array<TourSettings>>;
  username: Scalars['String'];
};


export type StudentGroupsArgs = {
  orderBy?: InputMaybe<GroupsOrderInput>;
  where?: InputMaybe<GroupsWhereInput>;
};


export type StudentLicenseUsageArgs = {
  where?: InputMaybe<LicenseUsageWhereInput>;
};


export type StudentLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  where?: InputMaybe<LicensesWhereInput>;
};


export type StudentSettingsArgs = {
  orderBy?: InputMaybe<StudentSettingsOrderInput>;
  where?: InputMaybe<StudentSettingsWhereInput>;
};


export type StudentToursSettingsArgs = {
  where?: InputMaybe<ToursSettingsWhereInput>;
};

export type StudentContact = {
  __typename?: 'StudentContact';
  contactId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export type StudentCreateInput = {
  classroomId?: InputMaybe<Array<Scalars['Int']>>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  firstName: Scalars['String'];
  gradeLevel: Scalars['String'];
  group?: InputMaybe<Array<GroupUpsertInput>>;
  lastName: Scalars['String'];
  licenses?: InputMaybe<Array<CreateEntityLicenseAssignInput>>;
  loginType?: InputMaybe<StudentLoginType>;
  organizationId: Scalars['Int'];
  password?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Array<BaseSettingCreateInput>>;
  sisId?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type StudentLicenseUsage = {
  __typename?: 'StudentLicenseUsage';
  active: Scalars['Boolean'];
  assignedCount: Scalars['Int'];
  manualAssignment: Scalars['Boolean'];
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  trial: Scalars['Boolean'];
};

export enum StudentLoginType {
  LETTER_CARDS = 'LETTER_CARDS',
  TEXTBOX = 'TEXTBOX'
}

export enum StudentSearchField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME'
}

export type StudentSetting = {
  __typename?: 'StudentSetting';
  app: App;
  appId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  student: Student;
  studentId: Scalars['Int'];
  value: Scalars['JSON'];
};

export type StudentSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  studentId: Scalars['Int'];
  value: Scalars['JSON'];
};

export enum StudentSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING',
  STUDENT_ID = 'STUDENT_ID'
}

export type StudentSettingUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type StudentSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  studentId: Scalars['Int'];
};

export type StudentSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<StudentSettingOrderField>;
};

export type StudentSettingsUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type StudentSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
  studentId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum StudentStatus {
  ACTIVE = 'ACTIVE',
  REMOVED = 'REMOVED'
}

export type StudentUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  firstName?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<GroupUpsertInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  loginType?: InputMaybe<StudentLoginType>;
  organizationId?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type StudentWhereInput = {
  authToken?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export enum StudentsOrderField {
  FIRST_NAME = 'FIRST_NAME',
  GRADE_LEVEL = 'GRADE_LEVEL',
  ID = 'ID',
  LAST_NAME = 'LAST_NAME',
  PASSWORD = 'PASSWORD',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  USERNAME = 'USERNAME'
}

export type StudentsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<StudentsOrderField>;
};

export type StudentsUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  gradeLevel?: InputMaybe<Scalars['String']>;
  loginType?: InputMaybe<StudentLoginType>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type StudentsWhereInput = {
  AND?: InputMaybe<Array<StudentsWhereInput>>;
  OR?: InputMaybe<Array<StudentsWhereInput>>;
  authToken?: InputMaybe<Array<Scalars['String']>>;
  classrooms?: InputMaybe<ClassroomsWhereInput>;
  email?: InputMaybe<Array<Scalars['String']>>;
  email_contains?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Array<Scalars['String']>>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  gradeLevel?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<Scalars['String']>>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  organizations?: InputMaybe<OrganizationsWhereInput>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<Array<StudentStatus>>;
  username?: InputMaybe<Array<Scalars['String']>>;
  username_contains?: InputMaybe<Scalars['String']>;
};

export type SupportCategoriesOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field?: InputMaybe<Array<SupportCategoryOrderField>>;
};

export type SupportCategoriesWhereInput = {
  id: Array<Scalars['Int']>;
};

export type SupportCategory = {
  __typename?: 'SupportCategory';
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  iconAsset: Asset;
  iconAssetId: Scalars['Int'];
  id: Scalars['Int'];
  locale: Locale;
  sortIndex: Scalars['Int'];
  supportTopics?: Maybe<Array<SupportTopic>>;
  title: Scalars['String'];
};

export enum SupportCategoryOrderField {
  ID = 'ID',
  SORT_INDEX = 'SORT_INDEX'
}

export type SupportCategoryWhereInput = {
  id: Scalars['Int'];
};

export type SupportTopic = {
  __typename?: 'SupportTopic';
  content: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  locale: Locale;
  sortIndex: Scalars['Int'];
  supportCategories?: Maybe<Array<SupportCategory>>;
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String'];
};

export enum SupportTopicOrderField {
  ID = 'ID',
  SORT_INDEX = 'SORT_INDEX'
}

export type SupportTopicWhereInput = {
  id: Scalars['Int'];
};

export type SupportTopicsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field?: InputMaybe<Array<SupportTopicOrderField>>;
};

export type SupportTopicsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  productName?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  supportCategoryId?: InputMaybe<Scalars['Int']>;
};

export type SwapLicensesInput = {
  toProductId: Scalars['Int'];
};

export type SwapLicensesWhereInput = {
  count?: InputMaybe<Scalars['Int']>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  fromProductId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type Tag = {
  __typename?: 'Tag';
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  locale: Locale;
  tagGroup?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type TagsWhereInput = {
  id: Array<Scalars['Int']>;
};

export type Tour = {
  __typename?: 'Tour';
  app: App;
  appId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  tourSteps: Array<TourStep>;
};

export enum TourOrderField {
  APP_ID = 'APP_ID',
  ID = 'ID',
  NAME = 'NAME',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID'
}

export type TourSettings = {
  __typename?: 'TourSettings';
  tour?: Maybe<Tour>;
  tourId: Scalars['Int'];
  tourStepSettings: Array<TourStepSetting>;
};

export type TourStep = {
  __typename?: 'TourStep';
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['JSON']>;
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  media?: Maybe<Media>;
  name: Scalars['String'];
  position?: Maybe<Position>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  tour: Tour;
  tourId: Scalars['Int'];
};

export type TourStepSetting = {
  __typename?: 'TourStepSetting';
  tourStep?: Maybe<TourStep>;
  tourStepId: Scalars['Int'];
  viewed: Scalars['Boolean'];
};

export type TourStepWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  tourId?: InputMaybe<Scalars['Int']>;
};

export type TourStepsWhereInput = {
  id?: InputMaybe<Array<Scalars['Int']>>;
  tourId?: InputMaybe<Array<Scalars['Int']>>;
};

export type TourWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

export type ToursOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<TourOrderField>;
};

export type ToursSettingsWhereInput = {
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  studentId?: InputMaybe<Scalars['Int']>;
  tours?: InputMaybe<Array<Scalars['String']>>;
  toursSteps?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['Int']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type ToursWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Array<Scalars['String']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
};

export type TransferStudentInput = {
  fromClassroomId: Scalars['Int'];
  toClassroomId: Scalars['Int'];
};

export type TransferStudentWhereInput = {
  studentId: Scalars['Int'];
};

export type UpdateAzsappClassroomSettingExposeLetterBooksInput = {
  classroomId: Scalars['Int'];
  value: ExposeLetterBooksDataInput;
};

export type UpdateGssClassroomSettingCharacterOrderInput = {
  classroomId: Scalars['Int'];
  value: GssSettingCharacterOrderDataInput;
};

export type UpdateGssClassroomSettingLeftHandednessInput = {
  classroomId: Scalars['Int'];
  value: GssSettingLeftHandednessDataInput;
};

export type UpdateGssClassroomSettingLocaleInput = {
  classroomId: Scalars['Int'];
  value: Locale;
};

export type UpdateGssStudentSettingCharacterOrderInput = {
  studentId: Scalars['Int'];
  value: GssSettingCharacterOrderDataInput;
};

export type UpdateGssStudentSettingLeftHandednessInput = {
  studentId: Scalars['Int'];
  value: GssSettingLeftHandednessDataInput;
};

export type UpdateGssStudentSettingLocaleInput = {
  studentId: Scalars['Int'];
  value: Locale;
};

export type UpdateHwtClassroomSettingLocaleInput = {
  classroomId: Scalars['Int'];
  value: Locale;
};

export type UpdateHwtStudentSettingLocaleInput = {
  studentId: Scalars['Int'];
  value: Locale;
};

export type UpdateKeyClassroomSettingAssessmentAcceleratorInput = {
  classroomId: Scalars['Int'];
  scheduledDates?: InputMaybe<Array<KeyAssessmentAcceleratorScheduledDateInput>>;
};

export type UpdateKeyClassroomSettingEnrichmentInput = {
  classroomId: Scalars['Int'];
  hearItTypeIt: KeySettingDataInput;
  myChoiceKeyboarding: KeySettingDataInput;
  teacherCreated: KeyTeacherCreatedActivitySettingInput;
};

export type UpdateKeyClassroomSettingHomeUseInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  value: Array<HomeUseClassroomDataInput>;
};

export type UpdateKeyClassroomSettingScheduledActivityInput = {
  assessOnLoginDate?: InputMaybe<Scalars['DateTime']>;
  classroomId: Scalars['Int'];
  scheduleType?: InputMaybe<ScheduledActivityScheduleType>;
  scheduledDates?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type UpdateKeyClassroomSettingSkipJumpInInput = {
  classroomId: Scalars['Int'];
  value: SkipJumpInClassroomDataInput;
};

export type UpdateKeyClassroomSettingStopAndReviewInput = {
  classroomId: Scalars['Int'];
  value: StopAndReviewClassroomDataInput;
};

export type UpdateKeyStudentSettingHomeUseInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  studentId: Scalars['Int'];
  value: HomeUseStudentDataInput;
};

export type UpdateKeyStudentSettingOneHandedTypingHandInput = {
  oneHandedTypingHand?: InputMaybe<KeyOneHandedTypingHand>;
  studentId: Scalars['Int'];
};

export type UpdateKeyStudentSettingSkipJumpInInput = {
  studentId: Scalars['Int'];
  value: SkipJumpInStudentDataInput;
};

export type UpdateKeyStudentSettingStopAndReviewInput = {
  studentId: Scalars['Int'];
  value: StopAndReviewStudentDataInput;
};

export type UpdateWdtClassroomSettingCharacterOrderInput = {
  classroomId: Scalars['Int'];
  value: WdtSettingCharacterOrderDataInput;
};

export type UpdateWdtClassroomSettingLeftHandednessInput = {
  classroomId: Scalars['Int'];
  value: WdtSettingLeftHandednessDataInput;
};

export type UpdateWdtStudentSettingCharacterOrderInput = {
  studentId: Scalars['Int'];
  value: WdtSettingCharacterOrderDataInput;
};

export type UpdateWdtStudentSettingLeftHandednessInput = {
  studentId: Scalars['Int'];
  value: WdtSettingLeftHandednessDataInput;
};

export type UploadUrl = {
  __typename?: 'UploadUrl';
  filename: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type UploadUrlsCreateInput = {
  filenames: Array<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  azureId?: Maybe<Scalars['String']>;
  classroomEnrollments?: Maybe<Array<UserClassroomEnrollment>>;
  classroomPrivileges?: Maybe<Array<UserClassroomPrivileges>>;
  dateCreated: Scalars['DateTime'];
  dateRemoved?: Maybe<Scalars['DateTime']>;
  dateUpdated: Scalars['DateTime'];
  externalId?: Maybe<ExternalId>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  licenseUsage?: Maybe<Array<UserLicenseUsage>>;
  licenses?: Maybe<Array<License>>;
  mastercodes?: Maybe<Array<Mastercode>>;
  orders?: Maybe<Array<Order>>;
  organizationAssociations?: Maybe<Array<UserOrganization>>;
  organizationPrivileges?: Maybe<Array<UserOrganizationPrivileges>>;
  pin: Scalars['String'];
  settings?: Maybe<Array<UserSetting>>;
  sisId?: Maybe<Scalars['String']>;
  status: UserStatus;
  toursSettings?: Maybe<Array<TourSettings>>;
  trialUsage?: Maybe<Array<UserTrialUsage>>;
  type: UserType;
  userTypeId: Scalars['Int'];
  username: Scalars['String'];
};


export type UserLicenseUsageArgs = {
  where?: InputMaybe<UserLicenseUsageWhereInput>;
};


export type UserLicensesArgs = {
  orderBy?: InputMaybe<LicensesOrderInput>;
  where?: InputMaybe<LicensesWhereInput>;
};


export type UserMastercodesArgs = {
  orderBy?: InputMaybe<MastercodesOrderInput>;
  where?: InputMaybe<MastercodesWhereInput>;
};


export type UserOrdersArgs = {
  orderBy?: InputMaybe<OrdersOrderInput>;
  where?: InputMaybe<OrdersWhereInput>;
};


export type UserSettingsArgs = {
  orderBy?: InputMaybe<UserSettingsOrderInput>;
  where?: InputMaybe<UserSettingsWhereInput>;
};


export type UserToursSettingsArgs = {
  where?: InputMaybe<ToursSettingsWhereInput>;
};


export type UserTrialUsageArgs = {
  where?: InputMaybe<UserLicenseUsageWhereInput>;
};

export type UserClassroomEnrollment = {
  __typename?: 'UserClassroomEnrollment';
  classroom: Classroom;
  classroomId: Scalars['Int'];
  classroomRoleIds: Array<Scalars['Int']>;
  classroomRoles: Array<ClassroomRole>;
  user: User;
  userId: Scalars['Int'];
};

export type UserClassroomPrivileges = {
  __typename?: 'UserClassroomPrivileges';
  classroomId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserCreateInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<ExternalIdInput>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  licenses?: InputMaybe<Array<CreateEntityLicenseAssignInput>>;
  organizationAssociations?: InputMaybe<Array<UserOrganizationInput>>;
  pin?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Array<BaseSettingCreateInput>>;
  sisId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  username: Scalars['String'];
};

export type UserEnrollmentInput = {
  classroomRole?: InputMaybe<Array<UserRole>>;
  userId: Scalars['Int'];
};

export type UserLicenseUsage = {
  __typename?: 'UserLicenseUsage';
  active: Scalars['Boolean'];
  assignedCount: Scalars['Int'];
  manualAssignment: Scalars['Boolean'];
  product: Product;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  trial: Scalars['Boolean'];
};

export type UserLicenseUsageWhereInput = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Array<ProductIdentifierInput>>;
  productCurriculum?: InputMaybe<Array<ProductIdentifierInput>>;
  productFamily?: InputMaybe<Array<ProductIdentifierInput>>;
};

export enum UserOrderField {
  FIRST_NAME = 'FIRST_NAME',
  ID = 'ID',
  LAST_NAME = 'LAST_NAME',
  SOURCE_ID = 'SOURCE_ID',
  SOURCE_KIND_ID = 'SOURCE_KIND_ID',
  USERNAME = 'USERNAME'
}

export type UserOrganization = {
  __typename?: 'UserOrganization';
  organization: Organization;
  organizationId: Scalars['Int'];
  organizationRoleIds: Array<Scalars['Int']>;
  organizationRoles: Array<OrganizationRole>;
  user: User;
  userId: Scalars['Int'];
};

export type UserOrganizationInput = {
  organizationId: Scalars['Int'];
  organizationRoleId: Array<Scalars['Int']>;
};

export type UserOrganizationPrivileges = {
  __typename?: 'UserOrganizationPrivileges';
  organizationId: Scalars['Int'];
  privileges?: Maybe<Array<Scalars['String']>>;
};

export type UserOrganizationWhereInput = {
  excludeAncestors?: InputMaybe<Scalars['Boolean']>;
};

export enum UserRole {
  COEDUCATOR = 'COEDUCATOR',
  COEDUCATOR_GSS = 'COEDUCATOR_GSS',
  COEDUCATOR_KEY = 'COEDUCATOR_KEY',
  EDUCATOR = 'EDUCATOR',
  EDUCATOR_GSS = 'EDUCATOR_GSS',
  EDUCATOR_KEY = 'EDUCATOR_KEY'
}

export enum UserSearchField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  USERNAME = 'USERNAME'
}

export type UserSetting = {
  __typename?: 'UserSetting';
  app: App;
  appId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  id: Scalars['Int'];
  product?: Maybe<Product>;
  productCurriculum?: Maybe<ProductCurriculum>;
  productCurriculumId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  user: User;
  userId: Scalars['Int'];
  value: Scalars['JSON'];
};

export type UserSettingCreateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  userId: Scalars['Int'];
  value: Scalars['JSON'];
};

export enum UserSettingOrderField {
  APP_ID = 'APP_ID',
  PRODUCT_CURRICULUM_ID = 'PRODUCT_CURRICULUM_ID',
  PRODUCT_ID = 'PRODUCT_ID',
  SETTING = 'SETTING',
  USER_ID = 'USER_ID'
}

export type UserSettingUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UserSettingWhereInput = {
  appId?: InputMaybe<Scalars['Int']>;
  appName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCurriculumCode?: InputMaybe<Scalars['String']>;
  productCurriculumId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  setting: Scalars['String'];
  userId: Scalars['Int'];
};

export type UserSettingsOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<UserSettingOrderField>;
};

export type UserSettingsUpdateInput = {
  appId?: InputMaybe<Scalars['Int']>;
  setting?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UserSettingsWhereInput = {
  appId?: InputMaybe<Array<Scalars['Int']>>;
  appName?: InputMaybe<Array<Scalars['String']>>;
  productCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumCode?: InputMaybe<Array<Scalars['String']>>;
  productCurriculumId?: InputMaybe<Array<Scalars['Int']>>;
  productId?: InputMaybe<Array<Scalars['Int']>>;
  setting?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Array<Scalars['Int']>>;
};

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING'
}

export type UserTrialUsage = {
  __typename?: 'UserTrialUsage';
  active: Scalars['Boolean'];
  available: Scalars['Boolean'];
  dateExpiration?: Maybe<Scalars['DateTime']>;
  product: Product;
  productCurriculum: ProductCurriculum;
  productCurriculumId: Scalars['Int'];
  productId: Scalars['Int'];
};

export enum UserType {
  ADMINISTRATOR = 'ADMINISTRATOR',
  CURRICULUM = 'CURRICULUM',
  ESL_ESOL = 'ESL_ESOL',
  HOMESCHOOL_EDUCATOR = 'HOMESCHOOL_EDUCATOR',
  K5_TEACHER = 'K5_TEACHER',
  OCCUPATIONAL_THERAPIST = 'OCCUPATIONAL_THERAPIST',
  OTHER = 'OTHER',
  PARENT_FAMILY = 'PARENT_FAMILY',
  PREK_TEACHER = 'PREK_TEACHER',
  PRINCIPAL_VICE_PRINCIPAL = 'PRINCIPAL_VICE_PRINCIPAL',
  READING_SPECIALIST = 'READING_SPECIALIST',
  SPECIAL_EDUCATION = 'SPECIAL_EDUCATION',
  TECHNOLOGY_MEDIA = 'TECHNOLOGY_MEDIA'
}

export type UserUpdateInput = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<ExternalIdUpdateInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationAssociations?: InputMaybe<Array<UserOrganizationInput>>;
  pin?: InputMaybe<Scalars['String']>;
  sisId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserWhereInput = {
  externalId?: InputMaybe<ExternalIdInput>;
  id?: InputMaybe<Scalars['Int']>;
  pin?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsersOrderInput = {
  direction?: InputMaybe<Array<OrderDirection>>;
  field: Array<UserOrderField>;
};

export type UsersUpdateInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<UserStatus>;
};

export type UsersWhereInput = {
  AND?: InputMaybe<Array<UsersWhereInput>>;
  OR?: InputMaybe<Array<UsersWhereInput>>;
  firstName?: InputMaybe<Array<Scalars['String']>>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<Scalars['String']>>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Array<Scalars['Int']>>;
  organizationRoles?: InputMaybe<OrganizationRolesWhereInput>;
  organizations?: InputMaybe<OrganizationsWhereInput>;
  pin?: InputMaybe<Array<Scalars['String']>>;
  removed?: InputMaybe<Scalars['Boolean']>;
  sisId?: InputMaybe<Array<Scalars['String']>>;
  sourceId?: InputMaybe<Array<Scalars['String']>>;
  sourceKind?: InputMaybe<Array<SourceKind>>;
  status?: InputMaybe<Array<UserStatus>>;
  type?: InputMaybe<Array<UserType>>;
  username?: InputMaybe<Array<Scalars['String']>>;
  username_contains?: InputMaybe<Scalars['String']>;
};

export type WdtActiveStudentsReportWhereInput = {
  classroomId: Scalars['Int'];
};

export type WdtCharacter = {
  __typename?: 'WdtCharacter';
  character: Scalars['String'];
  characterGroupIds: Array<Scalars['Int']>;
  id: Scalars['Int'];
};

export type WdtCharacterErrorData = {
  __typename?: 'WdtCharacterErrorData';
  character: WdtCharacter;
  errors: Array<WdtErrorData>;
};

export type WdtCharacterGroup = {
  __typename?: 'WdtCharacterGroup';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type WdtCharacterLevelProgressData = {
  __typename?: 'WdtCharacterLevelProgressData';
  level: Scalars['Int'];
  studentCompletedCount: Scalars['Int'];
};

export enum WdtCharacterOrder {
  freePlay = 'freePlay',
  hwt = 'hwt',
  natural = 'natural'
}

export type WdtCharacterProgressData = {
  __typename?: 'WdtCharacterProgressData';
  character: WdtCharacter;
  level: Scalars['Int'];
};

export type WdtCharactersCompletedAndTimeSpentIntervalData = {
  __typename?: 'WdtCharactersCompletedAndTimeSpentIntervalData';
  averageMinutesSpent: Scalars['Float'];
  charactersCompletedCount: Scalars['Int'];
  interval: Scalars['DateTime'];
};

export type WdtCharactersCompletedAndTimeSpentReportResult = {
  __typename?: 'WdtCharactersCompletedAndTimeSpentReportResult';
  averageMinutesSpent: Scalars['Float'];
  intervalUnit: ReportIntervalUnit;
  intervals: Array<WdtCharactersCompletedAndTimeSpentIntervalData>;
  totalCharactersCompletedCount: Scalars['Int'];
};

export type WdtCharactersCompletedAndTimeSpentReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

export type WdtClassroomErrorsByCharactersReportResult = {
  __typename?: 'WdtClassroomErrorsByCharactersReportResult';
  characterErrors?: Maybe<Array<WdtCharacterErrorData>>;
  characterGroups: Array<WdtCharacterGroup>;
  characterOrder: WdtCharacterOrder;
  classroomId: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomErrorsByCharactersReportWhereInput = {
  characterOrder?: InputMaybe<WdtCharacterOrder>;
  classroomId: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomErrorsByStudentsReportResult = {
  __typename?: 'WdtClassroomErrorsByStudentsReportResult';
  classroomId: Scalars['Int'];
  module: Scalars['String'];
  studentErrors?: Maybe<Array<WdtStudentErrorData>>;
};

export type WdtClassroomErrorsByStudentsReportWhereInput = {
  classroomId: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomModuleProgressData = {
  __typename?: 'WdtClassroomModuleProgressData';
  charactersCompletedCount: Scalars['Int'];
  level: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomOverallProgressReportResult = {
  __typename?: 'WdtClassroomOverallProgressReportResult';
  classroomId: Scalars['Int'];
  progress?: Maybe<Array<WdtClassroomModuleProgressData>>;
  totalStudentCount: Scalars['Int'];
};

export type WdtClassroomOverallProgressReportWhereInput = {
  classroomId: Scalars['Int'];
};

export type WdtClassroomProgressByCharactersData = {
  __typename?: 'WdtClassroomProgressByCharactersData';
  character: WdtCharacter;
  characterLevelsProgress: Array<WdtCharacterLevelProgressData>;
};

export type WdtClassroomProgressByCharactersReportResult = {
  __typename?: 'WdtClassroomProgressByCharactersReportResult';
  characterGroups: Array<WdtCharacterGroup>;
  characterOrder: WdtCharacterOrder;
  characterProgress?: Maybe<Array<WdtClassroomProgressByCharactersData>>;
  classroomId: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomProgressByCharactersReportWhereInput = {
  characterOrder?: InputMaybe<WdtCharacterOrder>;
  classroomId: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomProgressByStudentsData = {
  __typename?: 'WdtClassroomProgressByStudentsData';
  charactersCompletedCount: Scalars['Int'];
  level: Scalars['Int'];
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type WdtClassroomProgressByStudentsReportResult = {
  __typename?: 'WdtClassroomProgressByStudentsReportResult';
  classroomId: Scalars['Int'];
  module: Scalars['String'];
  studentProgress?: Maybe<Array<WdtClassroomProgressByStudentsData>>;
};

export type WdtClassroomProgressByStudentsReportWhereInput = {
  classroomId: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtClassroomSettings = {
  __typename?: 'WdtClassroomSettings';
  characterOrder?: Maybe<WdtSettingCharacterOrderData>;
  handedness?: Maybe<WdtSettingLeftHandednessData>;
};

export type WdtErrorData = {
  __typename?: 'WdtErrorData';
  count: Scalars['Int'];
  type: Scalars['String'];
};

export type WdtOverallErrorsReportResult = {
  __typename?: 'WdtOverallErrorsReportResult';
  errors: Array<WdtErrorData>;
};

export type WdtOverallErrorsReportWhereInput = {
  classroomId?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Int']>;
};

export enum WdtSetting {
  LETTER_AND_NUMBER_ORDER = 'LETTER_AND_NUMBER_ORDER'
}

export type WdtSettingCharacterOrderData = {
  __typename?: 'WdtSettingCharacterOrderData';
  capitals?: Maybe<WdtCharacterOrder>;
  lowercase?: Maybe<WdtCharacterOrder>;
  numbers?: Maybe<WdtCharacterOrder>;
};

export type WdtSettingCharacterOrderDataInput = {
  capitals?: InputMaybe<WdtCharacterOrder>;
  lowercase?: InputMaybe<WdtCharacterOrder>;
  numbers?: InputMaybe<WdtCharacterOrder>;
};

export type WdtSettingLeftHandednessData = {
  __typename?: 'WdtSettingLeftHandednessData';
  leftHanded: Scalars['Boolean'];
  rtlCrossStroke?: Maybe<Scalars['Boolean']>;
};

export type WdtSettingLeftHandednessDataInput = {
  leftHanded: Scalars['Boolean'];
  rtlCrossStroke?: InputMaybe<Scalars['Boolean']>;
};

export type WdtStudentErrorData = {
  __typename?: 'WdtStudentErrorData';
  errors: Array<WdtErrorData>;
  student?: Maybe<Student>;
  studentId: Scalars['Int'];
};

export type WdtStudentErrorsReportResult = {
  __typename?: 'WdtStudentErrorsReportResult';
  characterErrors?: Maybe<Array<WdtCharacterErrorData>>;
  characterGroups: Array<WdtCharacterGroup>;
  characterOrder: WdtCharacterOrder;
  module: Scalars['String'];
  studentId: Scalars['Int'];
};

export type WdtStudentErrorsReportWhereInput = {
  characterOrder?: InputMaybe<WdtCharacterOrder>;
  module: Scalars['String'];
  studentId: Scalars['Int'];
};

export type WdtStudentModuleProgressData = {
  __typename?: 'WdtStudentModuleProgressData';
  charactersCompletedCount: Scalars['Int'];
  level: Scalars['Int'];
  module: Scalars['String'];
};

export type WdtStudentOverallProgressReportResult = {
  __typename?: 'WdtStudentOverallProgressReportResult';
  progress?: Maybe<Array<WdtStudentModuleProgressData>>;
  studentId: Scalars['Int'];
};

export type WdtStudentOverallProgressReportWhereInput = {
  studentId: Scalars['Int'];
};

export type WdtStudentProgressReportResult = {
  __typename?: 'WdtStudentProgressReportResult';
  characterGroups: Array<WdtCharacterGroup>;
  characterOrder: WdtCharacterOrder;
  characterProgress?: Maybe<Array<WdtCharacterProgressData>>;
  module: Scalars['String'];
  studentId: Scalars['Int'];
};

export type WdtStudentProgressReportWhereInput = {
  characterOrder?: InputMaybe<WdtCharacterOrder>;
  module: Scalars['String'];
  studentId: Scalars['Int'];
};

export type WdtStudentSettings = {
  __typename?: 'WdtStudentSettings';
  characterOrder?: Maybe<WdtSettingCharacterOrderData>;
  handedness?: Maybe<WdtSettingLeftHandednessData>;
};

export type WeekSettingData = {
  __typename?: 'WeekSettingData';
  enabled?: Maybe<Scalars['Boolean']>;
  week?: Maybe<Scalars['Int']>;
};

export enum Weekday {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type WdtActiveStudentsReportResult = {
  __typename?: 'wdtActiveStudentsReportResult';
  activeStudentCount: Scalars['Int'];
  totalStudentCount: Scalars['Int'];
};

export type GetUserProductsQueryVariables = Exact<{
  where: UserWhereInput;
}>;


export type GetUserProductsQuery = { user: { id: number, username: string, firstName: string, lastName: string, licenseUsage: Array<{ assignedCount: number, manualAssignment: boolean, trial: boolean, product: { id: number, code: string, family: { id: number, code: string } }, productCurriculum: { id: number, code: string } | null }> | null, organizationAssociations: Array<{ organization: { id: number, name: string, licenseUsage: Array<{ availableCount: number, siteLicensed: boolean, product: { id: number, code: string, type: ProductType, family: { id: number, code: string } } }> | null } }> | null } | null };

export type KeyOrganizationEngagementReportAsyncQueryVariables = Exact<{
  where: KeyOrganizationEngagementReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type KeyOrganizationEngagementReportAsyncQuery = { keyOrganizationEngagementReportAsync: { id: string, error: string | null, result: Array<{ curriculumProgressPercentage: number, totalStudentCount: number, activeStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, organization: { id: number, name: string } | null }> | null } };

export type GetAcademicSessionsQueryVariables = Exact<{
  where?: InputMaybe<AcademicSessionsWhereInput>;
  organizationId: Scalars['Int'];
}>;


export type GetAcademicSessionsQuery = { academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null, active: boolean, default: boolean } | null>, organizationSetting: { id: number, organizationId: number, setting: string, value: any } | null };

export type CreateAcademicSessionMutationVariables = Exact<{
  data: AcademicSessionCreateInput;
}>;


export type CreateAcademicSessionMutation = { createAcademicSession: { id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null };

export type RemoveUpcomingAcademicSessionSettingMutationVariables = Exact<{
  where: OrganizationSettingWhereInput;
}>;


export type RemoveUpcomingAcademicSessionSettingMutation = { removeOrganizationSetting: any | null };

export type UpdateAcademicSessionMutationVariables = Exact<{
  where: AcademicSessionWhereInput;
  data: AcademicSessionUpdateInput;
}>;


export type UpdateAcademicSessionMutation = { updateAcademicSession: { id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null };

export type UpdateUpcomingAcademicSessionSettingMutationVariables = Exact<{
  organizationId: Scalars['Int'];
  value: Scalars['JSON'];
}>;


export type UpdateUpcomingAcademicSessionSettingMutation = { saveOrganizationSetting: { id: number, organizationId: number, setting: string, value: any } | null };

export type UploadBulkImportFileMutationMutationVariables = Exact<{
  data: BulkImportFileUploadInput;
}>;


export type UploadBulkImportFileMutationMutation = { uploadBulkImportFile: { url: string | null, fields: any | null } | null };

export type ArchiveClassroomMutationVariables = Exact<{
  classroomId: Scalars['Int'];
}>;


export type ArchiveClassroomMutation = { archiveClassroom: { id: number, dateArchived: any | null } | null };

export type ArchiveClassroomsMutationVariables = Exact<{
  where: ClassroomsWhereInput;
}>;


export type ArchiveClassroomsMutation = { archiveClassrooms: { count: number | null } | null };

export type BulkGroupEnrollmentActionMutationVariables = Exact<{
  data: Array<BulkGroupEnrollmentActionInput> | BulkGroupEnrollmentActionInput;
}>;


export type BulkGroupEnrollmentActionMutation = { bulkGroupEnrollmentAction: Array<{ error: string | null, groupEnrollment: { id: number, studentId: number, groupId: number } | null }> | null };

export type CreateClassroomMutationVariables = Exact<{
  classroom: ClassroomCreateInput;
}>;


export type CreateClassroomMutation = { createClassroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null } | null };

export type GetAdminClassroomDetailsQueryVariables = Exact<{
  where: ClassroomWhereInput;
}>;


export type GetAdminClassroomDetailsQuery = { classroom: { id: number, name: string, color: string, studentCount: number, organizationId: number, stats: { userCount: number, studentCount: number }, licenseUsage: Array<{ assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, students: Array<{ id: number, firstName: string, lastName: string, username: string, email: string | null, password: string | null, gradeLevel: string, licenseUsage: Array<{ assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null }> | null, organization: { id: number, name: string, type: OrganizationType, parentOrganization: { name: string, type: OrganizationType } | null } | null } | null };

export type GetBaseClassroomQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetBaseClassroomQuery = { entity: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null } | null };

export type GetClassroomNameQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetClassroomNameQuery = { classroom: { name: string } | null };

export type GetClassroomQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetClassroomQuery = { classroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, organization: { id: number, licenseUsage: Array<{ siteLicensed: boolean, assignedCount: number, availableCount: number, inUseCount: number, expiringCount: number, totalCount: number, productId: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null, overageStats: { availableCount: number, assignedCount: number, totalCount: number, expiringCount: number, overageLimitCount: number } | null }> | null } | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, students: Array<{ id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number, licenseUsage: Array<{ productId: number, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, groups: Array<{ id: number, appId: number, classroomId: number, name: string, groupCategory: { appId: number, classroomId: number, name: string } }> | null }> | null } | null };

export type GetOrganizationClassroomsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationClassroomsQuery = { organizations: Array<{ id: number, name: string, classrooms: Array<{ id: number, name: string, studentCount: number, color: string, dateArchived: any | null, organization: { id: number, name: string } | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, licenseUsage: Array<{ assignedCount: number, product: { id: number, name: string, code: string, iconUrl: string | null }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null } | null }> | null }> | null } | null>, users: Array<{ id: number, firstName: string, lastName: string }> };

export type GetKeyboardingModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKeyboardingModulesQuery = { keyboardingModules: Array<{ id: number, parentModuleId: number | null, name: string, description: string } | null> };

export type GetMyClassroomsQueryVariables = Exact<{
  whereUser?: InputMaybe<UsersWhereInput>;
}>;


export type GetMyClassroomsQuery = { classrooms: Array<{ id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, organization: { id: number, name: string } | null }> | null };

export type GetUserClassroomsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetUserClassroomsQuery = { classrooms: Array<{ id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, stats: { studentCount: number, userCount: number }, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, organization: { id: number, name: string } | null }> | null };

export type RemoveClassroomMutationVariables = Exact<{
  classroomId: Scalars['Int'];
}>;


export type RemoveClassroomMutation = { removeClassroom: { id: number, dateRemoved: any | null } | null };

export type RemoveClassroomsMutationVariables = Exact<{
  where: ClassroomsWhereInput;
}>;


export type RemoveClassroomsMutation = { removeClassrooms: { count: number | null } | null };

export type SearchClassroomsQueryVariables = Exact<{
  searchText: Scalars['String'];
  classroomIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchClassroomsQuery = { classrooms: Array<{ id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null }> | null };

export type UpdateClassroomMutationMutationVariables = Exact<{
  classroomId?: InputMaybe<Scalars['Int']>;
  data: ClassroomUpdateInput;
}>;


export type UpdateClassroomMutationMutation = { updateClassroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, organization: { id: number, name: string } | null } | null };

export type KeyClassroomAssessmentAcceleratorModulesMutationVariables = Exact<{
  data: UpdateKeyClassroomSettingAssessmentAcceleratorInput;
}>;


export type KeyClassroomAssessmentAcceleratorModulesMutation = { updateKeyClassroomAssessmentAcceleratorModules: { activityTypeId: string, scheduledDates: Array<{ date: any, moduleIds: Array<number> }> | null } };

export type GetClassroomAndOrganizationsQueryVariables = Exact<{
  where: ClassroomWhereInput;
}>;


export type GetClassroomAndOrganizationsQuery = { classroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, users: Array<{ classroomId: number, userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, organization: { id: number, name: string } | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, students: Array<{ id: number, username: string }> | null } | null, organizations: Array<{ id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null, users: Array<{ user: { id: number, firstName: string, lastName: string, username: string } }> | null } | null> };

export type GetClassroomLicenseUsageQueryVariables = Exact<{
  classroomId: Scalars['Int'];
}>;


export type GetClassroomLicenseUsageQuery = { classroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, students: Array<{ id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number, licenseUsage: Array<{ productId: number, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, groups: Array<{ id: number, appId: number, classroomId: number, name: string, groupCategory: { appId: number, classroomId: number, name: string } }> | null }> | null, organization: { rootOrganization: { licenseUsage: Array<{ assignedCount: number, availableCount: number, siteLicensed: boolean, totalCount: number, overageStats: { assignedCount: number, availableCount: number, overageLimitCount: number, totalCount: number } | null, product: { id: number, code: string, name: string, type: ProductType, family: { id: number, code: string, name: string } }, productCurriculum: { id: number, code: string } | null }> | null } | null } | null } | null };

export type GetMyOrganizationNamesClassroomsAndMasterCodesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyOrganizationNamesClassroomsAndMasterCodesQuery = { user: { organizationAssociations: Array<{ organization: { id: number, name: string } }> | null } | null, classrooms: Array<{ id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, stats: { studentCount: number, userCount: number } }> | null, mastercodes: Array<{ id: number, status: MastercodeStatus | null, orderItems: Array<{ id: number, licenseType: LicenseType, product: { id: number, code: string } | null }> | null }> | null };

export type GetStudentAndClassroomQueryQueryVariables = Exact<{
  whereStudent: StudentWhereInput;
  whereClassroom: ClassroomWhereInput;
}>;


export type GetStudentAndClassroomQueryQuery = { student: { id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number, externalId: { sourceId: string, sourceKind: SourceKind } | null, groups: Array<{ id: number, appId: number, classroomId: number, name: string, groupCategory: { appId: number, classroomId: number, name: string } }> | null, licenseUsage: Array<{ productId: number, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null } | null, classroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, students: Array<{ id: number, username: string }> | null, organization: { id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null } | null } | null };

export type GetClassroomsAndOrganizationsWithRolesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetClassroomsAndOrganizationsWithRolesQuery = { user: { organizationAssociations: Array<{ organizationId: number, organization: { id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, organizationRoles: Array<{ id: number, classification: OrganizationRoleClassification, name: string, displayName: string, appId: number | null, organizationId: number | null, public: boolean }> }> | null }, organizationRoles: Array<{ id: number, classification: OrganizationRoleClassification, name: string, displayName: string, appId: number | null, organizationId: number | null, public: boolean }> }> | null } | null, classrooms: Array<{ id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, stats: { studentCount: number, userCount: number } }> | null };

export type SendLicenseAssignmentEmailMutationVariables = Exact<{
  data: SendLicenseAssignmentEmailInput;
}>;


export type SendLicenseAssignmentEmailMutation = { sendLicenseAssignmentEmail: boolean | null };

export type SendUserInviteEmailMutationVariables = Exact<{
  data: SendUserInviteEmailInput;
}>;


export type SendUserInviteEmailMutation = { sendUserInviteEmail: boolean | null };

export type CreateResourceFavoriteMutationVariables = Exact<{
  data: ResourceFavoriteCreateInput;
}>;


export type CreateResourceFavoriteMutation = { createResourceFavorite: { id: number | null, resourceId: number } | null };

export type DeleteResourceFavoriteMutationVariables = Exact<{
  where: ResourceFavoriteDeleteInput;
}>;


export type DeleteResourceFavoriteMutation = { deleteResourceFavorite: { id: number | null, resourceId: number } | null };

export type GetResourceFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResourceFavoritesQuery = { resourceFavorites: Array<{ id: number | null, link: string | null, grades: Array<string | null> | null, title: string, description: string | null, productCodes: Array<string | null> | null, type: { id: number, type: string, title: string, description: string, sortIndex: number, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null }, imageAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } }, productFamily: { id: number, name: string } | null, thumbnailAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null }, resourceAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } | null, favorite: { id: number | null, resourceId: number } | null } | null> };

export type GetDefaultGroupSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultGroupSettingsQuery = { defaultGroupSettings: Array<{ gradeLevels: Array<string>, productCodes: Array<string>, group: { appId: number, name: string, groupCategory: { appId: number, name: string } | null } }> | null };

export type BulkLicenseActionMutationVariables = Exact<{
  where?: InputMaybe<BulkLicenseActionWhereInput>;
  assignRequests: Array<BulkLicenseActionInput> | BulkLicenseActionInput;
}>;


export type BulkLicenseActionMutation = { bulkLicenseAction: Array<{ error: string | null, request: { studentId: number | null, userId: number | null, productId: number | null, productCode: string | null, orderItemId: Array<number> | null }, licenses: Array<{ id: number }> | null }> };

export type GetMyLicenseUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLicenseUsageQuery = { me: { id: number, licenseUsage: Array<{ productId: number, productCurriculumId: number | null, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null } | null };

export type GetLicenseDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLicenseDataQuery = { mastercodes: Array<{ id: number, status: MastercodeStatus | null, orderItems: Array<{ id: number, licenseType: LicenseType, product: { id: number, code: string } | null }> | null }> | null, organizations: Array<{ id: number, name: string, parentOrganizationId: number | null, licenseUsage: Array<{ siteLicensed: boolean, assignedCount: number, availableCount: number, inUseCount: number, expiringCount: number, totalCount: number, productId: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null, overageStats: { availableCount: number, assignedCount: number, totalCount: number, expiringCount: number, overageLimitCount: number } | null }> | null, ancestorMastercodes: Array<{ id: number, code: string, status: MastercodeStatus | null, orderItems: Array<{ id: number, licenseType: LicenseType, licenseCount: number, dateExpiration: any | null, order: { orderNumber: string | null, itemFulfillmentNumber: string | null, ecmsOrderNumber: string | null }, product: { id: number, code: string, name: string } | null }> | null }> | null, mastercodes: Array<{ id: number, code: string, status: MastercodeStatus | null, orderItems: Array<{ id: number, licenseType: LicenseType, licenseCount: number, dateExpiration: any | null, order: { orderNumber: string | null, itemFulfillmentNumber: string | null, ecmsOrderNumber: string | null }, product: { id: number, code: string, name: string } | null }> | null }> | null, rootOrganization: { id: number, licenseUsage: Array<{ siteLicensed: boolean, assignedCount: number, availableCount: number, inUseCount: number, expiringCount: number, totalCount: number, productId: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null, overageStats: { availableCount: number, assignedCount: number, totalCount: number, expiringCount: number, overageLimitCount: number } | null }> | null } | null } | null> };

export type GetMastercodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMastercodesQuery = { mastercodes: Array<{ id: number, status: MastercodeStatus | null, orderItems: Array<{ id: number, licenseType: LicenseType, product: { id: number, code: string } | null }> | null }> | null };

export type GetMastercodeActivationDetailsQueryVariables = Exact<{
  where: MastercodesWhereInput;
  expirationWhere: OrderItemDateExpirationInput;
}>;


export type GetMastercodeActivationDetailsQuery = { mastercodes: Array<{ id: number, code: string, dateUnlocked: any | null, orderItems: Array<{ dateExpiration: any | null }> | null }> | null };

export type GetMyOrdersQueryVariables = Exact<{
  where: OrdersWhereInput;
}>;


export type GetMyOrdersQuery = { me: { id: number, orders: Array<{ id: number, orderNumber: string | null, ecmsOrderNumber: string | null, itemFulfillmentNumber: string | null, dateOrdered: any, cmsCustomerNumber: string | null, crmNumber: string | null, dateFulfilled: any | null, parentOrder: { id: number, orderNumber: string | null, ecmsOrderNumber: string | null, itemFulfillmentNumber: string | null, dateOrdered: any, cmsCustomerNumber: string | null, crmNumber: string | null, dateFulfilled: any | null } | null, mastercodes: Array<{ id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any, parentMastercode: { id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any } | null, orderItems: Array<{ id: number, lineNumber: number | null, licenseCount: number, multiyearTerm: number | null, siteLicenseRangeMin: number | null, siteLicenseRangeMax: number | null, dateCreated: any, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null }> | null }> | null, orderItems: Array<{ id: number, lineNumber: number | null, licenseCount: number, multiyearTerm: number | null, siteLicenseRangeMin: number | null, siteLicenseRangeMax: number | null, dateCreated: any, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null }> | null }> | null } | null };

export type GetOrderUnauthenticatedQueryVariables = Exact<{
  orderId: Scalars['Int'];
  ownerEmail: Scalars['String'];
}>;


export type GetOrderUnauthenticatedQuery = { order: { id: number, orderNumber: string | null, ecmsOrderNumber: string | null, itemFulfillmentNumber: string | null, dateOrdered: any, cmsCustomerNumber: string | null, crmNumber: string | null, dateFulfilled: any | null, parentOrder: { id: number, orderNumber: string | null, ecmsOrderNumber: string | null, itemFulfillmentNumber: string | null, dateOrdered: any, cmsCustomerNumber: string | null, crmNumber: string | null, dateFulfilled: any | null } | null, mastercodes: Array<{ id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any, parentMastercode: { id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any } | null, orderItems: Array<{ id: number, lineNumber: number | null, licenseCount: number, multiyearTerm: number | null, siteLicenseRangeMin: number | null, siteLicenseRangeMax: number | null, dateCreated: any, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null }> | null }> | null, orderItems: Array<{ id: number, lineNumber: number | null, licenseCount: number, multiyearTerm: number | null, siteLicenseRangeMin: number | null, siteLicenseRangeMax: number | null, dateCreated: any, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null }> | null } | null };

export type ScheduleUnlockMastercodeMutationVariables = Exact<{
  mastercodeId: Scalars['Int'];
  date: Scalars['DateTime'];
}>;


export type ScheduleUnlockMastercodeMutation = { scheduleUnlockMastercode: { id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any, parentMastercode: { id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any } | null, orderItems: Array<{ id: number, lineNumber: number | null, licenseCount: number, multiyearTerm: number | null, siteLicenseRangeMin: number | null, siteLicenseRangeMax: number | null, dateCreated: any, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null }> | null } };

export type ScheduleUnlockOrderMastercodesMutationVariables = Exact<{
  orderId: Scalars['Int'];
  date: Scalars['DateTime'];
}>;


export type ScheduleUnlockOrderMastercodesMutation = { scheduleUnlockOrderMastercodes: { count: number | null } };

export type TransferMastercodeMutationVariables = Exact<{
  mastercodeId: Scalars['Int'];
  ownerEmail: Scalars['String'];
  data: MastercodeTransferInput;
}>;


export type TransferMastercodeMutation = { transferMastercode: { id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any, parentMastercode: { id: number, code: string, ownerEmail: string | null, dateGracePeriodEnd: any, dateScheduledUnlock: any | null, dateUnlocked: any | null, dateExpired: any | null, dateCreated: any } | null, orderItems: Array<{ id: number, lineNumber: number | null, licenseCount: number, multiyearTerm: number | null, siteLicenseRangeMin: number | null, siteLicenseRangeMax: number | null, dateCreated: any, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null }> | null } };

export type TransferOrderMastercodesMutationVariables = Exact<{
  orderId: Scalars['Int'];
  ownerEmail: Scalars['String'];
  data: MastercodeTransferInput;
}>;


export type TransferOrderMastercodesMutation = { transferOrderMastercodes: { count: number | null } };

export type UnlockMastercodeMutationVariables = Exact<{
  mastercodeId: Scalars['Int'];
}>;


export type UnlockMastercodeMutation = { unlockMastercode: { success: Array<{ dateExpiration: any | null, licenseCount: number, orderItem: { id: number, product: { id: number, type: ProductType } | null } | null }> | null, fail: Array<{ dateExpiration: any | null, licenseCount: number, orderItem: { id: number, product: { id: number, type: ProductType } | null } | null }> | null } };

export type UnlockOrderMastercodesMutationVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type UnlockOrderMastercodesMutation = { unlockOrderMastercodes: { success: Array<{ dateExpiration: any | null, licenseCount: number, orderItem: { id: number, product: { id: number, type: ProductType } | null } | null }> | null, fail: Array<{ dateExpiration: any | null, licenseCount: number, orderItem: { id: number, product: { id: number, type: ProductType } | null } | null }> | null } };

export type GetBaseOrganizationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetBaseOrganizationQuery = { entity: { id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null } | null };

export type GetOrganizationAvailableLicensesQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type GetOrganizationAvailableLicensesQuery = { organization: { id: number, rootOrganization: { id: number, licenseUsage: Array<{ assignedCount: number, availableCount: number, siteLicensed: boolean, totalCount: number, overageStats: { assignedCount: number, availableCount: number, overageLimitCount: number, totalCount: number } | null, product: { id: number, code: string, name: string, type: ProductType, family: { id: number, code: string, name: string } }, productCurriculum: { id: number, code: string } | null }> | null } | null } | null };

export type GetOrganizationsIncludingDistrictsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsIncludingDistrictsQuery = { organizations: Array<{ id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null, subOrganizations: Array<{ type: OrganizationType } | null> | null, classrooms: Array<{ id: number, dateArchived: any | null }> | null, users: Array<{ organizationRoles: Array<{ classification: OrganizationRoleClassification }>, user: { id: number, type: UserType, firstName: string, lastName: string, username: string } }> | null } | null> };

export type GetOrganizationsAndRolesQueryVariables = Exact<{
  rolesWhere?: InputMaybe<OrganizationRolesWhereInput>;
}>;


export type GetOrganizationsAndRolesQuery = { organizations: Array<{ id: number, name: string, externalId: { sourceId: string, sourceKind: SourceKind } | null } | null>, organizationRoles: Array<{ id: number, name: string, displayName: string, public: boolean } | null> | null };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { organizations: Array<{ id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null, users: Array<{ user: { id: number, firstName: string, lastName: string, username: string } }> | null } | null> };

export type GetReportingOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportingOrganizationsQuery = { organizations: Array<{ id: number, type: OrganizationType } | null> };

export type SearchOrganizationsQueryVariables = Exact<{
  searchText: Scalars['String'];
  organizationType?: InputMaybe<Array<OrganizationType> | OrganizationType>;
  organizationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchOrganizationsQuery = { organizations: Array<{ id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null } | null> };

export type UpdateOrganizationMutationVariables = Exact<{
  data: OrganizationUpdateInput;
  where: OrganizationWhereInput;
}>;


export type UpdateOrganizationMutation = { updateOrganization: { id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null } | null };

export type GetProductCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductCacheQuery = { products: Array<{ id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null }, curriculums: Array<{ id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number }> | null } | null>, productFamilies: Array<{ id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null, products: Array<{ code: string, name: string, type: ProductType, iconUrl: string | null } | null> } | null>, apps: Array<{ id: number, name: string, title: string | null, description: string | null, type: ProductType | null, pliManaged: boolean, products: Array<{ id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }>, accessDetails: { url: string | null, bannerUrl: string, iosUrl: string | null } | null, purchaseDetails: { title: string | null, description: string | null, url: string, salesQuoteUrl: string | null, webstoreUrl: string | null } | null, appProducts: Array<{ id: number, appId: number, productId: number, title: string | null, description: string | null, pliManaged: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } | null, accessDetails: { url: string | null, bannerUrl: string, iosUrl: string | null } | null, purchaseDetails: { title: string | null, description: string | null, url: string, salesQuoteUrl: string | null, webstoreUrl: string | null } | null }> } | null> };

export type GetActiveStudentsReportQueryVariables = Exact<{
  where: PrmActiveStudentsReportWhereInput;
}>;


export type GetActiveStudentsReportQuery = { prmActiveStudentsReport: { activeStudentCount: number, totalStudentCount: number } | null };

export type GetClassroomStatsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetClassroomStatsQuery = { classroom: { id: number, name: string, organization: { id: number, name: string, type: OrganizationType } | null, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } }> | null, stats: { studentCount: number, userCount: number } } | null };

export type GetCurriculumLessonReportQueryVariables = Exact<{
  where: PrmCurriculumLessonReportWhereInput;
}>;


export type GetCurriculumLessonReportQuery = { prmCurriculumLessonReport: { averageLessonAssignedCount: number, averageLessonCompletedCount: number, totalLessonCount: number, productCurriculum: { id: number, code: string, name: string } | null, overallCompletionStats: { metSkillPercentage: number, unmetSkillPercentage: number, metSkillWithSupportPercentage: number, metSkillWithoutSupportPercentage: number }, lessons: Array<{ lessonId: number, averageTimeSpentSeconds: number | null, completionStats: { metSkillPercentage: number, unmetSkillPercentage: number, metSkillWithSupportPercentage: number, metSkillWithoutSupportPercentage: number } | null, lesson: { id: number, lessonNumber: number, title: string, primarySkillPhonics: string | null, primarySkillWordStudy: string | null } | null }> } | null };

export type GetPrmCurriculumProgressReportQueryVariables = Exact<{
  where: PrmCurriculumProgressReportWhereInput;
}>;


export type GetPrmCurriculumProgressReportQuery = { prmCurriculumProgressReport: { overallProgressPercentage: number, curriculums: Array<{ productCurriculumId: number, averageLessonAssignedCount: number, averageLessonCompletedCount: number, totalLessonCount: number, productCurriculum: { id: number, code: string, name: string } | null }> } | null };

export type GetOrganizationEngagementCurriculumReportQueryVariables = Exact<{
  organizationId: Scalars['Int'];
  productCurriculumId: Scalars['Int'];
}>;


export type GetOrganizationEngagementCurriculumReportQuery = { prmOrganizationEngagementCurriculumReport: { productCurriculumId: number, productCurriculum: { id: number, name: string } | null, organizationCurriculumProgress: Array<{ organizationId: number, averageLessonAssignedCount: number, averageLessonCompletedCount: number, totalLessonCount: number, organization: { id: number, name: string } | null, overallCompletionStats: { metSkillPercentage: number, unmetSkillPercentage: number, metSkillWithSupportPercentage: number, metSkillWithoutSupportPercentage: number } }> } | null };

export type GetOrganizationEngagmentOverviewReportQueryVariables = Exact<{
  organizationId: Scalars['Int'];
  licenseUsageWhere?: InputMaybe<LicenseUsageWhereInput>;
}>;


export type GetOrganizationEngagmentOverviewReportQuery = { prmOrganizationEngagementOverviewReport: { organizationOverviews: Array<{ activeStudentCount: number, totalStudentCount: number, averageLessonTimeSpentSeconds: number | null, overallProgressPercentage: number | null, organization: { id: number, name: string, licenseUsage: Array<{ assignedCount: number, product: { code: string, type: ProductType, family: { code: string } }, productCurriculum: { id: number, name: string } | null }> | null } | null }> } | null };

export type GetOrganizationStatsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetOrganizationStatsQuery = { organization: { id: number, type: OrganizationType, name: string, licenseUsage: Array<{ assignedCount: number, classroomAssignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } }> | null, stats: { classroomStudentCount: number, userCount: number, classroomCount: number }, parentOrganization: { id: number, name: string } | null, subOrganizations: Array<{ id: number, name: string, type: OrganizationType } | null> | null } | null };

export type GetStudentCurriculumLessonReportQueryVariables = Exact<{
  studentId: Scalars['Int'];
}>;


export type GetStudentCurriculumLessonReportQuery = { prmStudentCurriculumLessonReport: { studentId: number, student: { id: number, firstName: string, lastName: string, gradeLevel: string, licenseUsage: Array<{ active: boolean, assignedCount: number, productCurriculumId: number | null, productId: number, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null } | null, curriculumDetail: { lessonAssignedCount: number, productCurriculumId: number, lastLoginDate: any | null, currentLessonId: number | null, totalLessonCount: number, productCurriculum: { id: number, code: string, name: string } | null, currentLesson: { lessonNumber: number } | null } | null, lessonDetail: { averageLessonTimeSpentSeconds: number | null, lessons: Array<{ timeSpentSeconds: number | null, lessonId: number, metSkill: boolean | null, usedSupport: boolean | null, lesson: { lessonNumber: number, title: string, primarySkillPhonics: string | null, primarySkillWordStudy: string | null } | null }> } | null } | null };

export type GetPrmStudentEngagementReportQueryVariables = Exact<{
  where: PrmStudentEngagementReportWhereInput;
}>;


export type GetPrmStudentEngagementReportQuery = { prmStudentEngagementReport: { studentCurriculumProgress: Array<{ studentId: number, student: { id: number, firstName: string, lastName: string } | null, lessonCompletionStats: { metSkillWithSupportCount: number, metSkillWithoutSupportCount: number, unmetSkillCount: number } | null }> } | null };

export type GetStudentStatsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetStudentStatsQuery = { student: { id: number, firstName: string, lastName: string, organization: { id: number, name: string, type: OrganizationType, rootOrganization: { id: number, name: string, type: OrganizationType } | null } | null, classrooms: Array<{ id: number, name: string, dateArchived: any | null, organizationId: number }> | null } | null };

export type GetUserStatsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetUserStatsQuery = { user: { id: number, firstName: string, lastName: string, organizationAssociations: Array<{ organization: { id: number, name: string, type: OrganizationType } }> | null, classroomEnrollments: Array<{ classroom: { id: number, licenseUsage: Array<{ productId: number, assignedCount: number, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } } }> | null, stats: { studentCount: number, userCount: number } } }> | null } | null };

export type KeyActiveStudentsReportAsyncQueryVariables = Exact<{
  where: KeyReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type KeyActiveStudentsReportAsyncQuery = { keyActiveStudentsReportAsync: { id: string, error: string | null, result: { activeStudentCount: number, totalStudentCount: number } | null } };

export type KeyActiveStudentsReportQueryVariables = Exact<{
  where: KeyReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type KeyActiveStudentsReportQuery = { keyActiveStudentsReport: { activeStudentCount: number, totalStudentCount: number } };

export type KeyActivitiesCompletedAndTimeSpentReportQueryVariables = Exact<{
  where: KeyActivitiesCompletedAndTimeSpentReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type KeyActivitiesCompletedAndTimeSpentReportQuery = { keyActivitiesCompletedAndTimeSpentReport: { intervalUnit: ReportIntervalUnit, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, intervals: Array<{ interval: any, averageMinutesSpent: number, activitiesCompletedCount: number }> } };

export type KeyActivitiesCompletedReportAsyncQueryVariables = Exact<{
  where: KeyReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type KeyActivitiesCompletedReportAsyncQuery = { keyActivitiesCompletedReportAsync: { id: string, error: string | null, result: { totalActivitiesCompletedCount: number, curriculumActivitiesCompleted: Array<{ productCurriculumCode: string, activitiesCompletedCount: number }> | null } | null } };

export type GetAssessmentAndEnrichmentActivityReportQueryVariables = Exact<{
  where: KeyAssessmentAndEnrichmentActivityReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetAssessmentAndEnrichmentActivityReportQuery = { keyAssessmentAndEnrichmentActivityReport: { spotChecks: { totalCompletedCount: number, studentCompletedCount: number | null, averageWpm: number, averageAccuracy: number }, enrichmentActivities: { hearItTypeIt: { totalCompletedCount: number, studentCompletedCount: number | null } | null, myChoiceKeyboarding: { totalCompletedCount: number, studentCompletedCount: number | null } | null }, teacherCreatedActivities: { totalCompletedCount: number, studentCompletedCount: number | null, averageWpm: number, averageAccuracy: number } | null, assessmentAccelerator: Array<{ totalSecondsSpent: number | null, totalFirstAttemptCount: number | null, assignmentStatus: KeyAssessmentAcceleratorModuleAssignmentStatus | null, modules: Array<{ id: number, name: string }> | null }> } };

export type GetAverageWeeklyTimeSpentReportAsyncQueryVariables = Exact<{
  where: KeyReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetAverageWeeklyTimeSpentReportAsyncQuery = { keyAverageWeeklyTimeSpentReportAsync: { id: string, error: string | null, result: { averageWeeklyMinutesSpent: number, curriculumAverageWeeklyTimeSpent: Array<{ productCurriculumCode: string, averageWeeklyMinutesSpent: number }> | null } | null } };

export type GetClassroomEngagementReportQueryVariables = Exact<{
  where: KeyClassroomEngagementReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetClassroomEngagementReportQuery = { keyClassroomEngagementReport: { assessmentAccelerator: { averageAttemptCount: number | null, averageFirstAttemptCount: number | null, averageSecondsSpent: number | null, activityTypes: Array<{ activityType: { id: number, name: string } | null, modules: Array<{ averageAttemptCount: number | null, averageSecondsSpent: number | null, modules: Array<{ name: string, id: number }> | null }> }> | null, modules: Array<{ averageSecondsSpent: number | null, averageAttemptCount: number | null, averageFirstAttemptCount: number | null, modules: Array<{ name: string, id: number }> | null, activityTypes: Array<{ averageSecondsSpent: number | null, totalCompletedCount: number | null, averageAttemptCount: number | null, totalFirstAttemptCount: number | null, activityType: { id: number, name: string } | null }> | null }> | null } | null, students: Array<{ productCurriculumCode: string | null, lastLoginDate: any | null, curriculumWeek: number, curriculumProgressPercentage: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, student: { id: number, firstName: string, lastName: string, gradeLevel: string } | null, spotChecks: { totalCompletedCount: number, dateLastCompleted: any | null, averageWpm: number, averageAccuracy: number } | null, scheduledActivities: { assessmentCompletedCount: number, assessmentSkippedCount: number | null, assessmentAverageWpm: number | null, assessmentAverageAccuracy: number | null } | null, teacherCreatedActivities: { totalCompletedCount: number, averageWpm: number, averageAccuracy: number } | null, enrichmentActivities: { hearItTypeItCompletedCount: number, myChoiceKeyboardingCompletedCount: number } | null, assessmentAccelerator: { averageSecondsSpent: number | null, totalCompletedCount: number | null, averageAttemptCount: number | null, totalFirstAttemptCount: number | null, modules: Array<{ averageSecondsSpent: number | null, totalCompletedCount: number | null, averageAttemptCount: number | null, totalFirstAttemptCount: number | null, assignmentStatus: KeyAssessmentAcceleratorModuleAssignmentStatus | null, modules: Array<{ name: string, id: number }> | null }> } | null }> } | null };

export type GetCurriculumProgressReportAsyncQueryVariables = Exact<{
  where: KeyReportWhereInput;
}>;


export type GetCurriculumProgressReportAsyncQuery = { keyCurriculumProgressReportAsync: { id: string, error: string | null, result: { curriculumProgressPercentage: number } | null } };

export type GetCurriculumProgressReportQueryVariables = Exact<{
  where: KeyReportWhereInput;
}>;


export type GetCurriculumProgressReportQuery = { keyCurriculumProgressReport: { curriculumProgressPercentage: number } | null };

export type GetClassroomReportExportingQueryVariables = Exact<{
  id: Scalars['Int'];
  dateRange: DateRangeInput;
}>;


export type GetClassroomReportExportingQuery = { classroom: { activeStudentCount: number, totalStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, curriculumProgressPercentage: number, classroom: { id: number, name: string, sisId: string | null, organizationId: number, organization: { id: number, name: string } | null, licenseUsage: Array<{ assignedCount: number }> | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null } | null }, students: { assessmentAccelerator: { averageAttemptCount: number | null, averageFirstAttemptCount: number | null, averageSecondsSpent: number | null, activityTypes: Array<{ activityType: { id: number, name: string } | null, modules: Array<{ moduleIds: Array<number>, averageAttemptCount: number | null, averageSecondsSpent: number | null }> }> | null } | null, students: Array<{ productCurriculumCode: string | null, lastLoginDate: any | null, curriculumWeek: number, curriculumProgressPercentage: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, student: { id: number, firstName: string, lastName: string, gradeLevel: string, sisId: string | null, organization: { id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null, rootOrganization: { name: string, id: number } | null } | null, classrooms: Array<{ sisId: string | null, id: number, name: string, studentCount: number, color: string, dateArchived: any | null, organization: { id: number, name: string } | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, licenseUsage: Array<{ assignedCount: number, product: { id: number, name: string, code: string, iconUrl: string | null }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null } | null }> | null }> | null } | null, spotChecks: { totalCompletedCount: number, dateLastCompleted: any | null, averageWpm: number, averageAccuracy: number, activities: Array<{ template: string, dateCompleted: any, week: number, wpm: number, accuracy: number }> | null } | null, scheduledActivities: { assessmentCompletedCount: number, assessmentSkippedCount: number | null, assessmentAverageWpm: number | null, assessmentAverageAccuracy: number | null, activities: Array<{ dateCompleted: any, wpm: number | null, accuracy: number | null }> | null } | null, teacherCreatedActivities: { totalCompletedCount: number, averageWpm: number, averageAccuracy: number } | null, enrichmentActivities: { hearItTypeItCompletedCount: number, myChoiceKeyboardingCompletedCount: number } | null }> } | null };

export type GetOrganizationClassroomReportExportingQueryVariables = Exact<{
  id: Scalars['Int'];
  dateRange: DateRangeInput;
}>;


export type GetOrganizationClassroomReportExportingQuery = { organization: { id: number, name: string, type: OrganizationType, stats: { classroomStudentCount: number, userCount: number, classroomCount: number }, subOrganizations: Array<{ type: OrganizationType } | null> | null, licenseUsage: Array<{ classroomAssignedCount: number }> | null } | null, activeStudents: { id: string, error: string | null, result: { activeStudentCount: number, totalStudentCount: number } | null }, activitiesCompleted: { id: string, error: string | null, result: { totalActivitiesCompletedCount: number, curriculumActivitiesCompleted: Array<{ productCurriculumCode: string, activitiesCompletedCount: number }> | null } | null }, averageWeeklyTimeSpent: { id: string, error: string | null, result: { averageWeeklyMinutesSpent: number, curriculumAverageWeeklyTimeSpent: Array<{ productCurriculumCode: string, averageWeeklyMinutesSpent: number }> | null } | null }, curriculumProgress: { id: string, error: string | null, result: { curriculumProgressPercentage: number } | null }, classrooms: { id: string, error: string | null, result: Array<{ activeStudentCount: number, totalStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, curriculumProgressPercentage: number, classroom: { id: number, name: string, sisId: string | null, organizationId: number, organization: { id: number, name: string } | null, licenseUsage: Array<{ assignedCount: number }> | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string } }> | null } | null }> | null } };

export type GetOrganizationReportExportingQueryVariables = Exact<{
  id: Scalars['Int'];
  dateRange: DateRangeInput;
}>;


export type GetOrganizationReportExportingQuery = { organization: { id: number, name: string, type: OrganizationType, stats: { classroomStudentCount: number, userCount: number, classroomCount: number }, subOrganizations: Array<{ type: OrganizationType } | null> | null, licenseUsage: Array<{ classroomAssignedCount: number }> | null } | null, activeStudents: { id: string, error: string | null, result: { activeStudentCount: number, totalStudentCount: number } | null }, activitiesCompleted: { id: string, error: string | null, result: { totalActivitiesCompletedCount: number, curriculumActivitiesCompleted: Array<{ productCurriculumCode: string, activitiesCompletedCount: number }> | null } | null }, averageWeeklyTimeSpent: { id: string, error: string | null, result: { averageWeeklyMinutesSpent: number, curriculumAverageWeeklyTimeSpent: Array<{ productCurriculumCode: string, averageWeeklyMinutesSpent: number }> | null } | null }, curriculumProgress: { id: string, error: string | null, result: { curriculumProgressPercentage: number } | null }, schools: { id: string, error: string | null, result: Array<{ activeStudentCount: number, totalStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, curriculumProgressPercentage: number, organization: { id: number, name: string, type: OrganizationType, stats: { classroomStudentCount: number, userCount: number, classroomCount: number }, subOrganizations: Array<{ type: OrganizationType } | null> | null, licenseUsage: Array<{ classroomAssignedCount: number }> | null } | null, curriculumActivitiesCompleted: Array<{ productCurriculumCode: string, activitiesCompletedCount: number }> | null, curriculumAverageWeeklyTimeSpent: Array<{ productCurriculumCode: string, averageWeeklyMinutesSpent: number }> | null }> | null } };

export type GetStudentReportExportingQueryVariables = Exact<{
  id: Scalars['Int'];
  dateRange: DateRangeInput;
}>;


export type GetStudentReportExportingQuery = { students: { assessmentAccelerator: { averageAttemptCount: number | null, averageFirstAttemptCount: number | null, averageSecondsSpent: number | null, activityTypes: Array<{ activityType: { id: number, name: string } | null, modules: Array<{ moduleIds: Array<number>, averageAttemptCount: number | null, averageSecondsSpent: number | null }> }> | null } | null, students: Array<{ productCurriculumCode: string | null, lastLoginDate: any | null, curriculumWeek: number, curriculumProgressPercentage: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, student: { id: number, firstName: string, lastName: string, gradeLevel: string, sisId: string | null, organization: { id: number, sisId: string | null, ncesId: string | null, mdrNumber: string | null, name: string, type: OrganizationType, address: string | null, city: string | null, state: string | null, zip: string | null, parentOrganizationId: number | null, externalId: { sourceId: string, sourceKind: SourceKind } | null, academicSessions: Array<{ id: number, name: string, organizationId: number | null, dateTermStart: any, dateTermEnd: any, sourceKindId: number | null, sourceKind: string | null } | null> | null, rootOrganization: { name: string, id: number } | null } | null, classrooms: Array<{ sisId: string | null, id: number, name: string, studentCount: number, color: string, dateArchived: any | null, organization: { id: number, name: string } | null, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null, licenseUsage: Array<{ assignedCount: number, product: { id: number, name: string, code: string, iconUrl: string | null }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null } | null }> | null }> | null } | null, spotChecks: { totalCompletedCount: number, dateLastCompleted: any | null, averageWpm: number, averageAccuracy: number, activities: Array<{ template: string, dateCompleted: any, week: number, wpm: number, accuracy: number }> | null } | null, scheduledActivities: { assessmentCompletedCount: number, assessmentSkippedCount: number | null, assessmentAverageWpm: number | null, assessmentAverageAccuracy: number | null, activities: Array<{ dateCompleted: any, wpm: number | null, accuracy: number | null }> | null } | null, teacherCreatedActivities: { totalCompletedCount: number, averageWpm: number, averageAccuracy: number } | null, enrichmentActivities: { hearItTypeItCompletedCount: number, myChoiceKeyboardingCompletedCount: number } | null }> } | null };

export type GetUserReportExportingQueryVariables = Exact<{
  id: Scalars['Int'];
  dateRange: DateRangeInput;
}>;


export type GetUserReportExportingQuery = { user: { id: number, firstName: string, lastName: string, sisId: string | null } | null, classrooms: { id: string, error: string | null, result: Array<{ activeStudentCount: number, totalStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, curriculumProgressPercentage: number, classroom: { id: number, name: string, sisId: string | null, organizationId: number, organization: { id: number, name: string } | null, licenseUsage: Array<{ assignedCount: number }> | null } | null }> | null }, students: { id: string, error: string | null, result: { assessmentAccelerator: { averageAttemptCount: number | null, averageFirstAttemptCount: number | null, averageSecondsSpent: number | null, activityTypes: Array<{ activityType: { id: number, name: string } | null, modules: Array<{ moduleIds: Array<number>, averageAttemptCount: number | null, averageSecondsSpent: number | null }> }> | null } | null, students: Array<{ productCurriculumCode: string | null, lastLoginDate: any | null, curriculumWeek: number, curriculumProgressPercentage: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, student: { id: number, firstName: string, lastName: string, gradeLevel: string, sisId: string | null, organization: { id: number, sisId: string | null, name: string, type: OrganizationType, parentOrganizationId: number | null, rootOrganization: { name: string, id: number } | null } | null, classrooms: Array<{ id: number, sisId: string | null, name: string, users: Array<{ userId: number, user: { firstName: string, lastName: string }, classroomRoles: Array<{ name: string, displayName: string, classification: ClassroomRoleClassification }> }> | null }> | null } | null, spotChecks: { totalCompletedCount: number, dateLastCompleted: any | null, averageWpm: number, averageAccuracy: number, activities: Array<{ template: string, dateCompleted: any, week: number, wpm: number, accuracy: number }> | null } | null, scheduledActivities: { assessmentCompletedCount: number, assessmentSkippedCount: number | null, assessmentAverageWpm: number | null, assessmentAverageAccuracy: number | null, activities: Array<{ dateCompleted: any, wpm: number | null, accuracy: number | null }> | null } | null, teacherCreatedActivities: { totalCompletedCount: number, averageWpm: number, averageAccuracy: number } | null, enrichmentActivities: { hearItTypeItCompletedCount: number, myChoiceKeyboardingCompletedCount: number } | null }> } | null } };

export type GetOrganizationClassroomEngagementReportAsyncQueryVariables = Exact<{
  where: KeyOrganizationClassroomEngagementReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetOrganizationClassroomEngagementReportAsyncQuery = { keyOrganizationClassroomEngagementReportAsync: { id: string, error: string | null, result: Array<{ activeStudentCount: number, totalStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, curriculumProgressPercentage: number, classroom: { id: number, name: string, organizationId: number, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string } }> | null } | null }> | null } };

export type GetOrganizationClassroomEngagementReportQueryVariables = Exact<{
  where: KeyOrganizationClassroomEngagementReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetOrganizationClassroomEngagementReportQuery = { keyOrganizationClassroomEngagementReport: Array<{ activeStudentCount: number, totalStudentCount: number, totalActivitiesCompletedCount: number, averageWeeklyMinutesSpent: number, curriculumProgressPercentage: number, classroom: { id: number, name: string, organizationId: number, users: Array<{ userId: number, user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null }, classroomRoles: Array<{ id: number, name: string, displayName: string, classification: ClassroomRoleClassification, appId: number | null, organizationId: number | null, privileges: Array<{ id: number, name: string, displayName: string } | null> | null }> }> | null } | null }> | null };

export type GetStudentEngagementReportQueryVariables = Exact<{
  where: KeyStudentEngagementReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetStudentEngagementReportQuery = { keyStudentEngagementReport: { spotChecks: Array<{ template: string, dateCompleted: any, wpm: number, accuracy: number }> | null, assessments: Array<{ dateCompleted: any, aborted: boolean | null, averageWpm: number, averageAccuracy: number, activities: Array<{ template: string, aborted: boolean | null, wpm: number, accuracy: number }> | null }> | null, enrichmentActivities: Array<{ template: string, dateCompleted: any, aborted: boolean | null, retryCount: number | null, wpm: number, accuracy: number }> | null, assessmentAccelerator: { averageAttemptCount: number | null, totalFirstAttemptCount: number | null, totalSecondsSpent: number | null, activityTypes: Array<{ activityType: { id: number, name: string } | null, modules: Array<{ averageAttemptCount: number | null, averageSecondsSpent: number | null, modules: Array<{ name: string, id: number }> | null }> }>, modules: Array<{ totalFirstAttemptCount: number | null, totalSecondsSpent: number | null, averageAttemptCount: number | null, averageSecondsSpent: number | null, dateCompleted: any | null, modules: Array<{ name: string, id: number }> | null, attempts: Array<{ dateCompleted: any | null, activities: Array<{ attemptCount: number | null, responseData: any | null, secondsSpent: number | null, activity: { id: number, name: string, title: string, description: string } | null }> }> }> } | null, student: { firstName: string, lastName: string, gradeLevel: string, classrooms: Array<{ name: string }> | null } | null } };

export type GetStudentProgressReportQueryVariables = Exact<{
  where: KeyStudentProgressReportWhereInput;
  settingsWhere: PliStudentSettingsWhereInput;
  dateRange: DateRangeInput;
}>;


export type GetStudentProgressReportQuery = { keyStudentSettings: { oneHandedTypingHand: KeyOneHandedTypingHand | null } | null, keyStudentProgressReport: { productCurriculumCode: string | null, dateLastLogin: any | null, skipJumpInEnabled: boolean, stopAndReviewEnabled: boolean, stopAndReviewWeek: number | null, student: { id: number, gradeLevel: string } | null, curriculumProgress: { activeDayCount: number, activityCompletedCount: number, activityTotalCount: number, curriculumProgressPercentage: number, curriculumWeek: number, curriculumWeekTotal: number, spotCheckCompletedCount: number, spotCheckTotalCount: number } | null } };

export type WdtActiveStudentsReportQueryVariables = Exact<{
  where: WdtActiveStudentsReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type WdtActiveStudentsReportQuery = { wdtActiveStudentsReport: { activeStudentCount: number, totalStudentCount: number } };

export type WdtCharactersCompletedAndTimeSpentReportQueryVariables = Exact<{
  where: WdtCharactersCompletedAndTimeSpentReportWhereInput;
  dateRange: DateRangeInput;
}>;


export type WdtCharactersCompletedAndTimeSpentReportQuery = { wdtCharactersCompletedAndTimeSpentReport: { intervalUnit: ReportIntervalUnit, totalCharactersCompletedCount: number, averageMinutesSpent: number, intervals: Array<{ interval: any, averageMinutesSpent: number, charactersCompletedCount: number }> } };

export type WdtClassroomErrorsByCharactersReportQueryVariables = Exact<{
  where: WdtClassroomErrorsByCharactersReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtClassroomErrorsByCharactersReportQuery = { wdtClassroomErrorsByCharactersReport: { classroomId: number, characterOrder: WdtCharacterOrder, characterGroups: Array<{ id: number, name: string | null }>, characterErrors: Array<{ character: { id: number, characterGroupIds: Array<number>, character: string }, errors: Array<{ type: string, count: number }> }> | null } };

export type WdtClassroomErrorsByStudentsReportQueryVariables = Exact<{
  where: WdtClassroomErrorsByStudentsReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtClassroomErrorsByStudentsReportQuery = { wdtClassroomErrorsByStudentsReport: { classroomId: number, studentErrors: Array<{ student: { __typename: 'Student', id: number, firstName: string, lastName: string, gradeLevel: string } | null, errors: Array<{ type: string, count: number }> }> | null } };

export type WdtClassroomOverallProgressReportQueryVariables = Exact<{
  where: WdtClassroomOverallProgressReportWhereInput;
}>;


export type WdtClassroomOverallProgressReportQuery = { wdtClassroomOverallProgressReport: { totalStudentCount: number, progress: Array<{ module: string, level: number, charactersCompletedCount: number }> | null } };

export type WdtClassroomProgressByCharactersReportQueryVariables = Exact<{
  where: WdtClassroomProgressByCharactersReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtClassroomProgressByCharactersReportQuery = { wdtClassroomProgressByCharactersReport: { classroomId: number, characterOrder: WdtCharacterOrder, characterGroups: Array<{ id: number, name: string | null }>, characterProgress: Array<{ character: { id: number, characterGroupIds: Array<number>, character: string }, characterLevelsProgress: Array<{ level: number, studentCompletedCount: number }> }> | null } };

export type WdtClassroomProgressByStudentsReportQueryVariables = Exact<{
  where: WdtClassroomProgressByStudentsReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtClassroomProgressByStudentsReportQuery = { wdtClassroomProgressByStudentsReport: { studentProgress: Array<{ level: number, charactersCompletedCount: number, student: { __typename: 'Student', id: number, firstName: string, lastName: string, gradeLevel: string } | null }> | null } };

export type WdtOverallErrorsReportQueryVariables = Exact<{
  where: WdtOverallErrorsReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtOverallErrorsReportQuery = { wdtOverallErrorsReport: { errors: Array<{ type: string, count: number }> } };

export type WdtStudentErrorsReportQueryVariables = Exact<{
  where: WdtStudentErrorsReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtStudentErrorsReportQuery = { wdtStudentErrorsReport: { studentId: number, characterOrder: WdtCharacterOrder, characterGroups: Array<{ id: number, name: string | null }>, characterErrors: Array<{ character: { id: number, characterGroupIds: Array<number>, character: string }, errors: Array<{ type: string, count: number }> }> | null } };

export type WdtOverallStudentProgressReportQueryVariables = Exact<{
  where: WdtStudentOverallProgressReportWhereInput;
}>;


export type WdtOverallStudentProgressReportQuery = { wdtStudentOverallProgressReport: { progress: Array<{ module: string, level: number, charactersCompletedCount: number }> | null } };

export type WdtStudentProgressReportQueryVariables = Exact<{
  where: WdtStudentProgressReportWhereInput;
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type WdtStudentProgressReportQuery = { wdtStudentProgressReport: { studentId: number, characterOrder: WdtCharacterOrder, characterGroups: Array<{ id: number, name: string | null }>, characterProgress: Array<{ level: number, character: { id: number, characterGroupIds: Array<number>, character: string } }> | null } };

export type WdtStudentSettingsReportQueryVariables = Exact<{
  studentId: Scalars['Int'];
}>;


export type WdtStudentSettingsReportQuery = { wdtStudentSettings: { handedness: { leftHanded: boolean, rtlCrossStroke: boolean | null } | null, characterOrder: { numbers: WdtCharacterOrder | null, capitals: WdtCharacterOrder | null, lowercase: WdtCharacterOrder | null } | null } | null, student: { classrooms: Array<{ id: number }> | null } | null };

export type GetResourceTypesQueryVariables = Exact<{
  where?: InputMaybe<ResourceTypesWhereInput>;
}>;


export type GetResourceTypesQuery = { resourceTypes: Array<{ id: number, type: string, title: string, description: string, sortIndex: number, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null }, imageAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } }> };

export type KeyboardingCurriculumsQueryVariables = Exact<{
  where?: InputMaybe<KeyboardingCurriculumsWhereInput>;
}>;


export type KeyboardingCurriculumsQuery = { keyboardingCurriculums: Array<{ id: number, name: string, curriculumActivities: Array<{ id: number, curriculumId: number, curriculumWeekId: number, activityId: number, sequenceNumber: number, dayOfWeek: Weekday | null, enrichment: boolean, spotCheck: boolean, activity: { title: string, url: string, name: string, thumbnail: { src: string | null } | null, activityTypeVariant: { name: string, videos: Array<{ device: ClientDevice, video: { src: string | null } } | null> } }, curriculumWeek: { week: number, keys: string | null, curriculumTheme: { name: string, id: number, thumbnail: { src: string | null } } } }> } | null> };

export type KeyboardingModulesQueryVariables = Exact<{
  where: KeyboardingModulesWhereInput;
}>;


export type KeyboardingModulesQuery = { keyboardingModules: Array<{ id: number, name: string, description: string, productCurriculumId: number, thumbnailId: number, productCurriculum: { id: number, name: string, code: string } | null, thumbnail: { id: number, src: string | null } | null, submodules: Array<{ id: number, name: string, description: string, productCurriculumId: number, thumbnailId: number, productCurriculum: { id: number, name: string, code: string } | null, thumbnail: { id: number, src: string | null } | null, activities: Array<{ id: number, name: string, title: string, description: string, category: KeyboardingActivityCategory, url: string } | null> | null }> | null } | null> };

export type GetResourcesWithAssetsQueryVariables = Exact<{
  where?: InputMaybe<ResourcesWhereInput>;
}>;


export type GetResourcesWithAssetsQuery = { resources: Array<{ id: number | null, link: string | null, grades: Array<string | null> | null, title: string, description: string | null, productCodes: Array<string | null> | null, type: { id: number, type: string, title: string, description: string, sortIndex: number, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null }, imageAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } }, productFamily: { id: number, name: string } | null, thumbnailAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null }, resourceAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } | null }> };

export type AzsappClassroomSettingsQueryVariables = Exact<{
  where: PliClassroomSettingsWhereInput;
}>;


export type AzsappClassroomSettingsQuery = { azsappClassroomSettings: { accessBookAfterAssignment: { enabled: boolean | null } | null } | null };

export type UpdateAzsappClassroomSettingExposeLetterBooksMutationVariables = Exact<{
  data: Array<UpdateAzsappClassroomSettingExposeLetterBooksInput> | UpdateAzsappClassroomSettingExposeLetterBooksInput;
}>;


export type UpdateAzsappClassroomSettingExposeLetterBooksMutation = { updateAzsappClassroomSettingExposeLetterBooks: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } } | null> };

export type RemoveStudentSettingMutationMutationVariables = Exact<{
  where: StudentSettingWhereInput;
}>;


export type RemoveStudentSettingMutationMutation = { removeStudentSetting: any | null };

export type RemoveStudentSettingsMutationMutationVariables = Exact<{
  where: StudentSettingsWhereInput;
}>;


export type RemoveStudentSettingsMutationMutation = { removeStudentSettings: { count: number | null } | null };

export type GssClassroomSettingsQueryVariables = Exact<{
  where: PliClassroomSettingsWhereInput;
}>;


export type GssClassroomSettingsQuery = { gssClassroomSettings: { locale: Locale | null, handedness: { leftHanded: boolean, rtlCrossStroke: boolean | null } | null, characterOrder: { letters: GssCharacterOrder | null, numbers: GssCharacterOrder | null, wdtNumbers: GssCharacterOrder | null, wdtLowercase: GssCharacterOrder | null, wdtCapitals: GssCharacterOrder | null } | null } | null };

export type GssStudentSettingsQueryVariables = Exact<{
  where: PliStudentSettingsWhereInput;
}>;


export type GssStudentSettingsQuery = { gssStudentSettings: { locale: Locale | null, handedness: { leftHanded: boolean, rtlCrossStroke: boolean | null } | null, characterOrder: { letters: GssCharacterOrder | null, numbers: GssCharacterOrder | null, wdtNumbers: GssCharacterOrder | null, wdtLowercase: GssCharacterOrder | null, wdtCapitals: GssCharacterOrder | null } | null } | null };

export type UpdateGssClassroomSettingCharacterOrderMutationVariables = Exact<{
  data: Array<UpdateGssClassroomSettingCharacterOrderInput> | UpdateGssClassroomSettingCharacterOrderInput;
}>;


export type UpdateGssClassroomSettingCharacterOrderMutation = { updateGssClassroomSettingCharacterOrder: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } }> };

export type UpdateGssClassroomSettingLanguageMutationVariables = Exact<{
  data: Array<UpdateGssClassroomSettingLocaleInput> | UpdateGssClassroomSettingLocaleInput;
}>;


export type UpdateGssClassroomSettingLanguageMutation = { updateGssClassroomSettingLanguage: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } }> };

export type UpdateGssStudentSettingCharacterOrderMutationVariables = Exact<{
  data: Array<UpdateGssStudentSettingCharacterOrderInput> | UpdateGssStudentSettingCharacterOrderInput;
}>;


export type UpdateGssStudentSettingCharacterOrderMutation = { updateGssStudentSettingCharacterOrder: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type UpdateGssStudentSettingLanguageMutationVariables = Exact<{
  data: Array<UpdateGssStudentSettingLocaleInput> | UpdateGssStudentSettingLocaleInput;
}>;


export type UpdateGssStudentSettingLanguageMutation = { updateGssStudentSettingLanguage: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type UpdateGssStudentSettingLeftHandednessMutationVariables = Exact<{
  data: Array<UpdateGssStudentSettingLeftHandednessInput> | UpdateGssStudentSettingLeftHandednessInput;
}>;


export type UpdateGssStudentSettingLeftHandednessMutation = { updateGssStudentSettingLeftHandedness: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type HwtClassroomSettingsQueryVariables = Exact<{
  where: PliClassroomSettingsWhereInput;
}>;


export type HwtClassroomSettingsQuery = { hwtClassroomSettings: { locale: Locale | null } | null };

export type HwtStudentSettingsQueryVariables = Exact<{
  where: PliStudentSettingsWhereInput;
}>;


export type HwtStudentSettingsQuery = { hwtStudentSettings: { locale: Locale | null } | null };

export type UpdateHwtClassroomSettingLanguageMutationVariables = Exact<{
  data: Array<UpdateHwtClassroomSettingLocaleInput> | UpdateHwtClassroomSettingLocaleInput;
}>;


export type UpdateHwtClassroomSettingLanguageMutation = { updateHwtClassroomSettingLanguage: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } }> };

export type UpdateHwtStudentSettingLanguageMutationVariables = Exact<{
  data: Array<UpdateHwtStudentSettingLocaleInput> | UpdateHwtStudentSettingLocaleInput;
}>;


export type UpdateHwtStudentSettingLanguageMutation = { updateHwtStudentSettingLanguage: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type CreateKeyTeacherCreatedActivityPreviewMutationVariables = Exact<{
  data: KeyTeacherCreatedActivityPreviewInput;
}>;


export type CreateKeyTeacherCreatedActivityPreviewMutation = { createKeyTeacherCreatedActivityPreview: { id: string, url: string } };

export type KeyClassroomSettingsQueryVariables = Exact<{
  where: PliClassroomSettingsWhereInput;
}>;


export type KeyClassroomSettingsQuery = { keyClassroomSettings: { homeUse: { enabled: boolean, students: Array<{ studentId: number, productCurriculumCode: string, homeUse: { KEYK: string | null, KEY1: string | null, KEY2: string | null, KEY3: string | null, KEY4: string | null, KEY5: string | null, contactEmail: string | null } | null }> | null } | null, skipJumpIn: { enabled: boolean | null } | null, stopAndReview: { week: number | null, enabled: boolean | null } | null, assessmentSettings: { activityTypeId: string, assessOnLoginDate: any | null, scheduleType: ScheduledActivityScheduleType | null, scheduledDates: Array<any> | null } | null, enrichmentActivitySettings: { hearItTypeIt: { enabled: boolean | null } | null, myChoiceKeyboarding: { enabled: boolean | null } | null, teacherCreated: { enabled: boolean, activities: Array<{ id: number, title: string, text: string, date: any, activityGroupCount: number | null }> | null } | null } | null, assessmentAcceleratorSettings: { activityTypeId: string, scheduledDates: Array<{ date: any, moduleIds: Array<number> }> | null } | null } | null };

export type KeyStudentSettingsQueryVariables = Exact<{
  where: PliStudentSettingsWhereInput;
}>;


export type KeyStudentSettingsQuery = { keyStudentSettings: { oneHandedTypingHand: KeyOneHandedTypingHand | null, homeUse: { KEYK: string | null, KEY1: string | null, KEY2: string | null, KEY3: string | null, KEY4: string | null, KEY5: string | null, contactEmail: string | null } | null, skipJumpIn: { KEYK: boolean | null, KEY1: boolean | null, KEY2: boolean | null, KEY3: boolean | null, KEY4: boolean | null, KEY5: boolean | null } | null, stopAndReview: { KEYK: { week: number | null, enabled: boolean | null } | null, KEY1: { week: number | null, enabled: boolean | null } | null, KEY2: { week: number | null, enabled: boolean | null } | null, KEY3: { week: number | null, enabled: boolean | null } | null, KEY4: { week: number | null, enabled: boolean | null } | null, KEY5: { week: number | null, enabled: boolean | null } | null } | null } | null };

export type UpdateKeyClassroomSettingAssessmentsMutationVariables = Exact<{
  data: UpdateKeyClassroomSettingScheduledActivityInput;
}>;


export type UpdateKeyClassroomSettingAssessmentsMutation = { updateKeyClassroomSettingAssessments: { activityTypeId: string, assessOnLoginDate: any | null, scheduleType: ScheduledActivityScheduleType | null, scheduledDates: Array<any> | null } };

export type UpdateKeyClassroomSettingEnrichmentActivitiesMutationVariables = Exact<{
  data: UpdateKeyClassroomSettingEnrichmentInput;
}>;


export type UpdateKeyClassroomSettingEnrichmentActivitiesMutation = { updateKeyClassroomSettingEnrichmentActivities: { hearItTypeIt: { enabled: boolean | null } | null, myChoiceKeyboarding: { enabled: boolean | null } | null, teacherCreated: { enabled: boolean, activities: Array<{ id: number, title: string, text: string, date: any, activityGroupCount: number | null }> | null } | null } };

export type UpdateKeyClassroomSettingHomeUseMutationVariables = Exact<{
  data: UpdateKeyClassroomSettingHomeUseInput;
}>;


export type UpdateKeyClassroomSettingHomeUseMutation = { updateKeyClassroomSettingHomeUse: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } } | null> };

export type UpdateKeyClassroomSettingSkipJumpInMutationVariables = Exact<{
  data: Array<UpdateKeyClassroomSettingSkipJumpInInput> | UpdateKeyClassroomSettingSkipJumpInInput;
}>;


export type UpdateKeyClassroomSettingSkipJumpInMutation = { updateKeyClassroomSettingSkipJumpIn: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } } | null> };

export type UpdateKeyClassroomSettingStopAndReviewMutationVariables = Exact<{
  data: Array<UpdateKeyClassroomSettingStopAndReviewInput> | UpdateKeyClassroomSettingStopAndReviewInput;
}>;


export type UpdateKeyClassroomSettingStopAndReviewMutation = { updateKeyClassroomSettingStopAndReview: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } }> };

export type UpdateKeyStudentSettingHomeUseMutationVariables = Exact<{
  data: Array<UpdateKeyStudentSettingHomeUseInput> | UpdateKeyStudentSettingHomeUseInput;
}>;


export type UpdateKeyStudentSettingHomeUseMutation = { updateKeyStudentSettingHomeUse: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } } | null> };

export type UpdateKeyStudentSettingOneHandedTypingHandMutationVariables = Exact<{
  data: Array<UpdateKeyStudentSettingOneHandedTypingHandInput> | UpdateKeyStudentSettingOneHandedTypingHandInput;
}>;


export type UpdateKeyStudentSettingOneHandedTypingHandMutation = { updateKeyStudentSettingOneHandedTypingHand: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } } | null> };

export type UpdateKeyStudentSettingSkipJumpInMutationVariables = Exact<{
  data: Array<UpdateKeyStudentSettingSkipJumpInInput> | UpdateKeyStudentSettingSkipJumpInInput;
}>;


export type UpdateKeyStudentSettingSkipJumpInMutation = { updateKeyStudentSettingSkipJumpIn: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type UpdateKeyStudentSettingStopAndReviewMutationVariables = Exact<{
  data: Array<UpdateKeyStudentSettingStopAndReviewInput> | UpdateKeyStudentSettingStopAndReviewInput;
}>;


export type UpdateKeyStudentSettingStopAndReviewMutation = { updateKeyStudentSettingStopAndReview: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type UpdatePliUserSettingMutationVariables = Exact<{
  data: PliUserSettingInput;
}>;


export type UpdatePliUserSettingMutation = { updatePliUserSetting: { id: number, setting: string, userId: number, value: any, dateCreated: any, dateUpdated: any, app: { id: number, name: string, data: any | null } } };

export type UpdateUserSettingPliOnboardingWelcomeMutationVariables = Exact<{
  data: PliUserOnboardingWelcomeDataInput;
}>;


export type UpdateUserSettingPliOnboardingWelcomeMutation = { updateUserSettingPliOnboardingWelcome: { setting: string, value: any } };

export type WdtClassroomSettingsQueryVariables = Exact<{
  where: PliClassroomSettingsWhereInput;
}>;


export type WdtClassroomSettingsQuery = { wdtClassroomSettings: { handedness: { leftHanded: boolean, rtlCrossStroke: boolean | null } | null, characterOrder: { numbers: WdtCharacterOrder | null, capitals: WdtCharacterOrder | null, lowercase: WdtCharacterOrder | null } | null } | null };

export type WdtStudentSettingsQueryVariables = Exact<{
  where: PliStudentSettingsWhereInput;
}>;


export type WdtStudentSettingsQuery = { wdtStudentSettings: { handedness: { leftHanded: boolean, rtlCrossStroke: boolean | null } | null, characterOrder: { numbers: WdtCharacterOrder | null, capitals: WdtCharacterOrder | null, lowercase: WdtCharacterOrder | null } | null } | null };

export type UpdateWdtClassroomSettingCharacterOrderMutationVariables = Exact<{
  data: Array<UpdateWdtClassroomSettingCharacterOrderInput> | UpdateWdtClassroomSettingCharacterOrderInput;
}>;


export type UpdateWdtClassroomSettingCharacterOrderMutation = { updateWdtClassroomSettingCharacterOrder: Array<{ setting: string, value: any, classroom: { id: number }, app: { id: number, name: string } }> };

export type UpdateWdtStudentSettingCharacterOrderMutationVariables = Exact<{
  data: Array<UpdateWdtStudentSettingCharacterOrderInput> | UpdateWdtStudentSettingCharacterOrderInput;
}>;


export type UpdateWdtStudentSettingCharacterOrderMutation = { updateWdtStudentSettingCharacterOrder: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type UpdateWdtStudentSettingLeftHandednessMutationVariables = Exact<{
  data: Array<UpdateWdtStudentSettingLeftHandednessInput> | UpdateWdtStudentSettingLeftHandednessInput;
}>;


export type UpdateWdtStudentSettingLeftHandednessMutation = { updateWdtStudentSettingLeftHandedness: Array<{ setting: string, value: any, student: { id: number }, app: { id: number } }> };

export type CreateStudentsMutationVariables = Exact<{
  students: Array<StudentCreateInput> | StudentCreateInput;
}>;


export type CreateStudentsMutation = { createStudents: Array<{ id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number } | null> };

export type GetBaseStudentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetBaseStudentQuery = { entity: { id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number } | null };

export type GetStudentQueryQueryVariables = Exact<{
  where: StudentWhereInput;
}>;


export type GetStudentQueryQuery = { student: { id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number, licenseUsage: Array<{ productId: number, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, groups: Array<{ id: number, appId: number, classroomId: number, name: string, groupCategory: { appId: number, classroomId: number, name: string } }> | null } | null };

export type GetStudentSettingsQueryVariables = Exact<{
  where: StudentSettingsWhereInput;
}>;


export type GetStudentSettingsQuery = { studentSettings: Array<{ id: number, setting: string, studentId: number, value: any, dateCreated: any, dateUpdated: any, app: { id: number } } | null> };

export type GetStudentWithLicenseUsageQueryQueryVariables = Exact<{
  where: StudentWhereInput;
}>;


export type GetStudentWithLicenseUsageQueryQuery = { student: { id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number, licenseUsage: Array<{ productId: number, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null } | null };

export type RemoveStudentMutationMutationVariables = Exact<{
  where: StudentWhereInput;
}>;


export type RemoveStudentMutationMutation = { removeStudent: { id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number } | null };

export type RemoveStudentsMutationMutationVariables = Exact<{
  where: StudentsWhereInput;
}>;


export type RemoveStudentsMutationMutation = { removeStudents: { count: number | null } | null };

export type SearchStudentsQueryVariables = Exact<{
  searchText: Scalars['String'];
  classroomIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchStudentsQuery = { studentSearch: Array<{ id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number }> };

export type TransferStudentMutationVariables = Exact<{
  where: TransferStudentWhereInput;
  data: TransferStudentInput;
}>;


export type TransferStudentMutation = { transferStudent: { id: number } | null };

export type UpdateStudentMutationMutationVariables = Exact<{
  where: StudentWhereInput;
  data: StudentUpdateInput;
}>;


export type UpdateStudentMutationMutation = { updateStudent: { id: number, username: string, firstName: string, lastName: string, email: string | null, loginType: StudentLoginType, password: string | null, gradeLevel: string, organizationId: number, groups: Array<{ id: number, appId: number, classroomId: number, name: string, groupCategory: { appId: number, classroomId: number, name: string } }> | null } | null };

export type GetAllSupportCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSupportCategoriesQuery = { supportCategories: Array<{ id: number, iconAssetId: number, title: string, description: string | null, sortIndex: number, locale: Locale, data: any | null, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } }> };

export type SendSupportTicketMutationMutationVariables = Exact<{
  data: SendSupportTicketInput;
}>;


export type SendSupportTicketMutationMutation = { sendSupportTicket: boolean | null };

export type GetSupportCategoryQueryVariables = Exact<{
  where: SupportCategoryWhereInput;
}>;


export type GetSupportCategoryQuery = { supportCategory: { id: number, iconAssetId: number, title: string, description: string | null, sortIndex: number, locale: Locale, data: any | null, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null }, supportTopics: Array<{ id: number, title: string, description: string | null, sortIndex: number, tags: Array<{ id: number, tagGroup: string | null, value: string }> | null }> | null } | null };

export type GetSupportTopicQueryVariables = Exact<{
  where: SupportTopicWhereInput;
}>;


export type GetSupportTopicQuery = { supportTopic: { id: number, title: string, description: string | null, sortIndex: number, content: string, tags: Array<{ id: number, tagGroup: string | null, value: string }> | null, supportCategories: Array<{ id: number, iconAssetId: number, title: string, description: string | null, sortIndex: number, locale: Locale, data: any | null, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } }> | null } | null };

export type GetSupportTopicsQueryVariables = Exact<{
  where?: InputMaybe<SupportTopicsWhereInput>;
}>;


export type GetSupportTopicsQuery = { supportTopics: Array<{ id: number, title: string, description: string | null, sortIndex: number, supportCategories: Array<{ id: number, iconAssetId: number, title: string, description: string | null, sortIndex: number, locale: Locale, data: any | null, iconAsset: { id: number, title: string, description: string, locale: Locale, filename: string, src: string | null } }> | null, tags: Array<{ id: number, tagGroup: string | null, value: string }> | null }> };

export type CreateUserMutationVariables = Exact<{
  data: UserCreateInput;
  upsert?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateUserMutation = { createUser: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null } | null };

export type GetAdminUserInformationQueryVariables = Exact<{
  where: UserWhereInput;
}>;


export type GetAdminUserInformationQuery = { user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null, licenseUsage: Array<{ assignedCount: number, trial: boolean, product: { id: number, code: string, name: string, iconUrl: string | null }, productCurriculum: { id: number, code: string, name: string, iconUrl: string | null } | null }> | null, organizationAssociations: Array<{ organizationId: number, organization: { id: number, name: string, licenseUsage: Array<{ availableCount: number, assignedCount: number, siteLicensed: boolean, product: { id: number, code: string, name: string, iconUrl: string | null, type: ProductType, family: { id: number, code: string } }, productCurriculum: { id: number, code: string, name: string, iconUrl: string | null } | null }> | null }, organizationRoles: Array<{ id: number, classification: OrganizationRoleClassification, name: string, displayName: string, appId: number | null, organizationId: number | null, public: boolean }> }> | null } | null };

export type GetUserManagementUsersQueryVariables = Exact<{
  where?: InputMaybe<UsersWhereInput>;
}>;


export type GetUserManagementUsersQuery = { organizations: Array<{ id: number, name: string } | null>, users: Array<{ id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null, licenseUsage: Array<{ productId: number, productCurriculumId: number | null, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, organizationAssociations: Array<{ organizationId: number, organization: { id: number, name: string }, organizationRoles: Array<{ id: number, classification: OrganizationRoleClassification, name: string, displayName: string, appId: number | null, organizationId: number | null, public: boolean }> }> | null }> };

export type GetBaseUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetBaseUserQuery = { entity: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { me: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null, classroomPrivileges: Array<{ classroomId: number, privileges: Array<string> | null }> | null, licenseUsage: Array<{ productId: number, productCurriculumId: number | null, assignedCount: number, active: boolean, trial: boolean, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } | null }> | null, trialUsage: Array<{ productId: number, productCurriculumId: number, active: boolean, available: boolean, dateExpiration: any | null, product: { id: number, code: string, name: string, type: ProductType, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, family: { id: number, code: string, name: string, description: string | null, iconUrl: string | null, bannerUrl: string | null, types: Array<ProductType | null>, pliManaged: boolean | null } }, productCurriculum: { id: number, code: string, name: string, gradeLevel: Array<string> | null, trialAvailable: boolean, iconUrl: string | null, bannerUrl: string | null, productId: number } }> | null, organizationAssociations: Array<{ organizationId: number, organization: { id: number, name: string, externalId: { sourceKind: SourceKind, sourceId: string } | null, parentOrganization: { id: number } | null, licenseUsage: Array<{ totalCount: number, product: { family: { code: string } } }> | null }, organizationRoles: Array<{ id: number, classification: OrganizationRoleClassification, name: string, displayName: string, appId: number | null, organizationId: number | null, public: boolean }> }> | null, organizationPrivileges: Array<{ organizationId: number, privileges: Array<string> | null }> | null, settings: Array<{ id: number, setting: string, userId: number, value: any, dateCreated: any, dateUpdated: any, app: { id: number, name: string, data: any | null } }> | null } | null };

export type GetMyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationsQuery = { me: { organizationAssociations: Array<{ organization: { id: number, name: string, licenseUsage: Array<{ availableCount: number, assignedCount: number, siteLicensed: boolean, product: { id: number, code: string, name: string, iconUrl: string | null, type: ProductType }, productCurriculum: { id: number, code: string, name: string, iconUrl: string | null } | null }> | null } }> | null } | null };

export type GetUserInformationQueryVariables = Exact<{
  where: UserWhereInput;
}>;


export type GetUserInformationQuery = { user: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null, licenseUsage: Array<{ assignedCount: number, product: { id: number, iconUrl: string | null, name: string } }> | null, classroomEnrollments: Array<{ classroom: { id: number, sisId: string | null, name: string, color: string, loginType: StudentLoginType, organizationId: number, academicSessionId: number | null, dateArchived: any | null, dateRemoved: any | null, licenseUsage: Array<{ assignedCount: number, product: { id: number, iconUrl: string | null }, productCurriculum: { id: number, iconUrl: string | null } | null }> | null, stats: { studentCount: number, userCount: number } } }> | null, organizationAssociations: Array<{ organization: { id: number, name: string }, organizationRoles: Array<{ id: number, name: string, displayName: string, public: boolean }> }> | null } | null };

export type SearchUsersQueryVariables = Exact<{
  searchText: Scalars['String'];
  classroomIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersQuery = { userSearch: Array<{ id: number, username: string, firstName: string, lastName: string, status: UserStatus }> };

export type UpdateMyAvatarMutationMutationVariables = Exact<{
  data: UserUpdateInput;
}>;


export type UpdateMyAvatarMutationMutation = { updateMe: { id: number, avatarUrl: string | null } | null };

export type UpdateMeMutationMutationVariables = Exact<{
  data: UserUpdateInput;
}>;


export type UpdateMeMutationMutation = { updateMe: { id: number, username: string, firstName: string, lastName: string, pin: string } | null };

export type UpdateUserMutationVariables = Exact<{
  where: UserWhereInput;
  data: UserUpdateInput;
}>;


export type UpdateUserMutation = { updateUser: { id: number, username: string, firstName: string, lastName: string, type: UserType, pin: string, avatarUrl: string | null, status: UserStatus, dateUpdated: any, sisId: string | null, licenseUsage: Array<{ product: { id: number, name: string, iconUrl: string | null } }> | null, organizationAssociations: Array<{ organizationId: number, organization: { id: number, name: string, licenseUsage: Array<{ availableCount: number, assignedCount: number, siteLicensed: boolean, product: { id: number, code: string, name: string, iconUrl: string | null, type: ProductType }, productCurriculum: { id: number, code: string, name: string, iconUrl: string | null } | null }> | null }, organizationRoles: Array<{ id: number, classification: OrganizationRoleClassification, name: string, displayName: string, appId: number | null, organizationId: number | null, public: boolean }> }> | null } | null };

export const OrganizationEngagementFragmentDoc = gql`
    fragment OrganizationEngagement on KeyOrganizationEngagementReportResult {
  organization {
    id
    name
  }
  curriculumProgressPercentage
  totalStudentCount
  activeStudentCount
  totalActivitiesCompletedCount
  averageWeeklyMinutesSpent
}
    `;
export const BaseAppAccessDetailsFragmentDoc = gql`
    fragment BaseAppAccessDetails on AppAccessDetails {
  url
  bannerUrl
  iosUrl
}
    `;
export const BaseAppPurchaseDetailsFragmentDoc = gql`
    fragment BaseAppPurchaseDetails on AppPurchaseDetails {
  title
  description
  url
  salesQuoteUrl
  webstoreUrl
}
    `;
export const BaseUserAvatarFragmentDoc = gql`
    fragment BaseUserAvatar on User {
  id
  avatarUrl
}
    `;
export const BaseAzsappClassroomSettingsFragmentDoc = gql`
    fragment BaseAzsappClassroomSettings on AzsappClassroomSettings {
  accessBookAfterAssignment {
    enabled
  }
}
    `;
export const BaseClassroomStatsFragmentDoc = gql`
    fragment BaseClassroomStats on ClassroomStats {
  studentCount
  userCount
}
    `;
export const BaseGroupsFragmentDoc = gql`
    fragment BaseGroups on Group {
  id
  appId
  classroomId
  name
  groupCategory {
    appId
    classroomId
    name
  }
}
    `;
export const BaseGssClassroomSettingsFragmentDoc = gql`
    fragment BaseGssClassroomSettings on GssClassroomSettings {
  locale
  handedness {
    leftHanded
    rtlCrossStroke
  }
  characterOrder {
    letters
    numbers
    wdtNumbers
    wdtLowercase
    wdtCapitals
  }
}
    `;
export const BaseGssStudentSettingsFragmentDoc = gql`
    fragment BaseGssStudentSettings on GssStudentSettings {
  locale
  handedness {
    leftHanded
    rtlCrossStroke
  }
  characterOrder {
    letters
    numbers
    wdtNumbers
    wdtLowercase
    wdtCapitals
  }
}
    `;
export const BaseHwtStudentSettingsFragmentDoc = gql`
    fragment BaseHwtStudentSettings on HwtStudentSettings {
  locale
}
    `;
export const BaseKeyboardingClassroomExportLegacyFragmentDoc = gql`
    fragment BaseKeyboardingClassroomExportLegacy on KeyOrganizationClassroomEngagementReportResult {
  classroom {
    id
    name
    sisId
    organizationId
    organization {
      id
      name
    }
    licenseUsage(where: {productFamily: {code: "KEY"}}) {
      assignedCount
    }
  }
  activeStudentCount
  totalStudentCount
  totalActivitiesCompletedCount
  averageWeeklyMinutesSpent
  curriculumProgressPercentage
}
    `;
export const BaseKeyboardingClassroomExportFragmentDoc = gql`
    fragment BaseKeyboardingClassroomExport on KeyOrganizationClassroomEngagementReportResult {
  classroom {
    id
    name
    sisId
    organizationId
    organization {
      id
      name
    }
    licenseUsage(where: {productFamily: {code: "KEY"}}) {
      assignedCount
    }
  }
  activeStudentCount
  totalStudentCount
  totalActivitiesCompletedCount
  averageWeeklyMinutesSpent
  curriculumProgressPercentage
}
    `;
export const BaseKeyHomeUseSettingFragmentDoc = gql`
    fragment BaseKeyHomeUseSetting on KeySettingHomeUseData {
  KEYK
  KEY1
  KEY2
  KEY3
  KEY4
  KEY5
  contactEmail
}
    `;
export const BaseKeyScheduledActivitySettingsFragmentDoc = gql`
    fragment BaseKeyScheduledActivitySettings on KeyScheduledActivitySettings {
  activityTypeId
  assessOnLoginDate
  scheduleType
  scheduledDates
}
    `;
export const BaseKeyTeacherCreatedActivityFragmentDoc = gql`
    fragment BaseKeyTeacherCreatedActivity on KeyTeacherCreatedActivity {
  id
  title
  text
  date
  activityGroupCount
}
    `;
export const BaseKeyEnrichmentActivitySettingsFragmentDoc = gql`
    fragment BaseKeyEnrichmentActivitySettings on KeyEnrichmentActivitySettings {
  hearItTypeIt {
    enabled
  }
  myChoiceKeyboarding {
    enabled
  }
  teacherCreated {
    enabled
    activities {
      ...BaseKeyTeacherCreatedActivity
    }
  }
}
    ${BaseKeyTeacherCreatedActivityFragmentDoc}`;
export const BaseKeyboardingClassroomSettingsFragmentDoc = gql`
    fragment BaseKeyboardingClassroomSettings on KeyClassroomSettings {
  homeUse {
    enabled
    students {
      studentId
      productCurriculumCode
      homeUse {
        ...BaseKeyHomeUseSetting
      }
    }
  }
  skipJumpIn {
    enabled
  }
  stopAndReview {
    week
    enabled
  }
  assessmentSettings {
    ...BaseKeyScheduledActivitySettings
  }
  enrichmentActivitySettings {
    ...BaseKeyEnrichmentActivitySettings
  }
  assessmentAcceleratorSettings {
    activityTypeId
    scheduledDates {
      date
      moduleIds
    }
  }
}
    ${BaseKeyHomeUseSettingFragmentDoc}
${BaseKeyScheduledActivitySettingsFragmentDoc}
${BaseKeyEnrichmentActivitySettingsFragmentDoc}`;
export const BaseKeyboadingCurriculumActivityFragmentDoc = gql`
    fragment BaseKeyboadingCurriculumActivity on KeyboardingCurriculumActivity {
  id
  curriculumId
  curriculumWeekId
  activityId
  sequenceNumber
  dayOfWeek
  enrichment
  spotCheck
  activity {
    title
    url
    name
    thumbnail {
      src
    }
    activityTypeVariant {
      name
      videos {
        device
        video {
          src
        }
      }
    }
  }
  curriculumWeek {
    week
    keys
    curriculumTheme {
      name
      id
      thumbnail {
        src
      }
    }
  }
}
    `;
export const BaseExternalIdFragmentDoc = gql`
    fragment BaseExternalId on ExternalId {
  sourceId
  sourceKind
}
    `;
export const BaseAcademicSessionFragmentDoc = gql`
    fragment BaseAcademicSession on AcademicSession {
  id
  name
  organizationId
  dateTermStart
  dateTermEnd
  sourceKindId
  sourceKind
}
    `;
export const BaseOrganizationFragmentDoc = gql`
    fragment BaseOrganization on Organization {
  id
  externalId {
    ...BaseExternalId
  }
  sisId
  ncesId
  mdrNumber
  name
  type
  address
  city
  state
  zip
  parentOrganizationId
  academicSessions {
    ...BaseAcademicSession
  }
}
    ${BaseExternalIdFragmentDoc}
${BaseAcademicSessionFragmentDoc}`;
export const BaseUserFragmentDoc = gql`
    fragment BaseUser on User {
  id
  username
  firstName
  lastName
  type
  pin
  avatarUrl
  status
  dateUpdated
  sisId
}
    `;
export const BaseClassroomRoleFragmentDoc = gql`
    fragment BaseClassroomRole on ClassroomRole {
  id
  name
  displayName
  classification
  appId
  organizationId
}
    `;
export const BaseClassroomPrivilegeFragmentDoc = gql`
    fragment BaseClassroomPrivilege on ClassroomPrivilege {
  id
  name
  displayName
}
    `;
export const BaseClassroomUserEnrollmentFragmentDoc = gql`
    fragment BaseClassroomUserEnrollment on UserClassroomEnrollment {
  userId
  user {
    ...BaseUser
  }
  classroomRoles {
    ...BaseClassroomRole
    privileges {
      ...BaseClassroomPrivilege
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseClassroomRoleFragmentDoc}
${BaseClassroomPrivilegeFragmentDoc}`;
export const Base_Classroom_FragmentFragmentDoc = gql`
    fragment BASE_CLASSROOM_FRAGMENT on Classroom {
  id
  name
  studentCount
  color
  dateArchived
  organization {
    id
    name
  }
  users {
    ...BaseClassroomUserEnrollment
  }
  licenseUsage {
    assignedCount
    product {
      id
      name
      code
      iconUrl
    }
    productCurriculum {
      id
      code
      name
      gradeLevel
      trialAvailable
      iconUrl
      bannerUrl
    }
  }
}
    ${BaseClassroomUserEnrollmentFragmentDoc}`;
export const BaseKeyboardingStudentExportLegacyFragmentDoc = gql`
    fragment BaseKeyboardingStudentExportLegacy on KeyClassroomEngagementReportResult {
  assessmentAccelerator {
    averageAttemptCount
    averageFirstAttemptCount
    averageSecondsSpent
    activityTypes {
      activityType {
        id
        name
      }
      modules {
        moduleIds
        averageAttemptCount
        averageSecondsSpent
      }
    }
  }
  students {
    student {
      id
      firstName
      lastName
      gradeLevel
      sisId
      organization {
        ...BaseOrganization
        rootOrganization {
          name
          id
        }
      }
      classrooms {
        sisId
        ...BASE_CLASSROOM_FRAGMENT
      }
    }
    productCurriculumCode
    lastLoginDate
    curriculumWeek
    curriculumProgressPercentage
    totalActivitiesCompletedCount
    averageWeeklyMinutesSpent
    spotChecks {
      totalCompletedCount
      dateLastCompleted
      averageWpm
      averageAccuracy
      activities {
        template
        dateCompleted
        week
        wpm
        accuracy
      }
    }
    scheduledActivities {
      assessmentCompletedCount
      assessmentSkippedCount
      assessmentAverageWpm
      assessmentAverageAccuracy
      activities {
        dateCompleted
        wpm
        accuracy
      }
    }
    teacherCreatedActivities {
      totalCompletedCount
      averageWpm
      averageAccuracy
    }
    enrichmentActivities {
      hearItTypeItCompletedCount
      myChoiceKeyboardingCompletedCount
    }
  }
}
    ${BaseOrganizationFragmentDoc}
${Base_Classroom_FragmentFragmentDoc}`;
export const BaseKeyboardingStudentExportFragmentDoc = gql`
    fragment BaseKeyboardingStudentExport on KeyClassroomEngagementReportResult {
  assessmentAccelerator {
    averageAttemptCount
    averageFirstAttemptCount
    averageSecondsSpent
    activityTypes {
      activityType {
        id
        name
      }
      modules {
        moduleIds
        averageAttemptCount
        averageSecondsSpent
      }
    }
  }
  students {
    student {
      id
      firstName
      lastName
      gradeLevel
      sisId
      organization {
        id
        sisId
        name
        type
        parentOrganizationId
        rootOrganization {
          name
          id
        }
      }
      classrooms {
        id
        sisId
        name
        users {
          userId
          user {
            firstName
            lastName
          }
          classroomRoles {
            name
            displayName
            classification
          }
        }
      }
    }
    productCurriculumCode
    lastLoginDate
    curriculumWeek
    curriculumProgressPercentage
    totalActivitiesCompletedCount
    averageWeeklyMinutesSpent
    spotChecks {
      totalCompletedCount
      dateLastCompleted
      averageWpm
      averageAccuracy
      activities {
        template
        dateCompleted
        week
        wpm
        accuracy
      }
    }
    scheduledActivities {
      assessmentCompletedCount
      assessmentSkippedCount
      assessmentAverageWpm
      assessmentAverageAccuracy
      activities {
        dateCompleted
        wpm
        accuracy
      }
    }
    teacherCreatedActivities {
      totalCompletedCount
      averageWpm
      averageAccuracy
    }
    enrichmentActivities {
      hearItTypeItCompletedCount
      myChoiceKeyboardingCompletedCount
    }
  }
}
    `;
export const BaseKeyboardingStudentSettingsFragmentDoc = gql`
    fragment BaseKeyboardingStudentSettings on KeyStudentSettings {
  homeUse {
    ...BaseKeyHomeUseSetting
  }
  skipJumpIn {
    KEYK
    KEY1
    KEY2
    KEY3
    KEY4
    KEY5
  }
  stopAndReview {
    KEYK {
      week
      enabled
    }
    KEY1 {
      week
      enabled
    }
    KEY2 {
      week
      enabled
    }
    KEY3 {
      week
      enabled
    }
    KEY4 {
      week
      enabled
    }
    KEY5 {
      week
      enabled
    }
  }
  oneHandedTypingHand
}
    ${BaseKeyHomeUseSettingFragmentDoc}`;
export const BaseLessonCompletionStatsFragmentFragmentDoc = gql`
    fragment BaseLessonCompletionStatsFragment on PrmLessonCompletionStats {
  metSkillPercentage
  unmetSkillPercentage
  metSkillWithSupportPercentage
  metSkillWithoutSupportPercentage
}
    `;
export const BaseLessonFragmentFragmentDoc = gql`
    fragment BaseLessonFragment on PrmCurriculumLessonDetail {
  lessonId
  completionStats {
    ...BaseLessonCompletionStatsFragment
  }
  averageTimeSpentSeconds
  lesson {
    id
    lessonNumber
    title
    primarySkillPhonics
    primarySkillWordStudy
  }
}
    ${BaseLessonCompletionStatsFragmentFragmentDoc}`;
export const BaseOrderFragmentFragmentDoc = gql`
    fragment BaseOrderFragment on Order {
  id
  orderNumber
  ecmsOrderNumber
  itemFulfillmentNumber
  dateOrdered
  cmsCustomerNumber
  crmNumber
  dateFulfilled
}
    `;
export const BaseMastercodeFragmentFragmentDoc = gql`
    fragment BaseMastercodeFragment on Mastercode {
  id
  code
  ownerEmail
  dateGracePeriodEnd
  dateScheduledUnlock
  dateUnlocked
  dateExpired
  dateCreated
}
    `;
export const BaseProductFamilyFragmentDoc = gql`
    fragment BaseProductFamily on ProductFamily {
  id
  code
  name
  description
  iconUrl
  bannerUrl
  types
  pliManaged
}
    `;
export const BaseProductFragmentDoc = gql`
    fragment BaseProduct on Product {
  id
  code
  name
  type
  gradeLevel
  trialAvailable
  iconUrl
  bannerUrl
  family {
    ...BaseProductFamily
  }
}
    ${BaseProductFamilyFragmentDoc}`;
export const BaseOrderItemFragmentDoc = gql`
    fragment BaseOrderItem on OrderItem {
  id
  lineNumber
  licenseCount
  multiyearTerm
  siteLicenseRangeMin
  siteLicenseRangeMax
  dateCreated
  product {
    ...BaseProduct
  }
}
    ${BaseProductFragmentDoc}`;
export const MastercodeFragmentFragmentDoc = gql`
    fragment MastercodeFragment on Mastercode {
  ...BaseMastercodeFragment
  parentMastercode {
    ...BaseMastercodeFragment
  }
  orderItems {
    ...BaseOrderItem
  }
}
    ${BaseMastercodeFragmentFragmentDoc}
${BaseOrderItemFragmentDoc}`;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  ...BaseOrderFragment
  parentOrder {
    ...BaseOrderFragment
  }
  mastercodes {
    ...MastercodeFragment
  }
  orderItems {
    ...BaseOrderItem
  }
}
    ${BaseOrderFragmentFragmentDoc}
${MastercodeFragmentFragmentDoc}
${BaseOrderItemFragmentDoc}`;
export const BaseOrganizationAssociationLicenseUsageFragmentDoc = gql`
    fragment BaseOrganizationAssociationLicenseUsage on UserOrganization {
  organization {
    id
    name
    licenseUsage {
      product {
        id
        code
        name
        iconUrl
        type
      }
      productCurriculum {
        id
        code
        name
        iconUrl
      }
      availableCount
      assignedCount
      siteLicensed
    }
  }
}
    `;
export const BaseProductCurriculumFragmentDoc = gql`
    fragment BaseProductCurriculum on ProductCurriculum {
  id
  code
  name
  gradeLevel
  trialAvailable
  iconUrl
  bannerUrl
  productId
}
    `;
export const OrganizationLicenseFieldsFragmentDoc = gql`
    fragment OrganizationLicenseFields on Organization {
  licenseUsage {
    siteLicensed
    assignedCount
    availableCount
    inUseCount
    expiringCount
    totalCount
    productId
    product {
      ...BaseProduct
    }
    productCurriculum {
      ...BaseProductCurriculum
    }
    overageStats {
      availableCount
      assignedCount
      totalCount
      expiringCount
      overageLimitCount
    }
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export const BaseOrderItemProvisioningResultFragmentFragmentDoc = gql`
    fragment BaseOrderItemProvisioningResultFragment on OrderItemProvisioningResult {
  orderItem {
    id
    product {
      id
      type
    }
  }
  dateExpiration
  licenseCount
}
    `;
export const BaseProvisioningResultFragmentFragmentDoc = gql`
    fragment BaseProvisioningResultFragment on ProvisioningResult {
  success {
    ...BaseOrderItemProvisioningResultFragment
  }
  fail {
    ...BaseOrderItemProvisioningResultFragment
  }
}
    ${BaseOrderItemProvisioningResultFragmentFragmentDoc}`;
export const BaseAssetFragmentDoc = gql`
    fragment BaseAsset on Asset {
  id
  title
  description
  locale
  filename
  src
}
    `;
export const BaseResourceAssetsFragmentDoc = gql`
    fragment BaseResourceAssets on Resource {
  thumbnailAsset {
    ...BaseAsset
  }
  resourceAsset {
    ...BaseAsset
  }
}
    ${BaseAssetFragmentDoc}`;
export const BaseResourceFavoriteFragmentDoc = gql`
    fragment BaseResourceFavorite on Resource {
  favorite {
    id
    resourceId
  }
}
    `;
export const BaseResourceTypeFragmentDoc = gql`
    fragment BaseResourceType on ResourceType {
  id
  type
  title
  description
  sortIndex
}
    `;
export const BaseResourceTypeAssetsFragmentDoc = gql`
    fragment BaseResourceTypeAssets on ResourceType {
  iconAsset {
    ...BaseAsset
  }
  imageAsset {
    ...BaseAsset
  }
}
    ${BaseAssetFragmentDoc}`;
export const BaseResourceFragmentDoc = gql`
    fragment BaseResource on Resource {
  id
  link
  grades
  title
  description
  productCodes
  link
  type {
    ...BaseResourceType
    ...BaseResourceTypeAssets
  }
  productFamily {
    id
    name
  }
}
    ${BaseResourceTypeFragmentDoc}
${BaseResourceTypeAssetsFragmentDoc}`;
export const BaseStudentLicenseUsageFragmentDoc = gql`
    fragment BaseStudentLicenseUsage on StudentLicenseUsage {
  productId
  assignedCount
  active
  trial
  product {
    ...BaseProduct
  }
  productCurriculum {
    ...BaseProductCurriculum
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export const BaseStudentSettingsFragmentDoc = gql`
    fragment BaseStudentSettings on StudentSetting {
  id
  setting
  studentId
  value
  dateCreated
  dateUpdated
  app {
    id
  }
}
    `;
export const BaseStudentFragmentDoc = gql`
    fragment BaseStudent on Student {
  id
  username
  firstName
  lastName
  email
  loginType
  password
  gradeLevel
  organizationId
}
    `;
export const BaseSupportCategoryFragmentDoc = gql`
    fragment BaseSupportCategory on SupportCategory {
  id
  iconAssetId
  title
  description
  sortIndex
  locale
  data
  iconAsset {
    ...BaseAsset
  }
}
    ${BaseAssetFragmentDoc}`;
export const BaseSupportTopicFragmentDoc = gql`
    fragment BaseSupportTopic on SupportTopic {
  id
  title
  description
  sortIndex
}
    `;
export const BaseTagFragmentDoc = gql`
    fragment BaseTag on Tag {
  id
  tagGroup
  value
}
    `;
export const UpdateClassroomSettingFragmentFragmentDoc = gql`
    fragment UpdateClassroomSettingFragment on BaseClassroomSettingResponse {
  classroom {
    id
  }
  app {
    id
    name
  }
  setting
  value
}
    `;
export const UpdateStudentSettingFragmentFragmentDoc = gql`
    fragment UpdateStudentSettingFragment on BaseStudentSettingResponse {
  student {
    id
  }
  app {
    id
  }
  setting
  value
}
    `;
export const BaseClassroomFragmentDoc = gql`
    fragment BaseClassroom on Classroom {
  id
  sisId
  name
  color
  loginType
  organizationId
  academicSessionId
  dateArchived
  dateRemoved
}
    `;
export const BaseClassroomLicenseUsageFragmentDoc = gql`
    fragment BaseClassroomLicenseUsage on ClassroomLicenseUsage {
  productId
  assignedCount
  product {
    ...BaseProduct
  }
  productCurriculum {
    ...BaseProductCurriculum
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export const BaseUserClassroomEnrollmentFragmentDoc = gql`
    fragment BaseUserClassroomEnrollment on UserClassroomEnrollment {
  classroomId
  userId
  user {
    ...BaseUser
  }
  classroom {
    ...BaseClassroom
    licenseUsage {
      ...BaseClassroomLicenseUsage
    }
    organization {
      id
      name
    }
  }
  classroomRoles {
    ...BaseClassroomRole
    privileges {
      ...BaseClassroomPrivilege
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseClassroomFragmentDoc}
${BaseClassroomLicenseUsageFragmentDoc}
${BaseClassroomRoleFragmentDoc}
${BaseClassroomPrivilegeFragmentDoc}`;
export const BaseUserLicenseUsageFragmentDoc = gql`
    fragment BaseUserLicenseUsage on UserLicenseUsage {
  productId
  productCurriculumId
  assignedCount
  active
  trial
  product {
    ...BaseProduct
  }
  productCurriculum {
    ...BaseProductCurriculum
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export const BaseOrganizationRoleFragmentDoc = gql`
    fragment BaseOrganizationRole on OrganizationRole {
  id
  classification
  name
  displayName
  appId
  organizationId
  public
}
    `;
export const BaseOrganizationUserFragmentDoc = gql`
    fragment BaseOrganizationUser on UserOrganization {
  userId
  user {
    ...BaseUser
  }
  organizationRoles {
    ...BaseOrganizationRole
  }
}
    ${BaseUserFragmentDoc}
${BaseOrganizationRoleFragmentDoc}`;
export const BaseUserOrganizationFragmentDoc = gql`
    fragment BaseUserOrganization on UserOrganization {
  organizationId
  organization {
    ...BaseOrganization
    users {
      ...BaseOrganizationUser
    }
  }
  organizationRoles {
    ...BaseOrganizationRole
  }
}
    ${BaseOrganizationFragmentDoc}
${BaseOrganizationUserFragmentDoc}
${BaseOrganizationRoleFragmentDoc}`;
export const BaseUserProfileDetailsFragmentDoc = gql`
    fragment BaseUserProfileDetails on User {
  id
  username
  firstName
  lastName
  pin
}
    `;
export const BaseAppFragmentDoc = gql`
    fragment BaseApp on App {
  id
  name
  data
}
    `;
export const BaseUserSettingFragmentDoc = gql`
    fragment BaseUserSetting on UserSetting {
  id
  setting
  userId
  value
  dateCreated
  dateUpdated
  app {
    ...BaseApp
  }
}
    ${BaseAppFragmentDoc}`;
export const BaseUserTrialUsageFragmentDoc = gql`
    fragment BaseUserTrialUsage on UserTrialUsage {
  productId
  productCurriculumId
  product {
    ...BaseProduct
  }
  productCurriculum {
    ...BaseProductCurriculum
  }
  active
  available
  dateExpiration
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export const BaseWdtClassroomSettingsFragmentDoc = gql`
    fragment BaseWdtClassroomSettings on WdtClassroomSettings {
  handedness {
    leftHanded
    rtlCrossStroke
  }
  characterOrder {
    numbers
    capitals
    lowercase
  }
}
    `;
export const BaseWdtStudentSettingsFragmentDoc = gql`
    fragment BaseWdtStudentSettings on WdtStudentSettings {
  handedness {
    leftHanded
    rtlCrossStroke
  }
  characterOrder {
    numbers
    capitals
    lowercase
  }
}
    `;
export const LicenseDataMastercodeFragmentFragmentDoc = gql`
    fragment LicenseDataMastercodeFragment on Mastercode {
  id
  code
  status
  orderItems {
    id
    licenseType
    licenseCount
    dateExpiration
    order {
      orderNumber
      itemFulfillmentNumber
      ecmsOrderNumber
    }
    product {
      id
      code
      name
    }
  }
}
    `;
export const GetUserProductsDocument = gql`
    query getUserProducts($where: UserWhereInput!) {
  user(where: $where) {
    id
    username
    firstName
    lastName
    licenseUsage {
      assignedCount
      manualAssignment
      trial
      product {
        id
        code
        family {
          id
          code
        }
      }
      productCurriculum {
        id
        code
      }
    }
    organizationAssociations {
      organization {
        id
        name
        licenseUsage {
          product {
            id
            code
            type
            family {
              id
              code
            }
          }
          availableCount
          siteLicensed
        }
      }
    }
  }
}
    `;
export type GetUserProductsQueryResult = Apollo.QueryResult<GetUserProductsQuery, GetUserProductsQueryVariables>;
export const KeyOrganizationEngagementReportAsyncDocument = gql`
    query keyOrganizationEngagementReportAsync($where: KeyOrganizationEngagementReportWhereInput!, $dateRange: DateRangeInput!) {
  keyOrganizationEngagementReportAsync(where: $where, dateRange: $dateRange) {
    id
    error
    result {
      ...OrganizationEngagement
    }
  }
}
    ${OrganizationEngagementFragmentDoc}`;
export type KeyOrganizationEngagementReportAsyncQueryResult = Apollo.QueryResult<KeyOrganizationEngagementReportAsyncQuery, KeyOrganizationEngagementReportAsyncQueryVariables>;
export const GetAcademicSessionsDocument = gql`
    query getAcademicSessions($where: AcademicSessionsWhereInput, $organizationId: Int!) {
  academicSessions(where: $where) {
    ...BaseAcademicSession
    active
    default
  }
  organizationSetting(
    where: {appId: null, organizationId: $organizationId, setting: "upcomingAcademicSession"}
  ) {
    id
    organizationId
    setting
    value
  }
}
    ${BaseAcademicSessionFragmentDoc}`;
export type GetAcademicSessionsQueryResult = Apollo.QueryResult<GetAcademicSessionsQuery, GetAcademicSessionsQueryVariables>;
export const CreateAcademicSessionDocument = gql`
    mutation createAcademicSession($data: AcademicSessionCreateInput!) {
  createAcademicSession(data: $data) {
    ...BaseAcademicSession
  }
}
    ${BaseAcademicSessionFragmentDoc}`;
export type CreateAcademicSessionMutationResult = Apollo.MutationResult<CreateAcademicSessionMutation>;
export type CreateAcademicSessionMutationOptions = Apollo.BaseMutationOptions<CreateAcademicSessionMutation, CreateAcademicSessionMutationVariables>;
export const RemoveUpcomingAcademicSessionSettingDocument = gql`
    mutation removeUpcomingAcademicSessionSetting($where: OrganizationSettingWhereInput!) {
  removeOrganizationSetting(where: $where)
}
    `;
export type RemoveUpcomingAcademicSessionSettingMutationResult = Apollo.MutationResult<RemoveUpcomingAcademicSessionSettingMutation>;
export type RemoveUpcomingAcademicSessionSettingMutationOptions = Apollo.BaseMutationOptions<RemoveUpcomingAcademicSessionSettingMutation, RemoveUpcomingAcademicSessionSettingMutationVariables>;
export const UpdateAcademicSessionDocument = gql`
    mutation updateAcademicSession($where: AcademicSessionWhereInput!, $data: AcademicSessionUpdateInput!) {
  updateAcademicSession(data: $data, where: $where) {
    ...BaseAcademicSession
  }
}
    ${BaseAcademicSessionFragmentDoc}`;
export type UpdateAcademicSessionMutationResult = Apollo.MutationResult<UpdateAcademicSessionMutation>;
export type UpdateAcademicSessionMutationOptions = Apollo.BaseMutationOptions<UpdateAcademicSessionMutation, UpdateAcademicSessionMutationVariables>;
export const UpdateUpcomingAcademicSessionSettingDocument = gql`
    mutation updateUpcomingAcademicSessionSetting($organizationId: Int!, $value: JSON!) {
  saveOrganizationSetting(
    where: {appId: null, organizationId: $organizationId, setting: "upcomingAcademicSession"}
    value: $value
  ) {
    id
    organizationId
    setting
    value
  }
}
    `;
export type UpdateUpcomingAcademicSessionSettingMutationResult = Apollo.MutationResult<UpdateUpcomingAcademicSessionSettingMutation>;
export type UpdateUpcomingAcademicSessionSettingMutationOptions = Apollo.BaseMutationOptions<UpdateUpcomingAcademicSessionSettingMutation, UpdateUpcomingAcademicSessionSettingMutationVariables>;
export const UploadBulkImportFileMutationDocument = gql`
    mutation uploadBulkImportFileMutation($data: BulkImportFileUploadInput!) {
  uploadBulkImportFile(data: $data) {
    url
    fields
  }
}
    `;
export type UploadBulkImportFileMutationMutationResult = Apollo.MutationResult<UploadBulkImportFileMutationMutation>;
export type UploadBulkImportFileMutationMutationOptions = Apollo.BaseMutationOptions<UploadBulkImportFileMutationMutation, UploadBulkImportFileMutationMutationVariables>;
export const ArchiveClassroomDocument = gql`
    mutation archiveClassroom($classroomId: Int!) {
  archiveClassroom(where: {id: $classroomId}) {
    id
    dateArchived
  }
}
    `;
export type ArchiveClassroomMutationResult = Apollo.MutationResult<ArchiveClassroomMutation>;
export type ArchiveClassroomMutationOptions = Apollo.BaseMutationOptions<ArchiveClassroomMutation, ArchiveClassroomMutationVariables>;
export const ArchiveClassroomsDocument = gql`
    mutation archiveClassrooms($where: ClassroomsWhereInput!) {
  archiveClassrooms(where: $where) {
    count
  }
}
    `;
export type ArchiveClassroomsMutationResult = Apollo.MutationResult<ArchiveClassroomsMutation>;
export type ArchiveClassroomsMutationOptions = Apollo.BaseMutationOptions<ArchiveClassroomsMutation, ArchiveClassroomsMutationVariables>;
export const BulkGroupEnrollmentActionDocument = gql`
    mutation bulkGroupEnrollmentAction($data: [BulkGroupEnrollmentActionInput!]!) {
  bulkGroupEnrollmentAction(data: $data) {
    groupEnrollment {
      id
      studentId
      groupId
    }
    error
  }
}
    `;
export type BulkGroupEnrollmentActionMutationResult = Apollo.MutationResult<BulkGroupEnrollmentActionMutation>;
export type BulkGroupEnrollmentActionMutationOptions = Apollo.BaseMutationOptions<BulkGroupEnrollmentActionMutation, BulkGroupEnrollmentActionMutationVariables>;
export const CreateClassroomDocument = gql`
    mutation createClassroom($classroom: ClassroomCreateInput!) {
  createClassroom(data: $classroom) {
    ...BaseClassroom
  }
}
    ${BaseClassroomFragmentDoc}`;
export type CreateClassroomMutationResult = Apollo.MutationResult<CreateClassroomMutation>;
export type CreateClassroomMutationOptions = Apollo.BaseMutationOptions<CreateClassroomMutation, CreateClassroomMutationVariables>;
export const GetAdminClassroomDetailsDocument = gql`
    query getAdminClassroomDetails($where: ClassroomWhereInput!) {
  classroom(where: $where) {
    id
    name
    color
    studentCount
    stats {
      userCount
      studentCount
    }
    licenseUsage {
      assignedCount
      product {
        ...BaseProduct
      }
      productCurriculum {
        ...BaseProductCurriculum
      }
    }
    students {
      id
      firstName
      lastName
      username
      email
      password
      gradeLevel
      licenseUsage {
        assignedCount
        product {
          ...BaseProduct
        }
        productCurriculum {
          ...BaseProductCurriculum
        }
      }
    }
    organizationId
    organization {
      id
      name
      type
      parentOrganization {
        name
        type
      }
    }
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export type GetAdminClassroomDetailsQueryResult = Apollo.QueryResult<GetAdminClassroomDetailsQuery, GetAdminClassroomDetailsQueryVariables>;
export const GetBaseClassroomDocument = gql`
    query getBaseClassroom($id: Int!) {
  entity: classroom(where: {id: $id}) {
    ...BaseClassroom
  }
}
    ${BaseClassroomFragmentDoc}`;
export type GetBaseClassroomQueryResult = Apollo.QueryResult<GetBaseClassroomQuery, GetBaseClassroomQueryVariables>;
export const GetClassroomNameDocument = gql`
    query getClassroomName($id: Int!) {
  classroom(where: {id: $id}) {
    name
  }
}
    `;
export type GetClassroomNameQueryResult = Apollo.QueryResult<GetClassroomNameQuery, GetClassroomNameQueryVariables>;
export const GetClassroomDocument = gql`
    query getClassroom($id: Int!) {
  classroom(where: {id: $id}) {
    ...BaseClassroom
    licenseUsage {
      ...BaseClassroomLicenseUsage
    }
    organization {
      id
      ...OrganizationLicenseFields
    }
    users {
      ...BaseClassroomUserEnrollment
    }
    students {
      ...BaseStudent
      licenseUsage {
        ...BaseStudentLicenseUsage
      }
      groups {
        ...BaseGroups
      }
    }
  }
}
    ${BaseClassroomFragmentDoc}
${BaseClassroomLicenseUsageFragmentDoc}
${OrganizationLicenseFieldsFragmentDoc}
${BaseClassroomUserEnrollmentFragmentDoc}
${BaseStudentFragmentDoc}
${BaseStudentLicenseUsageFragmentDoc}
${BaseGroupsFragmentDoc}`;
export type GetClassroomQueryResult = Apollo.QueryResult<GetClassroomQuery, GetClassroomQueryVariables>;
export const GetOrganizationClassroomsDocument = gql`
    query getOrganizationClassrooms {
  organizations {
    id
    name
    classrooms {
      ...BASE_CLASSROOM_FRAGMENT
    }
  }
  users {
    id
    firstName
    lastName
  }
}
    ${Base_Classroom_FragmentFragmentDoc}`;
export type GetOrganizationClassroomsQueryResult = Apollo.QueryResult<GetOrganizationClassroomsQuery, GetOrganizationClassroomsQueryVariables>;
export const GetKeyboardingModulesDocument = gql`
    query getKeyboardingModules {
  keyboardingModules {
    id
    parentModuleId
    name
    description
  }
}
    `;
export type GetKeyboardingModulesQueryResult = Apollo.QueryResult<GetKeyboardingModulesQuery, GetKeyboardingModulesQueryVariables>;
export const GetMyClassroomsDocument = gql`
    query getMyClassrooms($whereUser: UsersWhereInput) {
  classrooms(whereUser: $whereUser, orderBy: {field: NAME, direction: ASC}) {
    ...BaseClassroom
    organization {
      id
      name
    }
  }
}
    ${BaseClassroomFragmentDoc}`;
export type GetMyClassroomsQueryResult = Apollo.QueryResult<GetMyClassroomsQuery, GetMyClassroomsQueryVariables>;
export const GetUserClassroomsDocument = gql`
    query getUserClassrooms($userId: Int!) {
  classrooms(whereUser: {id: [$userId]}, orderBy: {field: NAME, direction: ASC}) {
    ...BaseClassroom
    users {
      ...BaseClassroomUserEnrollment
    }
    stats {
      ...BaseClassroomStats
    }
    licenseUsage {
      ...BaseClassroomLicenseUsage
    }
    organization {
      id
      name
    }
  }
}
    ${BaseClassroomFragmentDoc}
${BaseClassroomUserEnrollmentFragmentDoc}
${BaseClassroomStatsFragmentDoc}
${BaseClassroomLicenseUsageFragmentDoc}`;
export type GetUserClassroomsQueryResult = Apollo.QueryResult<GetUserClassroomsQuery, GetUserClassroomsQueryVariables>;
export const RemoveClassroomDocument = gql`
    mutation removeClassroom($classroomId: Int!) {
  removeClassroom(where: {id: $classroomId}) {
    id
    dateRemoved
  }
}
    `;
export type RemoveClassroomMutationResult = Apollo.MutationResult<RemoveClassroomMutation>;
export type RemoveClassroomMutationOptions = Apollo.BaseMutationOptions<RemoveClassroomMutation, RemoveClassroomMutationVariables>;
export const RemoveClassroomsDocument = gql`
    mutation removeClassrooms($where: ClassroomsWhereInput!) {
  removeClassrooms(where: $where) {
    count
  }
}
    `;
export type RemoveClassroomsMutationResult = Apollo.MutationResult<RemoveClassroomsMutation>;
export type RemoveClassroomsMutationOptions = Apollo.BaseMutationOptions<RemoveClassroomsMutation, RemoveClassroomsMutationVariables>;
export const SearchClassroomsDocument = gql`
    query searchClassrooms($searchText: String!, $classroomIds: [Int!], $organizationIds: [Int!], $limit: Int) {
  classrooms(
    where: {name_contains: $searchText, archived: false, OR: [{id: $classroomIds}, {organizationId: $organizationIds}]}
    orderBy: {field: [NAME, ID], direction: [ASC, DESC]}
    paging: {limit: $limit}
  ) {
    ...BaseClassroom
  }
}
    ${BaseClassroomFragmentDoc}`;
export type SearchClassroomsQueryResult = Apollo.QueryResult<SearchClassroomsQuery, SearchClassroomsQueryVariables>;
export const UpdateClassroomMutationDocument = gql`
    mutation updateClassroomMutation($classroomId: Int, $data: ClassroomUpdateInput!) {
  updateClassroom(data: $data, where: {id: $classroomId}) {
    ...BaseClassroom
    users {
      ...BaseClassroomUserEnrollment
    }
    organization {
      id
      name
    }
  }
}
    ${BaseClassroomFragmentDoc}
${BaseClassroomUserEnrollmentFragmentDoc}`;
export type UpdateClassroomMutationMutationResult = Apollo.MutationResult<UpdateClassroomMutationMutation>;
export type UpdateClassroomMutationMutationOptions = Apollo.BaseMutationOptions<UpdateClassroomMutationMutation, UpdateClassroomMutationMutationVariables>;
export const KeyClassroomAssessmentAcceleratorModulesDocument = gql`
    mutation KeyClassroomAssessmentAcceleratorModules($data: UpdateKeyClassroomSettingAssessmentAcceleratorInput!) {
  updateKeyClassroomAssessmentAcceleratorModules(data: $data) {
    activityTypeId
    scheduledDates {
      date
      moduleIds
    }
  }
}
    `;
export type KeyClassroomAssessmentAcceleratorModulesMutationResult = Apollo.MutationResult<KeyClassroomAssessmentAcceleratorModulesMutation>;
export type KeyClassroomAssessmentAcceleratorModulesMutationOptions = Apollo.BaseMutationOptions<KeyClassroomAssessmentAcceleratorModulesMutation, KeyClassroomAssessmentAcceleratorModulesMutationVariables>;
export const GetClassroomAndOrganizationsDocument = gql`
    query getClassroomAndOrganizations($where: ClassroomWhereInput!) {
  classroom(where: $where) {
    ...BaseClassroom
    users {
      ...BaseUserClassroomEnrollment
    }
    students {
      id
      username
    }
  }
  organizations(
    where: {type: [SCHOOL, USER_GROUP]}
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...BaseOrganization
    users {
      user {
        id
        firstName
        lastName
        username
      }
    }
  }
}
    ${BaseClassroomFragmentDoc}
${BaseUserClassroomEnrollmentFragmentDoc}
${BaseOrganizationFragmentDoc}`;
export type GetClassroomAndOrganizationsQueryResult = Apollo.QueryResult<GetClassroomAndOrganizationsQuery, GetClassroomAndOrganizationsQueryVariables>;
export const GetClassroomLicenseUsageDocument = gql`
    query getClassroomLicenseUsage($classroomId: Int!) {
  classroom(where: {id: $classroomId}) {
    ...BaseClassroom
    students {
      ...BaseStudent
      licenseUsage {
        ...BaseStudentLicenseUsage
      }
      groups {
        ...BaseGroups
      }
    }
    organization {
      rootOrganization {
        licenseUsage {
          assignedCount
          availableCount
          siteLicensed
          totalCount
          overageStats {
            assignedCount
            availableCount
            overageLimitCount
            totalCount
          }
          product {
            id
            code
            name
            type
            family {
              id
              code
              name
            }
          }
          productCurriculum {
            id
            code
          }
        }
      }
    }
  }
}
    ${BaseClassroomFragmentDoc}
${BaseStudentFragmentDoc}
${BaseStudentLicenseUsageFragmentDoc}
${BaseGroupsFragmentDoc}`;
export type GetClassroomLicenseUsageQueryResult = Apollo.QueryResult<GetClassroomLicenseUsageQuery, GetClassroomLicenseUsageQueryVariables>;
export const GetMyOrganizationNamesClassroomsAndMasterCodesDocument = gql`
    query getMyOrganizationNamesClassroomsAndMasterCodes($userId: Int!) {
  user(where: {id: $userId}) {
    organizationAssociations {
      organization {
        id
        name
      }
    }
  }
  classrooms(
    where: {archived: false}
    whereUser: {id: [$userId]}
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...BaseClassroom
    licenseUsage {
      ...BaseClassroomLicenseUsage
    }
    stats {
      ...BaseClassroomStats
    }
  }
  mastercodes(where: {expired: false}) {
    id
    status
    orderItems {
      id
      licenseType
      product {
        id
        code
      }
    }
  }
}
    ${BaseClassroomFragmentDoc}
${BaseClassroomLicenseUsageFragmentDoc}
${BaseClassroomStatsFragmentDoc}`;
export type GetMyOrganizationNamesClassroomsAndMasterCodesQueryResult = Apollo.QueryResult<GetMyOrganizationNamesClassroomsAndMasterCodesQuery, GetMyOrganizationNamesClassroomsAndMasterCodesQueryVariables>;
export const GetStudentAndClassroomQueryDocument = gql`
    query getStudentAndClassroomQuery($whereStudent: StudentWhereInput!, $whereClassroom: ClassroomWhereInput!) {
  student(where: $whereStudent) {
    ...BaseStudent
    externalId {
      ...BaseExternalId
    }
    groups {
      ...BaseGroups
    }
    licenseUsage {
      ...BaseStudentLicenseUsage
    }
  }
  classroom(where: $whereClassroom) {
    ...BaseClassroom
    externalId {
      ...BaseExternalId
    }
    students {
      id
      username
    }
    organization {
      ...BaseOrganization
    }
  }
}
    ${BaseStudentFragmentDoc}
${BaseExternalIdFragmentDoc}
${BaseGroupsFragmentDoc}
${BaseStudentLicenseUsageFragmentDoc}
${BaseClassroomFragmentDoc}
${BaseOrganizationFragmentDoc}`;
export type GetStudentAndClassroomQueryQueryResult = Apollo.QueryResult<GetStudentAndClassroomQueryQuery, GetStudentAndClassroomQueryQueryVariables>;
export const GetClassroomsAndOrganizationsWithRolesDocument = gql`
    query getClassroomsAndOrganizationsWithRoles($userId: Int!) {
  user(where: {id: $userId}) {
    organizationAssociations {
      ...BaseUserOrganization
    }
  }
  classrooms(
    where: {archived: false}
    whereUser: {id: [$userId]}
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...BaseClassroom
    licenseUsage {
      ...BaseClassroomLicenseUsage
    }
    stats {
      ...BaseClassroomStats
    }
  }
}
    ${BaseUserOrganizationFragmentDoc}
${BaseClassroomFragmentDoc}
${BaseClassroomLicenseUsageFragmentDoc}
${BaseClassroomStatsFragmentDoc}`;
export type GetClassroomsAndOrganizationsWithRolesQueryResult = Apollo.QueryResult<GetClassroomsAndOrganizationsWithRolesQuery, GetClassroomsAndOrganizationsWithRolesQueryVariables>;
export const SendLicenseAssignmentEmailDocument = gql`
    mutation sendLicenseAssignmentEmail($data: SendLicenseAssignmentEmailInput!) {
  sendLicenseAssignmentEmail(data: $data)
}
    `;
export type SendLicenseAssignmentEmailMutationResult = Apollo.MutationResult<SendLicenseAssignmentEmailMutation>;
export type SendLicenseAssignmentEmailMutationOptions = Apollo.BaseMutationOptions<SendLicenseAssignmentEmailMutation, SendLicenseAssignmentEmailMutationVariables>;
export const SendUserInviteEmailDocument = gql`
    mutation sendUserInviteEmail($data: SendUserInviteEmailInput!) {
  sendUserInviteEmail(data: $data)
}
    `;
export type SendUserInviteEmailMutationResult = Apollo.MutationResult<SendUserInviteEmailMutation>;
export type SendUserInviteEmailMutationOptions = Apollo.BaseMutationOptions<SendUserInviteEmailMutation, SendUserInviteEmailMutationVariables>;
export const CreateResourceFavoriteDocument = gql`
    mutation createResourceFavorite($data: ResourceFavoriteCreateInput!) {
  createResourceFavorite(data: $data) {
    id
    resourceId
  }
}
    `;
export type CreateResourceFavoriteMutationResult = Apollo.MutationResult<CreateResourceFavoriteMutation>;
export type CreateResourceFavoriteMutationOptions = Apollo.BaseMutationOptions<CreateResourceFavoriteMutation, CreateResourceFavoriteMutationVariables>;
export const DeleteResourceFavoriteDocument = gql`
    mutation deleteResourceFavorite($where: ResourceFavoriteDeleteInput!) {
  deleteResourceFavorite(where: $where) {
    id
    resourceId
  }
}
    `;
export type DeleteResourceFavoriteMutationResult = Apollo.MutationResult<DeleteResourceFavoriteMutation>;
export type DeleteResourceFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteResourceFavoriteMutation, DeleteResourceFavoriteMutationVariables>;
export const GetResourceFavoritesDocument = gql`
    query getResourceFavorites {
  resourceFavorites {
    ...BaseResource
    ...BaseResourceAssets
    ...BaseResourceFavorite
  }
}
    ${BaseResourceFragmentDoc}
${BaseResourceAssetsFragmentDoc}
${BaseResourceFavoriteFragmentDoc}`;
export type GetResourceFavoritesQueryResult = Apollo.QueryResult<GetResourceFavoritesQuery, GetResourceFavoritesQueryVariables>;
export const GetDefaultGroupSettingsDocument = gql`
    query getDefaultGroupSettings {
  defaultGroupSettings {
    gradeLevels
    productCodes
    group {
      appId
      name
      groupCategory {
        appId
        name
      }
    }
  }
}
    `;
export type GetDefaultGroupSettingsQueryResult = Apollo.QueryResult<GetDefaultGroupSettingsQuery, GetDefaultGroupSettingsQueryVariables>;
export const BulkLicenseActionDocument = gql`
    mutation bulkLicenseAction($where: BulkLicenseActionWhereInput, $assignRequests: [BulkLicenseActionInput!]!) {
  bulkLicenseAction(where: $where, data: $assignRequests) {
    request {
      studentId
      userId
      productId
      productCode
      orderItemId
    }
    licenses {
      id
    }
    error
  }
}
    `;
export type BulkLicenseActionMutationResult = Apollo.MutationResult<BulkLicenseActionMutation>;
export type BulkLicenseActionMutationOptions = Apollo.BaseMutationOptions<BulkLicenseActionMutation, BulkLicenseActionMutationVariables>;
export const GetMyLicenseUsageDocument = gql`
    query getMyLicenseUsage {
  me {
    id
    licenseUsage {
      ...BaseUserLicenseUsage
    }
  }
}
    ${BaseUserLicenseUsageFragmentDoc}`;
export type GetMyLicenseUsageQueryResult = Apollo.QueryResult<GetMyLicenseUsageQuery, GetMyLicenseUsageQueryVariables>;
export const GetLicenseDataDocument = gql`
    query getLicenseData {
  mastercodes(where: {expired: false}) {
    id
    status
    orderItems {
      id
      licenseType
      product {
        id
        code
      }
    }
  }
  organizations(orderBy: {field: NAME, direction: ASC}) {
    id
    name
    parentOrganizationId
    ...OrganizationLicenseFields
    ancestorMastercodes(where: {status: UNLOCKED, orderItems: {trial: false}}) {
      ...LicenseDataMastercodeFragment
    }
    mastercodes(where: {status: UNLOCKED, orderItems: {trial: false}}) {
      ...LicenseDataMastercodeFragment
    }
    rootOrganization {
      id
      ...OrganizationLicenseFields
    }
  }
}
    ${OrganizationLicenseFieldsFragmentDoc}
${LicenseDataMastercodeFragmentFragmentDoc}`;
export type GetLicenseDataQueryResult = Apollo.QueryResult<GetLicenseDataQuery, GetLicenseDataQueryVariables>;
export const GetMastercodesDocument = gql`
    query getMastercodes {
  mastercodes(where: {expired: false}) {
    id
    status
    orderItems {
      id
      licenseType
      product {
        id
        code
      }
    }
  }
}
    `;
export type GetMastercodesQueryResult = Apollo.QueryResult<GetMastercodesQuery, GetMastercodesQueryVariables>;
export const GetMastercodeActivationDetailsDocument = gql`
    query getMastercodeActivationDetails($where: MastercodesWhereInput!, $expirationWhere: OrderItemDateExpirationInput!) {
  mastercodes(where: $where) {
    id
    code
    dateUnlocked
    orderItems {
      dateExpiration(where: $expirationWhere)
    }
  }
}
    `;
export type GetMastercodeActivationDetailsQueryResult = Apollo.QueryResult<GetMastercodeActivationDetailsQuery, GetMastercodeActivationDetailsQueryVariables>;
export const GetMyOrdersDocument = gql`
    query getMyOrders($where: OrdersWhereInput!) {
  me {
    id
    orders(where: $where, orderBy: {field: DATE_CREATED, direction: DESC}) {
      ...OrderFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type GetMyOrdersQueryResult = Apollo.QueryResult<GetMyOrdersQuery, GetMyOrdersQueryVariables>;
export const GetOrderUnauthenticatedDocument = gql`
    query getOrderUnauthenticated($orderId: Int!, $ownerEmail: String!) {
  order(where: {id: $orderId, ownerEmail: $ownerEmail}) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type GetOrderUnauthenticatedQueryResult = Apollo.QueryResult<GetOrderUnauthenticatedQuery, GetOrderUnauthenticatedQueryVariables>;
export const ScheduleUnlockMastercodeDocument = gql`
    mutation scheduleUnlockMastercode($mastercodeId: Int!, $date: DateTime!) {
  scheduleUnlockMastercode(where: {id: $mastercodeId}, date: $date) {
    ...MastercodeFragment
  }
}
    ${MastercodeFragmentFragmentDoc}`;
export type ScheduleUnlockMastercodeMutationResult = Apollo.MutationResult<ScheduleUnlockMastercodeMutation>;
export type ScheduleUnlockMastercodeMutationOptions = Apollo.BaseMutationOptions<ScheduleUnlockMastercodeMutation, ScheduleUnlockMastercodeMutationVariables>;
export const ScheduleUnlockOrderMastercodesDocument = gql`
    mutation scheduleUnlockOrderMastercodes($orderId: Int!, $date: DateTime!) {
  scheduleUnlockOrderMastercodes(where: {id: $orderId}, date: $date) {
    count
  }
}
    `;
export type ScheduleUnlockOrderMastercodesMutationResult = Apollo.MutationResult<ScheduleUnlockOrderMastercodesMutation>;
export type ScheduleUnlockOrderMastercodesMutationOptions = Apollo.BaseMutationOptions<ScheduleUnlockOrderMastercodesMutation, ScheduleUnlockOrderMastercodesMutationVariables>;
export const TransferMastercodeDocument = gql`
    mutation transferMastercode($mastercodeId: Int!, $ownerEmail: String!, $data: MastercodeTransferInput!) {
  transferMastercode(
    where: {id: $mastercodeId, ownerEmail: $ownerEmail}
    data: $data
  ) {
    ...MastercodeFragment
  }
}
    ${MastercodeFragmentFragmentDoc}`;
export type TransferMastercodeMutationResult = Apollo.MutationResult<TransferMastercodeMutation>;
export type TransferMastercodeMutationOptions = Apollo.BaseMutationOptions<TransferMastercodeMutation, TransferMastercodeMutationVariables>;
export const TransferOrderMastercodesDocument = gql`
    mutation transferOrderMastercodes($orderId: Int!, $ownerEmail: String!, $data: MastercodeTransferInput!) {
  transferOrderMastercodes(
    where: {id: $orderId, ownerEmail: $ownerEmail}
    data: $data
  ) {
    count
  }
}
    `;
export type TransferOrderMastercodesMutationResult = Apollo.MutationResult<TransferOrderMastercodesMutation>;
export type TransferOrderMastercodesMutationOptions = Apollo.BaseMutationOptions<TransferOrderMastercodesMutation, TransferOrderMastercodesMutationVariables>;
export const UnlockMastercodeDocument = gql`
    mutation unlockMastercode($mastercodeId: Int!) {
  unlockMastercode(where: {id: $mastercodeId}) {
    ...BaseProvisioningResultFragment
  }
}
    ${BaseProvisioningResultFragmentFragmentDoc}`;
export type UnlockMastercodeMutationResult = Apollo.MutationResult<UnlockMastercodeMutation>;
export type UnlockMastercodeMutationOptions = Apollo.BaseMutationOptions<UnlockMastercodeMutation, UnlockMastercodeMutationVariables>;
export const UnlockOrderMastercodesDocument = gql`
    mutation unlockOrderMastercodes($orderId: Int!) {
  unlockOrderMastercodes(where: {id: $orderId}) {
    ...BaseProvisioningResultFragment
  }
}
    ${BaseProvisioningResultFragmentFragmentDoc}`;
export type UnlockOrderMastercodesMutationResult = Apollo.MutationResult<UnlockOrderMastercodesMutation>;
export type UnlockOrderMastercodesMutationOptions = Apollo.BaseMutationOptions<UnlockOrderMastercodesMutation, UnlockOrderMastercodesMutationVariables>;
export const GetBaseOrganizationDocument = gql`
    query getBaseOrganization($id: Int!) {
  entity: organization(where: {id: $id}) {
    ...BaseOrganization
  }
}
    ${BaseOrganizationFragmentDoc}`;
export type GetBaseOrganizationQueryResult = Apollo.QueryResult<GetBaseOrganizationQuery, GetBaseOrganizationQueryVariables>;
export const GetOrganizationAvailableLicensesDocument = gql`
    query getOrganizationAvailableLicenses($organizationId: Int!) {
  organization(where: {id: $organizationId}) {
    id
    rootOrganization {
      id
      licenseUsage {
        assignedCount
        availableCount
        siteLicensed
        totalCount
        overageStats {
          assignedCount
          availableCount
          overageLimitCount
          totalCount
        }
        product {
          id
          code
          name
          type
          family {
            id
            code
            name
          }
        }
        productCurriculum {
          id
          code
        }
      }
    }
  }
}
    `;
export type GetOrganizationAvailableLicensesQueryResult = Apollo.QueryResult<GetOrganizationAvailableLicensesQuery, GetOrganizationAvailableLicensesQueryVariables>;
export const GetOrganizationsIncludingDistrictsDocument = gql`
    query getOrganizationsIncludingDistricts {
  organizations(
    where: {type: [DISTRICT, SCHOOL, USER_GROUP]}
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...BaseOrganization
    subOrganizations {
      type
    }
    classrooms {
      id
      dateArchived
    }
    users {
      organizationRoles {
        classification
      }
      user {
        id
        type
        firstName
        lastName
        username
      }
    }
  }
}
    ${BaseOrganizationFragmentDoc}`;
export type GetOrganizationsIncludingDistrictsQueryResult = Apollo.QueryResult<GetOrganizationsIncludingDistrictsQuery, GetOrganizationsIncludingDistrictsQueryVariables>;
export const GetOrganizationsAndRolesDocument = gql`
    query getOrganizationsAndRoles($rolesWhere: OrganizationRolesWhereInput) {
  organizations {
    id
    name
    externalId {
      ...BaseExternalId
    }
  }
  organizationRoles(where: $rolesWhere) {
    id
    name
    displayName
    public
  }
}
    ${BaseExternalIdFragmentDoc}`;
export type GetOrganizationsAndRolesQueryResult = Apollo.QueryResult<GetOrganizationsAndRolesQuery, GetOrganizationsAndRolesQueryVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  organizations(
    where: {type: [SCHOOL, USER_GROUP]}
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...BaseOrganization
    users {
      user {
        id
        firstName
        lastName
        username
      }
    }
  }
}
    ${BaseOrganizationFragmentDoc}`;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetReportingOrganizationsDocument = gql`
    query getReportingOrganizations {
  organizations {
    id
    type
  }
}
    `;
export type GetReportingOrganizationsQueryResult = Apollo.QueryResult<GetReportingOrganizationsQuery, GetReportingOrganizationsQueryVariables>;
export const SearchOrganizationsDocument = gql`
    query searchOrganizations($searchText: String!, $organizationType: [OrganizationType!], $organizationIds: [Int!], $limit: Int) {
  organizations(
    where: {name_contains: $searchText, type: $organizationType, id: $organizationIds}
    orderBy: {field: [NAME, ID], direction: [ASC, DESC]}
    paging: {limit: $limit}
  ) {
    ...BaseOrganization
  }
}
    ${BaseOrganizationFragmentDoc}`;
export type SearchOrganizationsQueryResult = Apollo.QueryResult<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($data: OrganizationUpdateInput!, $where: OrganizationWhereInput!) {
  updateOrganization(data: $data, where: $where) {
    ...BaseOrganization
  }
}
    ${BaseOrganizationFragmentDoc}`;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const GetProductCacheDocument = gql`
    query getProductCache {
  products {
    ...BaseProduct
    curriculums {
      ...BaseProductCurriculum
    }
  }
  productFamilies {
    ...BaseProductFamily
    products {
      code
      name
      type
      iconUrl
    }
  }
  apps {
    id
    name
    title
    description
    type
    pliManaged
    products {
      ...BaseProduct
    }
    accessDetails {
      ...BaseAppAccessDetails
    }
    purchaseDetails {
      ...BaseAppPurchaseDetails
    }
    appProducts {
      id
      appId
      productId
      title
      description
      pliManaged
      product {
        ...BaseProduct
      }
      accessDetails {
        ...BaseAppAccessDetails
      }
      purchaseDetails {
        ...BaseAppPurchaseDetails
      }
    }
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}
${BaseProductFamilyFragmentDoc}
${BaseAppAccessDetailsFragmentDoc}
${BaseAppPurchaseDetailsFragmentDoc}`;
export type GetProductCacheQueryResult = Apollo.QueryResult<GetProductCacheQuery, GetProductCacheQueryVariables>;
export const GetActiveStudentsReportDocument = gql`
    query getActiveStudentsReport($where: PrmActiveStudentsReportWhereInput!) {
  prmActiveStudentsReport(where: $where) {
    activeStudentCount
    totalStudentCount
  }
}
    `;
export type GetActiveStudentsReportQueryResult = Apollo.QueryResult<GetActiveStudentsReportQuery, GetActiveStudentsReportQueryVariables>;
export const GetClassroomStatsDocument = gql`
    query getClassroomStats($id: Int!) {
  classroom(where: {id: $id}) {
    id
    name
    organization {
      id
      name
      type
    }
    licenseUsage {
      productId
      assignedCount
      product {
        ...BaseProduct
      }
    }
    stats {
      ...BaseClassroomStats
    }
  }
}
    ${BaseProductFragmentDoc}
${BaseClassroomStatsFragmentDoc}`;
export type GetClassroomStatsQueryResult = Apollo.QueryResult<GetClassroomStatsQuery, GetClassroomStatsQueryVariables>;
export const GetCurriculumLessonReportDocument = gql`
    query getCurriculumLessonReport($where: PrmCurriculumLessonReportWhereInput!) {
  prmCurriculumLessonReport(where: $where) {
    productCurriculum {
      id
      code
      name
    }
    averageLessonAssignedCount
    averageLessonCompletedCount
    totalLessonCount
    overallCompletionStats {
      ...BaseLessonCompletionStatsFragment
    }
    lessons {
      ...BaseLessonFragment
    }
  }
}
    ${BaseLessonCompletionStatsFragmentFragmentDoc}
${BaseLessonFragmentFragmentDoc}`;
export type GetCurriculumLessonReportQueryResult = Apollo.QueryResult<GetCurriculumLessonReportQuery, GetCurriculumLessonReportQueryVariables>;
export const GetPrmCurriculumProgressReportDocument = gql`
    query getPrmCurriculumProgressReport($where: PrmCurriculumProgressReportWhereInput!) {
  prmCurriculumProgressReport(where: $where) {
    overallProgressPercentage
    curriculums {
      productCurriculumId
      averageLessonAssignedCount
      averageLessonCompletedCount
      totalLessonCount
      productCurriculum {
        id
        code
        name
      }
    }
  }
}
    `;
export type GetPrmCurriculumProgressReportQueryResult = Apollo.QueryResult<GetPrmCurriculumProgressReportQuery, GetPrmCurriculumProgressReportQueryVariables>;
export const GetOrganizationEngagementCurriculumReportDocument = gql`
    query getOrganizationEngagementCurriculumReport($organizationId: Int!, $productCurriculumId: Int!) {
  prmOrganizationEngagementCurriculumReport(
    where: {organizationId: $organizationId, productCurriculumId: $productCurriculumId}
  ) {
    productCurriculumId
    productCurriculum {
      id
      name
    }
    organizationCurriculumProgress {
      organizationId
      organization {
        id
        name
      }
      averageLessonAssignedCount
      averageLessonCompletedCount
      totalLessonCount
      overallCompletionStats {
        metSkillPercentage
        unmetSkillPercentage
        metSkillWithSupportPercentage
        metSkillWithoutSupportPercentage
      }
    }
  }
}
    `;
export type GetOrganizationEngagementCurriculumReportQueryResult = Apollo.QueryResult<GetOrganizationEngagementCurriculumReportQuery, GetOrganizationEngagementCurriculumReportQueryVariables>;
export const GetOrganizationEngagmentOverviewReportDocument = gql`
    query getOrganizationEngagmentOverviewReport($organizationId: Int!, $licenseUsageWhere: LicenseUsageWhereInput) {
  prmOrganizationEngagementOverviewReport(
    where: {organizationId: $organizationId}
  ) {
    organizationOverviews {
      organization {
        id
        name
        licenseUsage(where: $licenseUsageWhere) {
          assignedCount
          product {
            code
            type
            family {
              code
            }
          }
          productCurriculum {
            id
            name
          }
        }
      }
      activeStudentCount
      totalStudentCount
      averageLessonTimeSpentSeconds
      overallProgressPercentage
    }
  }
}
    `;
export type GetOrganizationEngagmentOverviewReportQueryResult = Apollo.QueryResult<GetOrganizationEngagmentOverviewReportQuery, GetOrganizationEngagmentOverviewReportQueryVariables>;
export const GetOrganizationStatsDocument = gql`
    query getOrganizationStats($id: Int!) {
  organization(where: {id: $id}) {
    id
    type
    name
    licenseUsage {
      assignedCount
      classroomAssignedCount
      product {
        ...BaseProduct
      }
    }
    stats {
      classroomStudentCount
      userCount
      classroomCount
    }
    parentOrganization {
      id
      name
    }
    subOrganizations {
      id
      name
      type
    }
  }
}
    ${BaseProductFragmentDoc}`;
export type GetOrganizationStatsQueryResult = Apollo.QueryResult<GetOrganizationStatsQuery, GetOrganizationStatsQueryVariables>;
export const GetStudentCurriculumLessonReportDocument = gql`
    query getStudentCurriculumLessonReport($studentId: Int!) {
  prmStudentCurriculumLessonReport(where: {studentId: $studentId}) {
    studentId
    student {
      id
      firstName
      lastName
      gradeLevel
      licenseUsage {
        active
        assignedCount
        product {
          ...BaseProduct
        }
        productCurriculum {
          ...BaseProductCurriculum
        }
        productCurriculumId
        productId
        trial
      }
    }
    curriculumDetail {
      lessonAssignedCount
      productCurriculumId
      productCurriculum {
        id
        code
        name
      }
      lastLoginDate
      currentLessonId
      currentLesson {
        lessonNumber
      }
      totalLessonCount
    }
    lessonDetail {
      averageLessonTimeSpentSeconds
      lessons {
        timeSpentSeconds
        lessonId
        lesson {
          lessonNumber
          title
          primarySkillPhonics
          primarySkillWordStudy
        }
        metSkill
        usedSupport
        timeSpentSeconds
      }
    }
  }
}
    ${BaseProductFragmentDoc}
${BaseProductCurriculumFragmentDoc}`;
export type GetStudentCurriculumLessonReportQueryResult = Apollo.QueryResult<GetStudentCurriculumLessonReportQuery, GetStudentCurriculumLessonReportQueryVariables>;
export const GetPrmStudentEngagementReportDocument = gql`
    query getPrmStudentEngagementReport($where: PrmStudentEngagementReportWhereInput!) {
  prmStudentEngagementReport(where: $where) {
    studentCurriculumProgress {
      studentId
      student {
        id
        firstName
        lastName
      }
      lessonCompletionStats {
        metSkillWithSupportCount
        metSkillWithoutSupportCount
        unmetSkillCount
      }
    }
  }
}
    `;
export type GetPrmStudentEngagementReportQueryResult = Apollo.QueryResult<GetPrmStudentEngagementReportQuery, GetPrmStudentEngagementReportQueryVariables>;
export const GetStudentStatsDocument = gql`
    query getStudentStats($id: Int!) {
  student(where: {id: $id}) {
    id
    firstName
    lastName
    organization {
      id
      name
      type
      rootOrganization {
        id
        name
        type
      }
    }
    classrooms {
      id
      name
      dateArchived
      organizationId
    }
  }
}
    `;
export type GetStudentStatsQueryResult = Apollo.QueryResult<GetStudentStatsQuery, GetStudentStatsQueryVariables>;
export const GetUserStatsDocument = gql`
    query getUserStats($id: Int!) {
  user(where: {id: $id}) {
    id
    firstName
    lastName
    organizationAssociations {
      organization {
        id
        name
        type
      }
    }
    classroomEnrollments {
      classroom {
        id
        licenseUsage {
          productId
          assignedCount
          product {
            ...BaseProduct
          }
        }
        stats {
          ...BaseClassroomStats
        }
      }
    }
  }
}
    ${BaseProductFragmentDoc}
${BaseClassroomStatsFragmentDoc}`;
export type GetUserStatsQueryResult = Apollo.QueryResult<GetUserStatsQuery, GetUserStatsQueryVariables>;
export const KeyActiveStudentsReportAsyncDocument = gql`
    query keyActiveStudentsReportAsync($where: KeyReportWhereInput!, $dateRange: DateRangeInput!) {
  keyActiveStudentsReportAsync(where: $where, dateRange: $dateRange) {
    id
    error
    result {
      activeStudentCount
      totalStudentCount
    }
  }
}
    `;
export type KeyActiveStudentsReportAsyncQueryResult = Apollo.QueryResult<KeyActiveStudentsReportAsyncQuery, KeyActiveStudentsReportAsyncQueryVariables>;
export const KeyActiveStudentsReportDocument = gql`
    query keyActiveStudentsReport($where: KeyReportWhereInput!, $dateRange: DateRangeInput!) {
  keyActiveStudentsReport(where: $where, dateRange: $dateRange) {
    activeStudentCount
    totalStudentCount
  }
}
    `;
export type KeyActiveStudentsReportQueryResult = Apollo.QueryResult<KeyActiveStudentsReportQuery, KeyActiveStudentsReportQueryVariables>;
export const KeyActivitiesCompletedAndTimeSpentReportDocument = gql`
    query keyActivitiesCompletedAndTimeSpentReport($where: KeyActivitiesCompletedAndTimeSpentReportWhereInput!, $dateRange: DateRangeInput!) {
  keyActivitiesCompletedAndTimeSpentReport(where: $where, dateRange: $dateRange) {
    intervalUnit
    intervals {
      interval
      averageMinutesSpent
      activitiesCompletedCount
    }
    totalActivitiesCompletedCount
    averageWeeklyMinutesSpent
  }
}
    `;
export type KeyActivitiesCompletedAndTimeSpentReportQueryResult = Apollo.QueryResult<KeyActivitiesCompletedAndTimeSpentReportQuery, KeyActivitiesCompletedAndTimeSpentReportQueryVariables>;
export const KeyActivitiesCompletedReportAsyncDocument = gql`
    query keyActivitiesCompletedReportAsync($where: KeyReportWhereInput!, $dateRange: DateRangeInput!) {
  keyActivitiesCompletedReportAsync(where: $where, dateRange: $dateRange) {
    id
    error
    result {
      curriculumActivitiesCompleted {
        productCurriculumCode
        activitiesCompletedCount
      }
      totalActivitiesCompletedCount
    }
  }
}
    `;
export type KeyActivitiesCompletedReportAsyncQueryResult = Apollo.QueryResult<KeyActivitiesCompletedReportAsyncQuery, KeyActivitiesCompletedReportAsyncQueryVariables>;
export const GetAssessmentAndEnrichmentActivityReportDocument = gql`
    query getAssessmentAndEnrichmentActivityReport($where: KeyAssessmentAndEnrichmentActivityReportWhereInput!, $dateRange: DateRangeInput!) {
  keyAssessmentAndEnrichmentActivityReport(where: $where, dateRange: $dateRange) {
    spotChecks {
      totalCompletedCount
      studentCompletedCount
      averageWpm
      averageAccuracy
    }
    enrichmentActivities {
      hearItTypeIt {
        totalCompletedCount
        studentCompletedCount
      }
      myChoiceKeyboarding {
        totalCompletedCount
        studentCompletedCount
      }
    }
    teacherCreatedActivities {
      totalCompletedCount
      studentCompletedCount
      averageWpm
      averageAccuracy
    }
    assessmentAccelerator {
      modules {
        id
        name
      }
      totalSecondsSpent
      totalFirstAttemptCount
      assignmentStatus
    }
  }
}
    `;
export type GetAssessmentAndEnrichmentActivityReportQueryResult = Apollo.QueryResult<GetAssessmentAndEnrichmentActivityReportQuery, GetAssessmentAndEnrichmentActivityReportQueryVariables>;
export const GetAverageWeeklyTimeSpentReportAsyncDocument = gql`
    query getAverageWeeklyTimeSpentReportAsync($where: KeyReportWhereInput!, $dateRange: DateRangeInput!) {
  keyAverageWeeklyTimeSpentReportAsync(where: $where, dateRange: $dateRange) {
    id
    error
    result {
      curriculumAverageWeeklyTimeSpent {
        productCurriculumCode
        averageWeeklyMinutesSpent
      }
      averageWeeklyMinutesSpent
    }
  }
}
    `;
export type GetAverageWeeklyTimeSpentReportAsyncQueryResult = Apollo.QueryResult<GetAverageWeeklyTimeSpentReportAsyncQuery, GetAverageWeeklyTimeSpentReportAsyncQueryVariables>;
export const GetClassroomEngagementReportDocument = gql`
    query getClassroomEngagementReport($where: KeyClassroomEngagementReportWhereInput!, $dateRange: DateRangeInput!) {
  keyClassroomEngagementReport(where: $where, dateRange: $dateRange) {
    assessmentAccelerator {
      averageAttemptCount
      averageFirstAttemptCount
      averageSecondsSpent
      activityTypes {
        activityType {
          id
          name
        }
        modules {
          modules {
            name
            id
          }
          averageAttemptCount
          averageSecondsSpent
        }
      }
      modules {
        modules {
          name
          id
        }
        averageSecondsSpent
        averageAttemptCount
        averageFirstAttemptCount
        activityTypes {
          activityType {
            id
            name
          }
          averageSecondsSpent
          totalCompletedCount
          averageAttemptCount
          totalFirstAttemptCount
        }
      }
    }
    students {
      student {
        id
        firstName
        lastName
        gradeLevel
      }
      productCurriculumCode
      lastLoginDate
      curriculumWeek
      curriculumProgressPercentage
      totalActivitiesCompletedCount
      averageWeeklyMinutesSpent
      spotChecks {
        totalCompletedCount
        dateLastCompleted
        averageWpm
        averageAccuracy
      }
      scheduledActivities {
        assessmentCompletedCount
        assessmentSkippedCount
        assessmentAverageWpm
        assessmentAverageAccuracy
      }
      teacherCreatedActivities {
        totalCompletedCount
        averageWpm
        averageAccuracy
      }
      enrichmentActivities {
        hearItTypeItCompletedCount
        myChoiceKeyboardingCompletedCount
      }
      assessmentAccelerator {
        averageSecondsSpent
        totalCompletedCount
        averageAttemptCount
        totalFirstAttemptCount
        modules {
          modules {
            name
            id
          }
          averageSecondsSpent
          totalCompletedCount
          averageAttemptCount
          totalFirstAttemptCount
          assignmentStatus
        }
      }
    }
  }
}
    `;
export type GetClassroomEngagementReportQueryResult = Apollo.QueryResult<GetClassroomEngagementReportQuery, GetClassroomEngagementReportQueryVariables>;
export const GetCurriculumProgressReportAsyncDocument = gql`
    query getCurriculumProgressReportAsync($where: KeyReportWhereInput!) {
  keyCurriculumProgressReportAsync(where: $where) {
    id
    error
    result {
      curriculumProgressPercentage
    }
  }
}
    `;
export type GetCurriculumProgressReportAsyncQueryResult = Apollo.QueryResult<GetCurriculumProgressReportAsyncQuery, GetCurriculumProgressReportAsyncQueryVariables>;
export const GetCurriculumProgressReportDocument = gql`
    query getCurriculumProgressReport($where: KeyReportWhereInput!) {
  keyCurriculumProgressReport(where: $where) {
    curriculumProgressPercentage
  }
}
    `;
export type GetCurriculumProgressReportQueryResult = Apollo.QueryResult<GetCurriculumProgressReportQuery, GetCurriculumProgressReportQueryVariables>;
export const GetClassroomReportExportingDocument = gql`
    query getClassroomReportExporting($id: Int!, $dateRange: DateRangeInput!) {
  classroom: keyClassroomExportReport(
    where: {classroomId: $id}
    dateRange: $dateRange
  ) {
    ...BaseKeyboardingClassroomExportLegacy
    classroom {
      users {
        ...BaseClassroomUserEnrollment
      }
    }
  }
  students: keyClassroomEngagementReport(
    where: {classroomId: $id}
    dateRange: $dateRange
  ) {
    ...BaseKeyboardingStudentExportLegacy
  }
}
    ${BaseKeyboardingClassroomExportLegacyFragmentDoc}
${BaseClassroomUserEnrollmentFragmentDoc}
${BaseKeyboardingStudentExportLegacyFragmentDoc}`;
export type GetClassroomReportExportingQueryResult = Apollo.QueryResult<GetClassroomReportExportingQuery, GetClassroomReportExportingQueryVariables>;
export const GetOrganizationClassroomReportExportingDocument = gql`
    query getOrganizationClassroomReportExporting($id: Int!, $dateRange: DateRangeInput!) {
  organization: organization(where: {id: $id}) {
    id
    name
    type
    stats {
      classroomStudentCount
      userCount
      classroomCount
    }
    subOrganizations {
      type
    }
    licenseUsage(where: {productFamily: {code: "KEY"}}) {
      classroomAssignedCount
    }
  }
  activeStudents: keyActiveStudentsReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      activeStudentCount
      totalStudentCount
    }
  }
  activitiesCompleted: keyActivitiesCompletedReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      curriculumActivitiesCompleted {
        productCurriculumCode
        activitiesCompletedCount
      }
      totalActivitiesCompletedCount
    }
  }
  averageWeeklyTimeSpent: keyAverageWeeklyTimeSpentReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      curriculumAverageWeeklyTimeSpent {
        productCurriculumCode
        averageWeeklyMinutesSpent
      }
      averageWeeklyMinutesSpent
    }
  }
  curriculumProgress: keyCurriculumProgressReportAsync(
    where: {organizationId: $id}
  ) {
    id
    error
    result {
      curriculumProgressPercentage
    }
  }
  classrooms: keyOrganizationClassroomEngagementReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      ...BaseKeyboardingClassroomExport
      classroom {
        users {
          userId
          user {
            id
            username
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${BaseKeyboardingClassroomExportFragmentDoc}`;
export type GetOrganizationClassroomReportExportingQueryResult = Apollo.QueryResult<GetOrganizationClassroomReportExportingQuery, GetOrganizationClassroomReportExportingQueryVariables>;
export const GetOrganizationReportExportingDocument = gql`
    query getOrganizationReportExporting($id: Int!, $dateRange: DateRangeInput!) {
  organization: organization(where: {id: $id}) {
    id
    name
    type
    stats {
      classroomStudentCount
      userCount
      classroomCount
    }
    subOrganizations {
      type
    }
    licenseUsage(where: {productFamily: {code: "KEY"}}) {
      classroomAssignedCount
    }
  }
  activeStudents: keyActiveStudentsReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      activeStudentCount
      totalStudentCount
    }
  }
  activitiesCompleted: keyActivitiesCompletedReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      curriculumActivitiesCompleted {
        productCurriculumCode
        activitiesCompletedCount
      }
      totalActivitiesCompletedCount
    }
  }
  averageWeeklyTimeSpent: keyAverageWeeklyTimeSpentReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      curriculumAverageWeeklyTimeSpent {
        productCurriculumCode
        averageWeeklyMinutesSpent
      }
      averageWeeklyMinutesSpent
    }
  }
  curriculumProgress: keyCurriculumProgressReportAsync(
    where: {organizationId: $id}
  ) {
    id
    error
    result {
      curriculumProgressPercentage
    }
  }
  schools: keyOrganizationEngagementReportAsync(
    where: {organizationId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      organization {
        id
        name
        type
        stats {
          classroomStudentCount
          userCount
          classroomCount
        }
        subOrganizations {
          type
        }
        licenseUsage(where: {productFamily: {code: "KEY"}}) {
          classroomAssignedCount
        }
      }
      activeStudentCount
      totalStudentCount
      curriculumActivitiesCompleted {
        productCurriculumCode
        activitiesCompletedCount
      }
      totalActivitiesCompletedCount
      curriculumAverageWeeklyTimeSpent {
        productCurriculumCode
        averageWeeklyMinutesSpent
      }
      averageWeeklyMinutesSpent
      curriculumProgressPercentage
    }
  }
}
    `;
export type GetOrganizationReportExportingQueryResult = Apollo.QueryResult<GetOrganizationReportExportingQuery, GetOrganizationReportExportingQueryVariables>;
export const GetStudentReportExportingDocument = gql`
    query getStudentReportExporting($id: Int!, $dateRange: DateRangeInput!) {
  students: keyClassroomEngagementReport(
    where: {studentId: $id}
    dateRange: $dateRange
  ) {
    ...BaseKeyboardingStudentExportLegacy
  }
}
    ${BaseKeyboardingStudentExportLegacyFragmentDoc}`;
export type GetStudentReportExportingQueryResult = Apollo.QueryResult<GetStudentReportExportingQuery, GetStudentReportExportingQueryVariables>;
export const GetUserReportExportingDocument = gql`
    query getUserReportExporting($id: Int!, $dateRange: DateRangeInput!) {
  user(where: {id: $id}) {
    id
    firstName
    lastName
    sisId
  }
  classrooms: keyOrganizationClassroomEngagementReportAsync(
    where: {userId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      ...BaseKeyboardingClassroomExport
    }
  }
  students: keyClassroomEngagementReportAsync(
    where: {userId: $id}
    dateRange: $dateRange
  ) {
    id
    error
    result {
      ...BaseKeyboardingStudentExport
    }
  }
}
    ${BaseKeyboardingClassroomExportFragmentDoc}
${BaseKeyboardingStudentExportFragmentDoc}`;
export type GetUserReportExportingQueryResult = Apollo.QueryResult<GetUserReportExportingQuery, GetUserReportExportingQueryVariables>;
export const GetOrganizationClassroomEngagementReportAsyncDocument = gql`
    query getOrganizationClassroomEngagementReportAsync($where: KeyOrganizationClassroomEngagementReportWhereInput!, $dateRange: DateRangeInput!) {
  keyOrganizationClassroomEngagementReportAsync(
    where: $where
    dateRange: $dateRange
  ) {
    id
    error
    result {
      classroom {
        id
        name
        organizationId
        users {
          userId
          user {
            id
            username
            firstName
            lastName
          }
        }
      }
      activeStudentCount
      totalStudentCount
      totalActivitiesCompletedCount
      averageWeeklyMinutesSpent
      curriculumProgressPercentage
    }
  }
}
    `;
export type GetOrganizationClassroomEngagementReportAsyncQueryResult = Apollo.QueryResult<GetOrganizationClassroomEngagementReportAsyncQuery, GetOrganizationClassroomEngagementReportAsyncQueryVariables>;
export const GetOrganizationClassroomEngagementReportDocument = gql`
    query getOrganizationClassroomEngagementReport($where: KeyOrganizationClassroomEngagementReportWhereInput!, $dateRange: DateRangeInput!) {
  keyOrganizationClassroomEngagementReport(where: $where, dateRange: $dateRange) {
    classroom {
      id
      name
      organizationId
      users {
        ...BaseClassroomUserEnrollment
      }
    }
    activeStudentCount
    totalStudentCount
    totalActivitiesCompletedCount
    averageWeeklyMinutesSpent
    curriculumProgressPercentage
  }
}
    ${BaseClassroomUserEnrollmentFragmentDoc}`;
export type GetOrganizationClassroomEngagementReportQueryResult = Apollo.QueryResult<GetOrganizationClassroomEngagementReportQuery, GetOrganizationClassroomEngagementReportQueryVariables>;
export const GetStudentEngagementReportDocument = gql`
    query getStudentEngagementReport($where: KeyStudentEngagementReportWhereInput!, $dateRange: DateRangeInput!) {
  keyStudentEngagementReport(where: $where, dateRange: $dateRange) {
    spotChecks {
      template
      dateCompleted
      wpm
      accuracy
    }
    assessments {
      dateCompleted
      aborted
      averageWpm
      averageAccuracy
      activities {
        template
        aborted
        wpm
        accuracy
      }
    }
    enrichmentActivities {
      template
      dateCompleted
      aborted
      retryCount
      wpm
      accuracy
    }
    assessmentAccelerator {
      averageAttemptCount
      totalFirstAttemptCount
      totalSecondsSpent
      activityTypes {
        activityType {
          id
          name
        }
        modules {
          modules {
            name
            id
          }
          averageAttemptCount
          averageSecondsSpent
          averageAttemptCount
        }
      }
      modules {
        totalFirstAttemptCount
        totalSecondsSpent
        averageAttemptCount
        averageSecondsSpent
        dateCompleted
        modules {
          name
          id
        }
        attempts {
          dateCompleted
          activities {
            activity {
              id
              name
              title
              description
            }
            attemptCount
            responseData
            secondsSpent
          }
        }
      }
    }
    student {
      firstName
      lastName
      gradeLevel
      classrooms {
        name
      }
    }
  }
}
    `;
export type GetStudentEngagementReportQueryResult = Apollo.QueryResult<GetStudentEngagementReportQuery, GetStudentEngagementReportQueryVariables>;
export const GetStudentProgressReportDocument = gql`
    query getStudentProgressReport($where: KeyStudentProgressReportWhereInput!, $settingsWhere: PliStudentSettingsWhereInput!, $dateRange: DateRangeInput!) {
  keyStudentSettings(where: $settingsWhere) {
    oneHandedTypingHand
  }
  keyStudentProgressReport(where: $where, dateRange: $dateRange) {
    student {
      id
      gradeLevel
    }
    productCurriculumCode
    dateLastLogin
    curriculumProgress {
      activeDayCount
      activityCompletedCount
      activityTotalCount
      curriculumProgressPercentage
      curriculumWeek
      curriculumWeekTotal
      spotCheckCompletedCount
      spotCheckTotalCount
    }
    skipJumpInEnabled
    stopAndReviewEnabled
    stopAndReviewWeek
  }
}
    `;
export type GetStudentProgressReportQueryResult = Apollo.QueryResult<GetStudentProgressReportQuery, GetStudentProgressReportQueryVariables>;
export const WdtActiveStudentsReportDocument = gql`
    query wdtActiveStudentsReport($where: WdtActiveStudentsReportWhereInput!, $dateRange: DateRangeInput!) {
  wdtActiveStudentsReport(where: $where, dateRange: $dateRange) {
    activeStudentCount
    totalStudentCount
  }
}
    `;
export type WdtActiveStudentsReportQueryResult = Apollo.QueryResult<WdtActiveStudentsReportQuery, WdtActiveStudentsReportQueryVariables>;
export const WdtCharactersCompletedAndTimeSpentReportDocument = gql`
    query wdtCharactersCompletedAndTimeSpentReport($where: WdtCharactersCompletedAndTimeSpentReportWhereInput!, $dateRange: DateRangeInput!) {
  wdtCharactersCompletedAndTimeSpentReport(where: $where, dateRange: $dateRange) {
    intervalUnit
    intervals {
      interval
      averageMinutesSpent
      charactersCompletedCount
    }
    totalCharactersCompletedCount
    averageMinutesSpent
  }
}
    `;
export type WdtCharactersCompletedAndTimeSpentReportQueryResult = Apollo.QueryResult<WdtCharactersCompletedAndTimeSpentReportQuery, WdtCharactersCompletedAndTimeSpentReportQueryVariables>;
export const WdtClassroomErrorsByCharactersReportDocument = gql`
    query wdtClassroomErrorsByCharactersReport($where: WdtClassroomErrorsByCharactersReportWhereInput!, $dateRange: DateRangeInput) {
  wdtClassroomErrorsByCharactersReport(where: $where, dateRange: $dateRange) {
    classroomId
    characterOrder
    characterGroups {
      id
      name
    }
    characterErrors {
      character {
        id
        characterGroupIds
        character
      }
      errors {
        type
        count
      }
    }
  }
}
    `;
export type WdtClassroomErrorsByCharactersReportQueryResult = Apollo.QueryResult<WdtClassroomErrorsByCharactersReportQuery, WdtClassroomErrorsByCharactersReportQueryVariables>;
export const WdtClassroomErrorsByStudentsReportDocument = gql`
    query wdtClassroomErrorsByStudentsReport($where: WdtClassroomErrorsByStudentsReportWhereInput!, $dateRange: DateRangeInput) {
  wdtClassroomErrorsByStudentsReport(where: $where, dateRange: $dateRange) {
    classroomId
    studentErrors {
      student {
        id
        firstName
        lastName
        gradeLevel
        __typename
      }
      errors {
        type
        count
      }
    }
  }
}
    `;
export type WdtClassroomErrorsByStudentsReportQueryResult = Apollo.QueryResult<WdtClassroomErrorsByStudentsReportQuery, WdtClassroomErrorsByStudentsReportQueryVariables>;
export const WdtClassroomOverallProgressReportDocument = gql`
    query wdtClassroomOverallProgressReport($where: WdtClassroomOverallProgressReportWhereInput!) {
  wdtClassroomOverallProgressReport(where: $where) {
    totalStudentCount
    progress {
      module
      level
      charactersCompletedCount
    }
  }
}
    `;
export type WdtClassroomOverallProgressReportQueryResult = Apollo.QueryResult<WdtClassroomOverallProgressReportQuery, WdtClassroomOverallProgressReportQueryVariables>;
export const WdtClassroomProgressByCharactersReportDocument = gql`
    query wdtClassroomProgressByCharactersReport($where: WdtClassroomProgressByCharactersReportWhereInput!, $dateRange: DateRangeInput) {
  wdtClassroomProgressByCharactersReport(where: $where, dateRange: $dateRange) {
    classroomId
    characterOrder
    characterGroups {
      id
      name
    }
    characterProgress {
      character {
        id
        characterGroupIds
        character
      }
      characterLevelsProgress {
        level
        studentCompletedCount
      }
    }
  }
}
    `;
export type WdtClassroomProgressByCharactersReportQueryResult = Apollo.QueryResult<WdtClassroomProgressByCharactersReportQuery, WdtClassroomProgressByCharactersReportQueryVariables>;
export const WdtClassroomProgressByStudentsReportDocument = gql`
    query wdtClassroomProgressByStudentsReport($where: WdtClassroomProgressByStudentsReportWhereInput!, $dateRange: DateRangeInput) {
  wdtClassroomProgressByStudentsReport(where: $where, dateRange: $dateRange) {
    studentProgress {
      student {
        id
        firstName
        lastName
        gradeLevel
        __typename
      }
      level
      charactersCompletedCount
    }
  }
}
    `;
export type WdtClassroomProgressByStudentsReportQueryResult = Apollo.QueryResult<WdtClassroomProgressByStudentsReportQuery, WdtClassroomProgressByStudentsReportQueryVariables>;
export const WdtOverallErrorsReportDocument = gql`
    query wdtOverallErrorsReport($where: WdtOverallErrorsReportWhereInput!, $dateRange: DateRangeInput) {
  wdtOverallErrorsReport(where: $where, dateRange: $dateRange) {
    errors {
      type
      count
    }
  }
}
    `;
export type WdtOverallErrorsReportQueryResult = Apollo.QueryResult<WdtOverallErrorsReportQuery, WdtOverallErrorsReportQueryVariables>;
export const WdtStudentErrorsReportDocument = gql`
    query wdtStudentErrorsReport($where: WdtStudentErrorsReportWhereInput!, $dateRange: DateRangeInput) {
  wdtStudentErrorsReport(where: $where, dateRange: $dateRange) {
    studentId
    characterOrder
    characterGroups {
      id
      name
    }
    characterErrors {
      character {
        id
        characterGroupIds
        character
      }
      errors {
        type
        count
      }
    }
  }
}
    `;
export type WdtStudentErrorsReportQueryResult = Apollo.QueryResult<WdtStudentErrorsReportQuery, WdtStudentErrorsReportQueryVariables>;
export const WdtOverallStudentProgressReportDocument = gql`
    query wdtOverallStudentProgressReport($where: WdtStudentOverallProgressReportWhereInput!) {
  wdtStudentOverallProgressReport(where: $where) {
    progress {
      module
      level
      charactersCompletedCount
    }
  }
}
    `;
export type WdtOverallStudentProgressReportQueryResult = Apollo.QueryResult<WdtOverallStudentProgressReportQuery, WdtOverallStudentProgressReportQueryVariables>;
export const WdtStudentProgressReportDocument = gql`
    query wdtStudentProgressReport($where: WdtStudentProgressReportWhereInput!, $dateRange: DateRangeInput) {
  wdtStudentProgressReport(where: $where, dateRange: $dateRange) {
    studentId
    characterOrder
    characterGroups {
      id
      name
    }
    characterProgress {
      character {
        id
        characterGroupIds
        character
      }
      level
    }
  }
}
    `;
export type WdtStudentProgressReportQueryResult = Apollo.QueryResult<WdtStudentProgressReportQuery, WdtStudentProgressReportQueryVariables>;
export const WdtStudentSettingsReportDocument = gql`
    query wdtStudentSettingsReport($studentId: Int!) {
  wdtStudentSettings(where: {studentId: $studentId}) {
    ...BaseWdtStudentSettings
  }
  student(where: {id: $studentId}) {
    classrooms {
      id
    }
  }
}
    ${BaseWdtStudentSettingsFragmentDoc}`;
export type WdtStudentSettingsReportQueryResult = Apollo.QueryResult<WdtStudentSettingsReportQuery, WdtStudentSettingsReportQueryVariables>;
export const GetResourceTypesDocument = gql`
    query getResourceTypes($where: ResourceTypesWhereInput) {
  resourceTypes(where: $where) {
    ...BaseResourceType
    ...BaseResourceTypeAssets
  }
}
    ${BaseResourceTypeFragmentDoc}
${BaseResourceTypeAssetsFragmentDoc}`;
export type GetResourceTypesQueryResult = Apollo.QueryResult<GetResourceTypesQuery, GetResourceTypesQueryVariables>;
export const KeyboardingCurriculumsDocument = gql`
    query KeyboardingCurriculums($where: KeyboardingCurriculumsWhereInput) {
  keyboardingCurriculums(where: $where) {
    id
    name
    curriculumActivities {
      ...BaseKeyboadingCurriculumActivity
    }
  }
}
    ${BaseKeyboadingCurriculumActivityFragmentDoc}`;
export type KeyboardingCurriculumsQueryResult = Apollo.QueryResult<KeyboardingCurriculumsQuery, KeyboardingCurriculumsQueryVariables>;
export const KeyboardingModulesDocument = gql`
    query keyboardingModules($where: KeyboardingModulesWhereInput!) {
  keyboardingModules(where: $where) {
    id
    name
    description
    productCurriculumId
    productCurriculum {
      id
      name
      code
    }
    thumbnailId
    thumbnail {
      id
      src
    }
    submodules {
      id
      name
      description
      productCurriculumId
      productCurriculum {
        id
        name
        code
      }
      thumbnailId
      thumbnail {
        id
        src
      }
      activities {
        id
        name
        title
        description
        category
        url
      }
    }
  }
}
    `;
export type KeyboardingModulesQueryResult = Apollo.QueryResult<KeyboardingModulesQuery, KeyboardingModulesQueryVariables>;
export const GetResourcesWithAssetsDocument = gql`
    query getResourcesWithAssets($where: ResourcesWhereInput) {
  resources(where: $where) {
    ...BaseResource
    ...BaseResourceAssets
  }
}
    ${BaseResourceFragmentDoc}
${BaseResourceAssetsFragmentDoc}`;
export type GetResourcesWithAssetsQueryResult = Apollo.QueryResult<GetResourcesWithAssetsQuery, GetResourcesWithAssetsQueryVariables>;
export const AzsappClassroomSettingsDocument = gql`
    query azsappClassroomSettings($where: PliClassroomSettingsWhereInput!) {
  azsappClassroomSettings(where: $where) {
    ...BaseAzsappClassroomSettings
  }
}
    ${BaseAzsappClassroomSettingsFragmentDoc}`;
export type AzsappClassroomSettingsQueryResult = Apollo.QueryResult<AzsappClassroomSettingsQuery, AzsappClassroomSettingsQueryVariables>;
export const UpdateAzsappClassroomSettingExposeLetterBooksDocument = gql`
    mutation updateAzsappClassroomSettingExposeLetterBooks($data: [UpdateAzsappClassroomSettingExposeLetterBooksInput!]!) {
  updateAzsappClassroomSettingExposeLetterBooks(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateAzsappClassroomSettingExposeLetterBooksMutationResult = Apollo.MutationResult<UpdateAzsappClassroomSettingExposeLetterBooksMutation>;
export type UpdateAzsappClassroomSettingExposeLetterBooksMutationOptions = Apollo.BaseMutationOptions<UpdateAzsappClassroomSettingExposeLetterBooksMutation, UpdateAzsappClassroomSettingExposeLetterBooksMutationVariables>;
export const RemoveStudentSettingMutationDocument = gql`
    mutation removeStudentSettingMutation($where: StudentSettingWhereInput!) {
  removeStudentSetting(where: $where)
}
    `;
export type RemoveStudentSettingMutationMutationResult = Apollo.MutationResult<RemoveStudentSettingMutationMutation>;
export type RemoveStudentSettingMutationMutationOptions = Apollo.BaseMutationOptions<RemoveStudentSettingMutationMutation, RemoveStudentSettingMutationMutationVariables>;
export const RemoveStudentSettingsMutationDocument = gql`
    mutation removeStudentSettingsMutation($where: StudentSettingsWhereInput!) {
  removeStudentSettings(where: $where) {
    count
  }
}
    `;
export type RemoveStudentSettingsMutationMutationResult = Apollo.MutationResult<RemoveStudentSettingsMutationMutation>;
export type RemoveStudentSettingsMutationMutationOptions = Apollo.BaseMutationOptions<RemoveStudentSettingsMutationMutation, RemoveStudentSettingsMutationMutationVariables>;
export const GssClassroomSettingsDocument = gql`
    query gssClassroomSettings($where: PliClassroomSettingsWhereInput!) {
  gssClassroomSettings(where: $where) {
    ...BaseGssClassroomSettings
  }
}
    ${BaseGssClassroomSettingsFragmentDoc}`;
export type GssClassroomSettingsQueryResult = Apollo.QueryResult<GssClassroomSettingsQuery, GssClassroomSettingsQueryVariables>;
export const GssStudentSettingsDocument = gql`
    query gssStudentSettings($where: PliStudentSettingsWhereInput!) {
  gssStudentSettings(where: $where) {
    ...BaseGssStudentSettings
  }
}
    ${BaseGssStudentSettingsFragmentDoc}`;
export type GssStudentSettingsQueryResult = Apollo.QueryResult<GssStudentSettingsQuery, GssStudentSettingsQueryVariables>;
export const UpdateGssClassroomSettingCharacterOrderDocument = gql`
    mutation updateGssClassroomSettingCharacterOrder($data: [UpdateGssClassroomSettingCharacterOrderInput!]!) {
  updateGssClassroomSettingCharacterOrder(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateGssClassroomSettingCharacterOrderMutationResult = Apollo.MutationResult<UpdateGssClassroomSettingCharacterOrderMutation>;
export type UpdateGssClassroomSettingCharacterOrderMutationOptions = Apollo.BaseMutationOptions<UpdateGssClassroomSettingCharacterOrderMutation, UpdateGssClassroomSettingCharacterOrderMutationVariables>;
export const UpdateGssClassroomSettingLanguageDocument = gql`
    mutation updateGssClassroomSettingLanguage($data: [UpdateGssClassroomSettingLocaleInput!]!) {
  updateGssClassroomSettingLanguage(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateGssClassroomSettingLanguageMutationResult = Apollo.MutationResult<UpdateGssClassroomSettingLanguageMutation>;
export type UpdateGssClassroomSettingLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateGssClassroomSettingLanguageMutation, UpdateGssClassroomSettingLanguageMutationVariables>;
export const UpdateGssStudentSettingCharacterOrderDocument = gql`
    mutation updateGssStudentSettingCharacterOrder($data: [UpdateGssStudentSettingCharacterOrderInput!]!) {
  updateGssStudentSettingCharacterOrder(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateGssStudentSettingCharacterOrderMutationResult = Apollo.MutationResult<UpdateGssStudentSettingCharacterOrderMutation>;
export type UpdateGssStudentSettingCharacterOrderMutationOptions = Apollo.BaseMutationOptions<UpdateGssStudentSettingCharacterOrderMutation, UpdateGssStudentSettingCharacterOrderMutationVariables>;
export const UpdateGssStudentSettingLanguageDocument = gql`
    mutation updateGssStudentSettingLanguage($data: [UpdateGssStudentSettingLocaleInput!]!) {
  updateGssStudentSettingLanguage(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateGssStudentSettingLanguageMutationResult = Apollo.MutationResult<UpdateGssStudentSettingLanguageMutation>;
export type UpdateGssStudentSettingLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateGssStudentSettingLanguageMutation, UpdateGssStudentSettingLanguageMutationVariables>;
export const UpdateGssStudentSettingLeftHandednessDocument = gql`
    mutation updateGssStudentSettingLeftHandedness($data: [UpdateGssStudentSettingLeftHandednessInput!]!) {
  updateGssStudentSettingLeftHandedness(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateGssStudentSettingLeftHandednessMutationResult = Apollo.MutationResult<UpdateGssStudentSettingLeftHandednessMutation>;
export type UpdateGssStudentSettingLeftHandednessMutationOptions = Apollo.BaseMutationOptions<UpdateGssStudentSettingLeftHandednessMutation, UpdateGssStudentSettingLeftHandednessMutationVariables>;
export const HwtClassroomSettingsDocument = gql`
    query hwtClassroomSettings($where: PliClassroomSettingsWhereInput!) {
  hwtClassroomSettings(where: $where) {
    locale
  }
}
    `;
export type HwtClassroomSettingsQueryResult = Apollo.QueryResult<HwtClassroomSettingsQuery, HwtClassroomSettingsQueryVariables>;
export const HwtStudentSettingsDocument = gql`
    query hwtStudentSettings($where: PliStudentSettingsWhereInput!) {
  hwtStudentSettings(where: $where) {
    ...BaseHwtStudentSettings
  }
}
    ${BaseHwtStudentSettingsFragmentDoc}`;
export type HwtStudentSettingsQueryResult = Apollo.QueryResult<HwtStudentSettingsQuery, HwtStudentSettingsQueryVariables>;
export const UpdateHwtClassroomSettingLanguageDocument = gql`
    mutation updateHwtClassroomSettingLanguage($data: [UpdateHwtClassroomSettingLocaleInput!]!) {
  updateHwtClassroomSettingLanguage(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateHwtClassroomSettingLanguageMutationResult = Apollo.MutationResult<UpdateHwtClassroomSettingLanguageMutation>;
export type UpdateHwtClassroomSettingLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateHwtClassroomSettingLanguageMutation, UpdateHwtClassroomSettingLanguageMutationVariables>;
export const UpdateHwtStudentSettingLanguageDocument = gql`
    mutation updateHwtStudentSettingLanguage($data: [UpdateHwtStudentSettingLocaleInput!]!) {
  updateHwtStudentSettingLanguage(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateHwtStudentSettingLanguageMutationResult = Apollo.MutationResult<UpdateHwtStudentSettingLanguageMutation>;
export type UpdateHwtStudentSettingLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateHwtStudentSettingLanguageMutation, UpdateHwtStudentSettingLanguageMutationVariables>;
export const CreateKeyTeacherCreatedActivityPreviewDocument = gql`
    mutation createKeyTeacherCreatedActivityPreview($data: KeyTeacherCreatedActivityPreviewInput!) {
  createKeyTeacherCreatedActivityPreview(data: $data) {
    id
    url
  }
}
    `;
export type CreateKeyTeacherCreatedActivityPreviewMutationResult = Apollo.MutationResult<CreateKeyTeacherCreatedActivityPreviewMutation>;
export type CreateKeyTeacherCreatedActivityPreviewMutationOptions = Apollo.BaseMutationOptions<CreateKeyTeacherCreatedActivityPreviewMutation, CreateKeyTeacherCreatedActivityPreviewMutationVariables>;
export const KeyClassroomSettingsDocument = gql`
    query keyClassroomSettings($where: PliClassroomSettingsWhereInput!) {
  keyClassroomSettings(where: $where) {
    ...BaseKeyboardingClassroomSettings
  }
}
    ${BaseKeyboardingClassroomSettingsFragmentDoc}`;
export type KeyClassroomSettingsQueryResult = Apollo.QueryResult<KeyClassroomSettingsQuery, KeyClassroomSettingsQueryVariables>;
export const KeyStudentSettingsDocument = gql`
    query keyStudentSettings($where: PliStudentSettingsWhereInput!) {
  keyStudentSettings(where: $where) {
    ...BaseKeyboardingStudentSettings
  }
}
    ${BaseKeyboardingStudentSettingsFragmentDoc}`;
export type KeyStudentSettingsQueryResult = Apollo.QueryResult<KeyStudentSettingsQuery, KeyStudentSettingsQueryVariables>;
export const UpdateKeyClassroomSettingAssessmentsDocument = gql`
    mutation updateKeyClassroomSettingAssessments($data: UpdateKeyClassroomSettingScheduledActivityInput!) {
  updateKeyClassroomSettingAssessments(data: $data) {
    ...BaseKeyScheduledActivitySettings
  }
}
    ${BaseKeyScheduledActivitySettingsFragmentDoc}`;
export type UpdateKeyClassroomSettingAssessmentsMutationResult = Apollo.MutationResult<UpdateKeyClassroomSettingAssessmentsMutation>;
export type UpdateKeyClassroomSettingAssessmentsMutationOptions = Apollo.BaseMutationOptions<UpdateKeyClassroomSettingAssessmentsMutation, UpdateKeyClassroomSettingAssessmentsMutationVariables>;
export const UpdateKeyClassroomSettingEnrichmentActivitiesDocument = gql`
    mutation updateKeyClassroomSettingEnrichmentActivities($data: UpdateKeyClassroomSettingEnrichmentInput!) {
  updateKeyClassroomSettingEnrichmentActivities(data: $data) {
    ...BaseKeyEnrichmentActivitySettings
  }
}
    ${BaseKeyEnrichmentActivitySettingsFragmentDoc}`;
export type UpdateKeyClassroomSettingEnrichmentActivitiesMutationResult = Apollo.MutationResult<UpdateKeyClassroomSettingEnrichmentActivitiesMutation>;
export type UpdateKeyClassroomSettingEnrichmentActivitiesMutationOptions = Apollo.BaseMutationOptions<UpdateKeyClassroomSettingEnrichmentActivitiesMutation, UpdateKeyClassroomSettingEnrichmentActivitiesMutationVariables>;
export const UpdateKeyClassroomSettingHomeUseDocument = gql`
    mutation updateKeyClassroomSettingHomeUse($data: UpdateKeyClassroomSettingHomeUseInput!) {
  updateKeyClassroomSettingHomeUse(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateKeyClassroomSettingHomeUseMutationResult = Apollo.MutationResult<UpdateKeyClassroomSettingHomeUseMutation>;
export type UpdateKeyClassroomSettingHomeUseMutationOptions = Apollo.BaseMutationOptions<UpdateKeyClassroomSettingHomeUseMutation, UpdateKeyClassroomSettingHomeUseMutationVariables>;
export const UpdateKeyClassroomSettingSkipJumpInDocument = gql`
    mutation updateKeyClassroomSettingSkipJumpIn($data: [UpdateKeyClassroomSettingSkipJumpInInput!]!) {
  updateKeyClassroomSettingSkipJumpIn(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateKeyClassroomSettingSkipJumpInMutationResult = Apollo.MutationResult<UpdateKeyClassroomSettingSkipJumpInMutation>;
export type UpdateKeyClassroomSettingSkipJumpInMutationOptions = Apollo.BaseMutationOptions<UpdateKeyClassroomSettingSkipJumpInMutation, UpdateKeyClassroomSettingSkipJumpInMutationVariables>;
export const UpdateKeyClassroomSettingStopAndReviewDocument = gql`
    mutation updateKeyClassroomSettingStopAndReview($data: [UpdateKeyClassroomSettingStopAndReviewInput!]!) {
  updateKeyClassroomSettingStopAndReview(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateKeyClassroomSettingStopAndReviewMutationResult = Apollo.MutationResult<UpdateKeyClassroomSettingStopAndReviewMutation>;
export type UpdateKeyClassroomSettingStopAndReviewMutationOptions = Apollo.BaseMutationOptions<UpdateKeyClassroomSettingStopAndReviewMutation, UpdateKeyClassroomSettingStopAndReviewMutationVariables>;
export const UpdateKeyStudentSettingHomeUseDocument = gql`
    mutation updateKeyStudentSettingHomeUse($data: [UpdateKeyStudentSettingHomeUseInput!]!) {
  updateKeyStudentSettingHomeUse(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateKeyStudentSettingHomeUseMutationResult = Apollo.MutationResult<UpdateKeyStudentSettingHomeUseMutation>;
export type UpdateKeyStudentSettingHomeUseMutationOptions = Apollo.BaseMutationOptions<UpdateKeyStudentSettingHomeUseMutation, UpdateKeyStudentSettingHomeUseMutationVariables>;
export const UpdateKeyStudentSettingOneHandedTypingHandDocument = gql`
    mutation updateKeyStudentSettingOneHandedTypingHand($data: [UpdateKeyStudentSettingOneHandedTypingHandInput!]!) {
  updateKeyStudentSettingOneHandedTypingHand(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateKeyStudentSettingOneHandedTypingHandMutationResult = Apollo.MutationResult<UpdateKeyStudentSettingOneHandedTypingHandMutation>;
export type UpdateKeyStudentSettingOneHandedTypingHandMutationOptions = Apollo.BaseMutationOptions<UpdateKeyStudentSettingOneHandedTypingHandMutation, UpdateKeyStudentSettingOneHandedTypingHandMutationVariables>;
export const UpdateKeyStudentSettingSkipJumpInDocument = gql`
    mutation updateKeyStudentSettingSkipJumpIn($data: [UpdateKeyStudentSettingSkipJumpInInput!]!) {
  updateKeyStudentSettingSkipJumpIn(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateKeyStudentSettingSkipJumpInMutationResult = Apollo.MutationResult<UpdateKeyStudentSettingSkipJumpInMutation>;
export type UpdateKeyStudentSettingSkipJumpInMutationOptions = Apollo.BaseMutationOptions<UpdateKeyStudentSettingSkipJumpInMutation, UpdateKeyStudentSettingSkipJumpInMutationVariables>;
export const UpdateKeyStudentSettingStopAndReviewDocument = gql`
    mutation updateKeyStudentSettingStopAndReview($data: [UpdateKeyStudentSettingStopAndReviewInput!]!) {
  updateKeyStudentSettingStopAndReview(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateKeyStudentSettingStopAndReviewMutationResult = Apollo.MutationResult<UpdateKeyStudentSettingStopAndReviewMutation>;
export type UpdateKeyStudentSettingStopAndReviewMutationOptions = Apollo.BaseMutationOptions<UpdateKeyStudentSettingStopAndReviewMutation, UpdateKeyStudentSettingStopAndReviewMutationVariables>;
export const UpdatePliUserSettingDocument = gql`
    mutation UpdatePliUserSetting($data: PliUserSettingInput!) {
  updatePliUserSetting(data: $data) {
    ...BaseUserSetting
  }
}
    ${BaseUserSettingFragmentDoc}`;
export type UpdatePliUserSettingMutationResult = Apollo.MutationResult<UpdatePliUserSettingMutation>;
export type UpdatePliUserSettingMutationOptions = Apollo.BaseMutationOptions<UpdatePliUserSettingMutation, UpdatePliUserSettingMutationVariables>;
export const UpdateUserSettingPliOnboardingWelcomeDocument = gql`
    mutation updateUserSettingPliOnboardingWelcome($data: PliUserOnboardingWelcomeDataInput!) {
  updateUserSettingPliOnboardingWelcome(data: $data) {
    setting
    value
  }
}
    `;
export type UpdateUserSettingPliOnboardingWelcomeMutationResult = Apollo.MutationResult<UpdateUserSettingPliOnboardingWelcomeMutation>;
export type UpdateUserSettingPliOnboardingWelcomeMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingPliOnboardingWelcomeMutation, UpdateUserSettingPliOnboardingWelcomeMutationVariables>;
export const WdtClassroomSettingsDocument = gql`
    query wdtClassroomSettings($where: PliClassroomSettingsWhereInput!) {
  wdtClassroomSettings(where: $where) {
    ...BaseWdtClassroomSettings
  }
}
    ${BaseWdtClassroomSettingsFragmentDoc}`;
export type WdtClassroomSettingsQueryResult = Apollo.QueryResult<WdtClassroomSettingsQuery, WdtClassroomSettingsQueryVariables>;
export const WdtStudentSettingsDocument = gql`
    query wdtStudentSettings($where: PliStudentSettingsWhereInput!) {
  wdtStudentSettings(where: $where) {
    ...BaseWdtStudentSettings
  }
}
    ${BaseWdtStudentSettingsFragmentDoc}`;
export type WdtStudentSettingsQueryResult = Apollo.QueryResult<WdtStudentSettingsQuery, WdtStudentSettingsQueryVariables>;
export const UpdateWdtClassroomSettingCharacterOrderDocument = gql`
    mutation updateWdtClassroomSettingCharacterOrder($data: [UpdateWdtClassroomSettingCharacterOrderInput!]!) {
  updateWdtClassroomSettingCharacterOrder(data: $data) {
    ...UpdateClassroomSettingFragment
  }
}
    ${UpdateClassroomSettingFragmentFragmentDoc}`;
export type UpdateWdtClassroomSettingCharacterOrderMutationResult = Apollo.MutationResult<UpdateWdtClassroomSettingCharacterOrderMutation>;
export type UpdateWdtClassroomSettingCharacterOrderMutationOptions = Apollo.BaseMutationOptions<UpdateWdtClassroomSettingCharacterOrderMutation, UpdateWdtClassroomSettingCharacterOrderMutationVariables>;
export const UpdateWdtStudentSettingCharacterOrderDocument = gql`
    mutation updateWdtStudentSettingCharacterOrder($data: [UpdateWdtStudentSettingCharacterOrderInput!]!) {
  updateWdtStudentSettingCharacterOrder(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateWdtStudentSettingCharacterOrderMutationResult = Apollo.MutationResult<UpdateWdtStudentSettingCharacterOrderMutation>;
export type UpdateWdtStudentSettingCharacterOrderMutationOptions = Apollo.BaseMutationOptions<UpdateWdtStudentSettingCharacterOrderMutation, UpdateWdtStudentSettingCharacterOrderMutationVariables>;
export const UpdateWdtStudentSettingLeftHandednessDocument = gql`
    mutation updateWdtStudentSettingLeftHandedness($data: [UpdateWdtStudentSettingLeftHandednessInput!]!) {
  updateWdtStudentSettingLeftHandedness(data: $data) {
    ...UpdateStudentSettingFragment
  }
}
    ${UpdateStudentSettingFragmentFragmentDoc}`;
export type UpdateWdtStudentSettingLeftHandednessMutationResult = Apollo.MutationResult<UpdateWdtStudentSettingLeftHandednessMutation>;
export type UpdateWdtStudentSettingLeftHandednessMutationOptions = Apollo.BaseMutationOptions<UpdateWdtStudentSettingLeftHandednessMutation, UpdateWdtStudentSettingLeftHandednessMutationVariables>;
export const CreateStudentsDocument = gql`
    mutation createStudents($students: [StudentCreateInput!]!) {
  createStudents(data: $students) {
    ...BaseStudent
  }
}
    ${BaseStudentFragmentDoc}`;
export type CreateStudentsMutationResult = Apollo.MutationResult<CreateStudentsMutation>;
export type CreateStudentsMutationOptions = Apollo.BaseMutationOptions<CreateStudentsMutation, CreateStudentsMutationVariables>;
export const GetBaseStudentDocument = gql`
    query getBaseStudent($id: Int!) {
  entity: student(where: {id: $id}) {
    ...BaseStudent
  }
}
    ${BaseStudentFragmentDoc}`;
export type GetBaseStudentQueryResult = Apollo.QueryResult<GetBaseStudentQuery, GetBaseStudentQueryVariables>;
export const GetStudentQueryDocument = gql`
    query getStudentQuery($where: StudentWhereInput!) {
  student(where: $where) {
    ...BaseStudent
    licenseUsage {
      ...BaseStudentLicenseUsage
    }
    groups {
      ...BaseGroups
    }
  }
}
    ${BaseStudentFragmentDoc}
${BaseStudentLicenseUsageFragmentDoc}
${BaseGroupsFragmentDoc}`;
export type GetStudentQueryQueryResult = Apollo.QueryResult<GetStudentQueryQuery, GetStudentQueryQueryVariables>;
export const GetStudentSettingsDocument = gql`
    query getStudentSettings($where: StudentSettingsWhereInput!) {
  studentSettings(where: $where) {
    ...BaseStudentSettings
  }
}
    ${BaseStudentSettingsFragmentDoc}`;
export type GetStudentSettingsQueryResult = Apollo.QueryResult<GetStudentSettingsQuery, GetStudentSettingsQueryVariables>;
export const GetStudentWithLicenseUsageQueryDocument = gql`
    query getStudentWithLicenseUsageQuery($where: StudentWhereInput!) {
  student(where: $where) {
    ...BaseStudent
    licenseUsage {
      ...BaseStudentLicenseUsage
    }
  }
}
    ${BaseStudentFragmentDoc}
${BaseStudentLicenseUsageFragmentDoc}`;
export type GetStudentWithLicenseUsageQueryQueryResult = Apollo.QueryResult<GetStudentWithLicenseUsageQueryQuery, GetStudentWithLicenseUsageQueryQueryVariables>;
export const RemoveStudentMutationDocument = gql`
    mutation removeStudentMutation($where: StudentWhereInput!) {
  removeStudent(where: $where) {
    ...BaseStudent
  }
}
    ${BaseStudentFragmentDoc}`;
export type RemoveStudentMutationMutationResult = Apollo.MutationResult<RemoveStudentMutationMutation>;
export type RemoveStudentMutationMutationOptions = Apollo.BaseMutationOptions<RemoveStudentMutationMutation, RemoveStudentMutationMutationVariables>;
export const RemoveStudentsMutationDocument = gql`
    mutation removeStudentsMutation($where: StudentsWhereInput!) {
  removeStudents(where: $where) {
    count
  }
}
    `;
export type RemoveStudentsMutationMutationResult = Apollo.MutationResult<RemoveStudentsMutationMutation>;
export type RemoveStudentsMutationMutationOptions = Apollo.BaseMutationOptions<RemoveStudentsMutationMutation, RemoveStudentsMutationMutationVariables>;
export const SearchStudentsDocument = gql`
    query searchStudents($searchText: String!, $classroomIds: [Int!], $organizationIds: [Int!], $limit: Int) {
  studentSearch(
    searchText: $searchText
    classroomId: $classroomIds
    organizationId: $organizationIds
    orderBy: {field: [LAST_NAME, FIRST_NAME, ID], direction: [ASC, ASC, DESC]}
    paging: {limit: $limit}
  ) {
    ...BaseStudent
  }
}
    ${BaseStudentFragmentDoc}`;
export type SearchStudentsQueryResult = Apollo.QueryResult<SearchStudentsQuery, SearchStudentsQueryVariables>;
export const TransferStudentDocument = gql`
    mutation transferStudent($where: TransferStudentWhereInput!, $data: TransferStudentInput!) {
  transferStudent(where: $where, data: $data) {
    id
  }
}
    `;
export type TransferStudentMutationResult = Apollo.MutationResult<TransferStudentMutation>;
export type TransferStudentMutationOptions = Apollo.BaseMutationOptions<TransferStudentMutation, TransferStudentMutationVariables>;
export const UpdateStudentMutationDocument = gql`
    mutation updateStudentMutation($where: StudentWhereInput!, $data: StudentUpdateInput!) {
  updateStudent(data: $data, where: $where) {
    ...BaseStudent
    groups {
      ...BaseGroups
    }
  }
}
    ${BaseStudentFragmentDoc}
${BaseGroupsFragmentDoc}`;
export type UpdateStudentMutationMutationResult = Apollo.MutationResult<UpdateStudentMutationMutation>;
export type UpdateStudentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateStudentMutationMutation, UpdateStudentMutationMutationVariables>;
export const GetAllSupportCategoriesDocument = gql`
    query getAllSupportCategories {
  supportCategories {
    ...BaseSupportCategory
  }
}
    ${BaseSupportCategoryFragmentDoc}`;
export type GetAllSupportCategoriesQueryResult = Apollo.QueryResult<GetAllSupportCategoriesQuery, GetAllSupportCategoriesQueryVariables>;
export const SendSupportTicketMutationDocument = gql`
    mutation sendSupportTicketMutation($data: SendSupportTicketInput!) {
  sendSupportTicket(data: $data)
}
    `;
export type SendSupportTicketMutationMutationResult = Apollo.MutationResult<SendSupportTicketMutationMutation>;
export type SendSupportTicketMutationMutationOptions = Apollo.BaseMutationOptions<SendSupportTicketMutationMutation, SendSupportTicketMutationMutationVariables>;
export const GetSupportCategoryDocument = gql`
    query getSupportCategory($where: SupportCategoryWhereInput!) {
  supportCategory(where: $where) {
    ...BaseSupportCategory
    supportTopics {
      ...BaseSupportTopic
      tags {
        ...BaseTag
      }
    }
  }
}
    ${BaseSupportCategoryFragmentDoc}
${BaseSupportTopicFragmentDoc}
${BaseTagFragmentDoc}`;
export type GetSupportCategoryQueryResult = Apollo.QueryResult<GetSupportCategoryQuery, GetSupportCategoryQueryVariables>;
export const GetSupportTopicDocument = gql`
    query getSupportTopic($where: SupportTopicWhereInput!) {
  supportTopic(where: $where) {
    ...BaseSupportTopic
    content
    tags {
      ...BaseTag
    }
    supportCategories {
      ...BaseSupportCategory
    }
  }
}
    ${BaseSupportTopicFragmentDoc}
${BaseTagFragmentDoc}
${BaseSupportCategoryFragmentDoc}`;
export type GetSupportTopicQueryResult = Apollo.QueryResult<GetSupportTopicQuery, GetSupportTopicQueryVariables>;
export const GetSupportTopicsDocument = gql`
    query getSupportTopics($where: SupportTopicsWhereInput) {
  supportTopics(where: $where) {
    ...BaseSupportTopic
    supportCategories {
      ...BaseSupportCategory
    }
    tags {
      ...BaseTag
    }
  }
}
    ${BaseSupportTopicFragmentDoc}
${BaseSupportCategoryFragmentDoc}
${BaseTagFragmentDoc}`;
export type GetSupportTopicsQueryResult = Apollo.QueryResult<GetSupportTopicsQuery, GetSupportTopicsQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($data: UserCreateInput!, $upsert: Boolean = false) {
  createUser(data: $data, upsert: $upsert) {
    ...BaseUser
  }
}
    ${BaseUserFragmentDoc}`;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetAdminUserInformationDocument = gql`
    query getAdminUserInformation($where: UserWhereInput!) {
  user(where: $where) {
    ...BaseUser
    licenseUsage {
      assignedCount
      trial
      product {
        id
        code
        name
        iconUrl
      }
      productCurriculum {
        id
        code
        name
        iconUrl
      }
    }
    organizationAssociations {
      organizationId
      organization {
        id
        name
        licenseUsage {
          product {
            id
            code
            name
            iconUrl
            type
            family {
              id
              code
            }
          }
          productCurriculum {
            id
            code
            name
            iconUrl
          }
          availableCount
          assignedCount
          siteLicensed
        }
      }
      organizationRoles {
        ...BaseOrganizationRole
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseOrganizationRoleFragmentDoc}`;
export type GetAdminUserInformationQueryResult = Apollo.QueryResult<GetAdminUserInformationQuery, GetAdminUserInformationQueryVariables>;
export const GetUserManagementUsersDocument = gql`
    query getUserManagementUsers($where: UsersWhereInput) {
  organizations {
    id
    name
  }
  users(where: $where) {
    ...BaseUser
    licenseUsage {
      ...BaseUserLicenseUsage
    }
    organizationAssociations {
      organizationId
      organization {
        id
        name
      }
      organizationRoles {
        ...BaseOrganizationRole
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseUserLicenseUsageFragmentDoc}
${BaseOrganizationRoleFragmentDoc}`;
export type GetUserManagementUsersQueryResult = Apollo.QueryResult<GetUserManagementUsersQuery, GetUserManagementUsersQueryVariables>;
export const GetBaseUserDocument = gql`
    query getBaseUser($id: Int!) {
  entity: user(where: {id: $id}) {
    ...BaseUser
  }
}
    ${BaseUserFragmentDoc}`;
export type GetBaseUserQueryResult = Apollo.QueryResult<GetBaseUserQuery, GetBaseUserQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    ...BaseUser
    classroomPrivileges {
      classroomId
      privileges
    }
    licenseUsage(where: {includeExpired: true}) {
      ...BaseUserLicenseUsage
    }
    trialUsage(where: {includeExpired: true}) {
      ...BaseUserTrialUsage
    }
    organizationAssociations {
      organizationId
      organization {
        id
        externalId {
          sourceKind
          sourceId
        }
        name
        parentOrganization {
          id
        }
        licenseUsage {
          totalCount
          product {
            family {
              code
            }
          }
        }
      }
      organizationRoles {
        ...BaseOrganizationRole
      }
    }
    organizationPrivileges {
      organizationId
      privileges
    }
    settings {
      ...BaseUserSetting
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseUserLicenseUsageFragmentDoc}
${BaseUserTrialUsageFragmentDoc}
${BaseOrganizationRoleFragmentDoc}
${BaseUserSettingFragmentDoc}`;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetMyOrganizationsDocument = gql`
    query getMyOrganizations {
  me {
    organizationAssociations {
      ...BaseOrganizationAssociationLicenseUsage
    }
  }
}
    ${BaseOrganizationAssociationLicenseUsageFragmentDoc}`;
export type GetMyOrganizationsQueryResult = Apollo.QueryResult<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>;
export const GetUserInformationDocument = gql`
    query getUserInformation($where: UserWhereInput!) {
  user(where: $where) {
    ...BaseUser
    licenseUsage {
      assignedCount
      product {
        id
        iconUrl
        name
      }
    }
    classroomEnrollments {
      classroom {
        ...BaseClassroom
        licenseUsage {
          assignedCount
          product {
            id
            iconUrl
          }
          productCurriculum {
            id
            iconUrl
          }
        }
        stats {
          ...BaseClassroomStats
        }
      }
    }
    organizationAssociations {
      organization {
        id
        name
      }
      organizationRoles {
        id
        name
        displayName
        public
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseClassroomFragmentDoc}
${BaseClassroomStatsFragmentDoc}`;
export type GetUserInformationQueryResult = Apollo.QueryResult<GetUserInformationQuery, GetUserInformationQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($searchText: String!, $classroomIds: [Int!], $organizationIds: [Int!], $limit: Int) {
  userSearch(
    searchText: $searchText
    classroomId: $classroomIds
    organizationId: $organizationIds
    where: {status: [ACTIVE, PENDING]}
    orderBy: {field: [LAST_NAME, FIRST_NAME, ID], direction: [ASC, ASC, DESC]}
    paging: {limit: $limit}
  ) {
    id
    username
    firstName
    lastName
    status
  }
}
    `;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const UpdateMyAvatarMutationDocument = gql`
    mutation updateMyAvatarMutation($data: UserUpdateInput!) {
  updateMe(data: $data) {
    ...BaseUserAvatar
  }
}
    ${BaseUserAvatarFragmentDoc}`;
export type UpdateMyAvatarMutationMutationResult = Apollo.MutationResult<UpdateMyAvatarMutationMutation>;
export type UpdateMyAvatarMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMyAvatarMutationMutation, UpdateMyAvatarMutationMutationVariables>;
export const UpdateMeMutationDocument = gql`
    mutation updateMeMutation($data: UserUpdateInput!) {
  updateMe(data: $data) {
    ...BaseUserProfileDetails
  }
}
    ${BaseUserProfileDetailsFragmentDoc}`;
export type UpdateMeMutationMutationResult = Apollo.MutationResult<UpdateMeMutationMutation>;
export type UpdateMeMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutationMutation, UpdateMeMutationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($where: UserWhereInput!, $data: UserUpdateInput!) {
  updateUser(data: $data, where: $where) {
    ...BaseUser
    licenseUsage {
      product {
        id
        name
        iconUrl
      }
    }
    organizationAssociations {
      organizationId
      ...BaseOrganizationAssociationLicenseUsage
      organizationRoles {
        ...BaseOrganizationRole
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${BaseOrganizationAssociationLicenseUsageFragmentDoc}
${BaseOrganizationRoleFragmentDoc}`;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;